/*! jQuery v1.7.2 jquery.com | jquery.org/license */
(function(a,b){function cy(a){return f.isWindow(a)?a:a.nodeType===9?a.defaultView||a.parentWindow:!1}function cu(a){if(!cj[a]){var b=c.body,d=f("<"+a+">").appendTo(b),e=d.css("display");d.remove();if(e==="none"||e===""){ck||(ck=c.createElement("iframe"),ck.frameBorder=ck.width=ck.height=0),b.appendChild(ck);if(!cl||!ck.createElement)cl=(ck.contentWindow||ck.contentDocument).document,cl.write((f.support.boxModel?"<!doctype html>":"")+"<html><body>"),cl.close();d=cl.createElement(a),cl.body.appendChild(d),e=f.css(d,"display"),b.removeChild(ck)}cj[a]=e}return cj[a]}function ct(a,b){var c={};f.each(cp.concat.apply([],cp.slice(0,b)),function(){c[this]=a});return c}function cs(){cq=b}function cr(){setTimeout(cs,0);return cq=f.now()}function ci(){try{return new a.ActiveXObject("Microsoft.XMLHTTP")}catch(b){}}function ch(){try{return new a.XMLHttpRequest}catch(b){}}function cb(a,c){a.dataFilter&&(c=a.dataFilter(c,a.dataType));var d=a.dataTypes,e={},g,h,i=d.length,j,k=d[0],l,m,n,o,p;for(g=1;g<i;g++){if(g===1)for(h in a.converters)typeof h=="string"&&(e[h.toLowerCase()]=a.converters[h]);l=k,k=d[g];if(k==="*")k=l;else if(l!=="*"&&l!==k){m=l+" "+k,n=e[m]||e["* "+k];if(!n){p=b;for(o in e){j=o.split(" ");if(j[0]===l||j[0]==="*"){p=e[j[1]+" "+k];if(p){o=e[o],o===!0?n=p:p===!0&&(n=o);break}}}}!n&&!p&&f.error("No conversion from "+m.replace(" "," to ")),n!==!0&&(c=n?n(c):p(o(c)))}}return c}function ca(a,c,d){var e=a.contents,f=a.dataTypes,g=a.responseFields,h,i,j,k;for(i in g)i in d&&(c[g[i]]=d[i]);while(f[0]==="*")f.shift(),h===b&&(h=a.mimeType||c.getResponseHeader("content-type"));if(h)for(i in e)if(e[i]&&e[i].test(h)){f.unshift(i);break}if(f[0]in d)j=f[0];else{for(i in d){if(!f[0]||a.converters[i+" "+f[0]]){j=i;break}k||(k=i)}j=j||k}if(j){j!==f[0]&&f.unshift(j);return d[j]}}function b_(a,b,c,d){if(f.isArray(b))f.each(b,function(b,e){c||bD.test(a)?d(a,e):b_(a+"["+(typeof e=="object"?b:"")+"]",e,c,d)});else if(!c&&f.type(b)==="object")for(var e in b)b_(a+"["+e+"]",b[e],c,d);else d(a,b)}function b$(a,c){var d,e,g=f.ajaxSettings.flatOptions||{};for(d in c)c[d]!==b&&((g[d]?a:e||(e={}))[d]=c[d]);e&&f.extend(!0,a,e)}function bZ(a,c,d,e,f,g){f=f||c.dataTypes[0],g=g||{},g[f]=!0;var h=a[f],i=0,j=h?h.length:0,k=a===bS,l;for(;i<j&&(k||!l);i++)l=h[i](c,d,e),typeof l=="string"&&(!k||g[l]?l=b:(c.dataTypes.unshift(l),l=bZ(a,c,d,e,l,g)));(k||!l)&&!g["*"]&&(l=bZ(a,c,d,e,"*",g));return l}function bY(a){return function(b,c){typeof b!="string"&&(c=b,b="*");if(f.isFunction(c)){var d=b.toLowerCase().split(bO),e=0,g=d.length,h,i,j;for(;e<g;e++)h=d[e],j=/^\+/.test(h),j&&(h=h.substr(1)||"*"),i=a[h]=a[h]||[],i[j?"unshift":"push"](c)}}}function bB(a,b,c){var d=b==="width"?a.offsetWidth:a.offsetHeight,e=b==="width"?1:0,g=4;if(d>0){if(c!=="border")for(;e<g;e+=2)c||(d-=parseFloat(f.css(a,"padding"+bx[e]))||0),c==="margin"?d+=parseFloat(f.css(a,c+bx[e]))||0:d-=parseFloat(f.css(a,"border"+bx[e]+"Width"))||0;return d+"px"}d=by(a,b);if(d<0||d==null)d=a.style[b];if(bt.test(d))return d;d=parseFloat(d)||0;if(c)for(;e<g;e+=2)d+=parseFloat(f.css(a,"padding"+bx[e]))||0,c!=="padding"&&(d+=parseFloat(f.css(a,"border"+bx[e]+"Width"))||0),c==="margin"&&(d+=parseFloat(f.css(a,c+bx[e]))||0);return d+"px"}function bo(a){var b=c.createElement("div");bh.appendChild(b),b.innerHTML=a.outerHTML;return b.firstChild}function bn(a){var b=(a.nodeName||"").toLowerCase();b==="input"?bm(a):b!=="script"&&typeof a.getElementsByTagName!="undefined"&&f.grep(a.getElementsByTagName("input"),bm)}function bm(a){if(a.type==="checkbox"||a.type==="radio")a.defaultChecked=a.checked}function bl(a){return typeof a.getElementsByTagName!="undefined"?a.getElementsByTagName("*"):typeof a.querySelectorAll!="undefined"?a.querySelectorAll("*"):[]}function bk(a,b){var c;b.nodeType===1&&(b.clearAttributes&&b.clearAttributes(),b.mergeAttributes&&b.mergeAttributes(a),c=b.nodeName.toLowerCase(),c==="object"?b.outerHTML=a.outerHTML:c!=="input"||a.type!=="checkbox"&&a.type!=="radio"?c==="option"?b.selected=a.defaultSelected:c==="input"||c==="textarea"?b.defaultValue=a.defaultValue:c==="script"&&b.text!==a.text&&(b.text=a.text):(a.checked&&(b.defaultChecked=b.checked=a.checked),b.value!==a.value&&(b.value=a.value)),b.removeAttribute(f.expando),b.removeAttribute("_submit_attached"),b.removeAttribute("_change_attached"))}function bj(a,b){if(b.nodeType===1&&!!f.hasData(a)){var c,d,e,g=f._data(a),h=f._data(b,g),i=g.events;if(i){delete h.handle,h.events={};for(c in i)for(d=0,e=i[c].length;d<e;d++)f.event.add(b,c,i[c][d])}h.data&&(h.data=f.extend({},h.data))}}function bi(a,b){return f.nodeName(a,"table")?a.getElementsByTagName("tbody")[0]||a.appendChild(a.ownerDocument.createElement("tbody")):a}function U(a){var b=V.split("|"),c=a.createDocumentFragment();if(c.createElement)while(b.length)c.createElement(b.pop());return c}function T(a,b,c){b=b||0;if(f.isFunction(b))return f.grep(a,function(a,d){var e=!!b.call(a,d,a);return e===c});if(b.nodeType)return f.grep(a,function(a,d){return a===b===c});if(typeof b=="string"){var d=f.grep(a,function(a){return a.nodeType===1});if(O.test(b))return f.filter(b,d,!c);b=f.filter(b,d)}return f.grep(a,function(a,d){return f.inArray(a,b)>=0===c})}function S(a){return!a||!a.parentNode||a.parentNode.nodeType===11}function K(){return!0}function J(){return!1}function n(a,b,c){var d=b+"defer",e=b+"queue",g=b+"mark",h=f._data(a,d);h&&(c==="queue"||!f._data(a,e))&&(c==="mark"||!f._data(a,g))&&setTimeout(function(){!f._data(a,e)&&!f._data(a,g)&&(f.removeData(a,d,!0),h.fire())},0)}function m(a){for(var b in a){if(b==="data"&&f.isEmptyObject(a[b]))continue;if(b!=="toJSON")return!1}return!0}function l(a,c,d){if(d===b&&a.nodeType===1){var e="data-"+c.replace(k,"-$1").toLowerCase();d=a.getAttribute(e);if(typeof d=="string"){try{d=d==="true"?!0:d==="false"?!1:d==="null"?null:f.isNumeric(d)?+d:j.test(d)?f.parseJSON(d):d}catch(g){}f.data(a,c,d)}else d=b}return d}function h(a){var b=g[a]={},c,d;a=a.split(/\s+/);for(c=0,d=a.length;c<d;c++)b[a[c]]=!0;return b}var c=a.document,d=a.navigator,e=a.location,f=function(){function J(){if(!e.isReady){try{c.documentElement.doScroll("left")}catch(a){setTimeout(J,1);return}e.ready()}}var e=function(a,b){return new e.fn.init(a,b,h)},f=a.jQuery,g=a.$,h,i=/^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/,j=/\S/,k=/^\s+/,l=/\s+$/,m=/^<(\w+)\s*\/?>(?:<\/\1>)?$/,n=/^[\],:{}\s]*$/,o=/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g,p=/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,q=/(?:^|:|,)(?:\s*\[)+/g,r=/(webkit)[ \/]([\w.]+)/,s=/(opera)(?:.*version)?[ \/]([\w.]+)/,t=/(msie) ([\w.]+)/,u=/(mozilla)(?:.*? rv:([\w.]+))?/,v=/-([a-z]|[0-9])/ig,w=/^-ms-/,x=function(a,b){return(b+"").toUpperCase()},y=d.userAgent,z,A,B,C=Object.prototype.toString,D=Object.prototype.hasOwnProperty,E=Array.prototype.push,F=Array.prototype.slice,G=String.prototype.trim,H=Array.prototype.indexOf,I={};e.fn=e.prototype={constructor:e,init:function(a,d,f){var g,h,j,k;if(!a)return this;if(a.nodeType){this.context=this[0]=a,this.length=1;return this}if(a==="body"&&!d&&c.body){this.context=c,this[0]=c.body,this.selector=a,this.length=1;return this}if(typeof a=="string"){a.charAt(0)!=="<"||a.charAt(a.length-1)!==">"||a.length<3?g=i.exec(a):g=[null,a,null];if(g&&(g[1]||!d)){if(g[1]){d=d instanceof e?d[0]:d,k=d?d.ownerDocument||d:c,j=m.exec(a),j?e.isPlainObject(d)?(a=[c.createElement(j[1])],e.fn.attr.call(a,d,!0)):a=[k.createElement(j[1])]:(j=e.buildFragment([g[1]],[k]),a=(j.cacheable?e.clone(j.fragment):j.fragment).childNodes);return e.merge(this,a)}h=c.getElementById(g[2]);if(h&&h.parentNode){if(h.id!==g[2])return f.find(a);this.length=1,this[0]=h}this.context=c,this.selector=a;return this}return!d||d.jquery?(d||f).find(a):this.constructor(d).find(a)}if(e.isFunction(a))return f.ready(a);a.selector!==b&&(this.selector=a.selector,this.context=a.context);return e.makeArray(a,this)},selector:"",jquery:"1.7.2",length:0,size:function(){return this.length},toArray:function(){return F.call(this,0)},get:function(a){return a==null?this.toArray():a<0?this[this.length+a]:this[a]},pushStack:function(a,b,c){var d=this.constructor();e.isArray(a)?E.apply(d,a):e.merge(d,a),d.prevObject=this,d.context=this.context,b==="find"?d.selector=this.selector+(this.selector?" ":"")+c:b&&(d.selector=this.selector+"."+b+"("+c+")");return d},each:function(a,b){return e.each(this,a,b)},ready:function(a){e.bindReady(),A.add(a);return this},eq:function(a){a=+a;return a===-1?this.slice(a):this.slice(a,a+1)},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},slice:function(){return this.pushStack(F.apply(this,arguments),"slice",F.call(arguments).join(","))},map:function(a){return this.pushStack(e.map(this,function(b,c){return a.call(b,c,b)}))},end:function(){return this.prevObject||this.constructor(null)},push:E,sort:[].sort,splice:[].splice},e.fn.init.prototype=e.fn,e.extend=e.fn.extend=function(){var a,c,d,f,g,h,i=arguments[0]||{},j=1,k=arguments.length,l=!1;typeof i=="boolean"&&(l=i,i=arguments[1]||{},j=2),typeof i!="object"&&!e.isFunction(i)&&(i={}),k===j&&(i=this,--j);for(;j<k;j++)if((a=arguments[j])!=null)for(c in a){d=i[c],f=a[c];if(i===f)continue;l&&f&&(e.isPlainObject(f)||(g=e.isArray(f)))?(g?(g=!1,h=d&&e.isArray(d)?d:[]):h=d&&e.isPlainObject(d)?d:{},i[c]=e.extend(l,h,f)):f!==b&&(i[c]=f)}return i},e.extend({noConflict:function(b){a.$===e&&(a.$=g),b&&a.jQuery===e&&(a.jQuery=f);return e},isReady:!1,readyWait:1,holdReady:function(a){a?e.readyWait++:e.ready(!0)},ready:function(a){if(a===!0&&!--e.readyWait||a!==!0&&!e.isReady){if(!c.body)return setTimeout(e.ready,1);e.isReady=!0;if(a!==!0&&--e.readyWait>0)return;A.fireWith(c,[e]),e.fn.trigger&&e(c).trigger("ready").off("ready")}},bindReady:function(){if(!A){A=e.Callbacks("once memory");if(c.readyState==="complete")return setTimeout(e.ready,1);if(c.addEventListener)c.addEventListener("DOMContentLoaded",B,!1),a.addEventListener("load",e.ready,!1);else if(c.attachEvent){c.attachEvent("onreadystatechange",B),a.attachEvent("onload",e.ready);var b=!1;try{b=a.frameElement==null}catch(d){}c.documentElement.doScroll&&b&&J()}}},isFunction:function(a){return e.type(a)==="function"},isArray:Array.isArray||function(a){return e.type(a)==="array"},isWindow:function(a){return a!=null&&a==a.window},isNumeric:function(a){return!isNaN(parseFloat(a))&&isFinite(a)},type:function(a){return a==null?String(a):I[C.call(a)]||"object"},isPlainObject:function(a){if(!a||e.type(a)!=="object"||a.nodeType||e.isWindow(a))return!1;try{if(a.constructor&&!D.call(a,"constructor")&&!D.call(a.constructor.prototype,"isPrototypeOf"))return!1}catch(c){return!1}var d;for(d in a);return d===b||D.call(a,d)},isEmptyObject:function(a){for(var b in a)return!1;return!0},error:function(a){throw new Error(a)},parseJSON:function(b){if(typeof b!="string"||!b)return null;b=e.trim(b);if(a.JSON&&a.JSON.parse)return a.JSON.parse(b);if(n.test(b.replace(o,"@").replace(p,"]").replace(q,"")))return(new Function("return "+b))();e.error("Invalid JSON: "+b)},parseXML:function(c){if(typeof c!="string"||!c)return null;var d,f;try{a.DOMParser?(f=new DOMParser,d=f.parseFromString(c,"text/xml")):(d=new ActiveXObject("Microsoft.XMLDOM"),d.async="false",d.loadXML(c))}catch(g){d=b}(!d||!d.documentElement||d.getElementsByTagName("parsererror").length)&&e.error("Invalid XML: "+c);return d},noop:function(){},globalEval:function(b){b&&j.test(b)&&(a.execScript||function(b){a.eval.call(a,b)})(b)},camelCase:function(a){return a.replace(w,"ms-").replace(v,x)},nodeName:function(a,b){return a.nodeName&&a.nodeName.toUpperCase()===b.toUpperCase()},each:function(a,c,d){var f,g=0,h=a.length,i=h===b||e.isFunction(a);if(d){if(i){for(f in a)if(c.apply(a[f],d)===!1)break}else for(;g<h;)if(c.apply(a[g++],d)===!1)break}else if(i){for(f in a)if(c.call(a[f],f,a[f])===!1)break}else for(;g<h;)if(c.call(a[g],g,a[g++])===!1)break;return a},trim:G?function(a){return a==null?"":G.call(a)}:function(a){return a==null?"":(a+"").replace(k,"").replace(l,"")},makeArray:function(a,b){var c=b||[];if(a!=null){var d=e.type(a);a.length==null||d==="string"||d==="function"||d==="regexp"||e.isWindow(a)?E.call(c,a):e.merge(c,a)}return c},inArray:function(a,b,c){var d;if(b){if(H)return H.call(b,a,c);d=b.length,c=c?c<0?Math.max(0,d+c):c:0;for(;c<d;c++)if(c in b&&b[c]===a)return c}return-1},merge:function(a,c){var d=a.length,e=0;if(typeof c.length=="number")for(var f=c.length;e<f;e++)a[d++]=c[e];else while(c[e]!==b)a[d++]=c[e++];a.length=d;return a},grep:function(a,b,c){var d=[],e;c=!!c;for(var f=0,g=a.length;f<g;f++)e=!!b(a[f],f),c!==e&&d.push(a[f]);return d},map:function(a,c,d){var f,g,h=[],i=0,j=a.length,k=a instanceof e||j!==b&&typeof j=="number"&&(j>0&&a[0]&&a[j-1]||j===0||e.isArray(a));if(k)for(;i<j;i++)f=c(a[i],i,d),f!=null&&(h[h.length]=f);else for(g in a)f=c(a[g],g,d),f!=null&&(h[h.length]=f);return h.concat.apply([],h)},guid:1,proxy:function(a,c){if(typeof c=="string"){var d=a[c];c=a,a=d}if(!e.isFunction(a))return b;var f=F.call(arguments,2),g=function(){return a.apply(c,f.concat(F.call(arguments)))};g.guid=a.guid=a.guid||g.guid||e.guid++;return g},access:function(a,c,d,f,g,h,i){var j,k=d==null,l=0,m=a.length;if(d&&typeof d=="object"){for(l in d)e.access(a,c,l,d[l],1,h,f);g=1}else if(f!==b){j=i===b&&e.isFunction(f),k&&(j?(j=c,c=function(a,b,c){return j.call(e(a),c)}):(c.call(a,f),c=null));if(c)for(;l<m;l++)c(a[l],d,j?f.call(a[l],l,c(a[l],d)):f,i);g=1}return g?a:k?c.call(a):m?c(a[0],d):h},now:function(){return(new Date).getTime()},uaMatch:function(a){a=a.toLowerCase();var b=r.exec(a)||s.exec(a)||t.exec(a)||a.indexOf("compatible")<0&&u.exec(a)||[];return{browser:b[1]||"",version:b[2]||"0"}},sub:function(){function a(b,c){return new a.fn.init(b,c)}e.extend(!0,a,this),a.superclass=this,a.fn=a.prototype=this(),a.fn.constructor=a,a.sub=this.sub,a.fn.init=function(d,f){f&&f instanceof e&&!(f instanceof a)&&(f=a(f));return e.fn.init.call(this,d,f,b)},a.fn.init.prototype=a.fn;var b=a(c);return a},browser:{}}),e.each("Boolean Number String Function Array Date RegExp Object".split(" "),function(a,b){I["[object "+b+"]"]=b.toLowerCase()}),z=e.uaMatch(y),z.browser&&(e.browser[z.browser]=!0,e.browser.version=z.version),e.browser.webkit&&(e.browser.safari=!0),j.test(" ")&&(k=/^[\s\xA0]+/,l=/[\s\xA0]+$/),h=e(c),c.addEventListener?B=function(){c.removeEventListener("DOMContentLoaded",B,!1),e.ready()}:c.attachEvent&&(B=function(){c.readyState==="complete"&&(c.detachEvent("onreadystatechange",B),e.ready())});return e}(),g={};f.Callbacks=function(a){a=a?g[a]||h(a):{};var c=[],d=[],e,i,j,k,l,m,n=function(b){var d,e,g,h,i;for(d=0,e=b.length;d<e;d++)g=b[d],h=f.type(g),h==="array"?n(g):h==="function"&&(!a.unique||!p.has(g))&&c.push(g)},o=function(b,f){f=f||[],e=!a.memory||[b,f],i=!0,j=!0,m=k||0,k=0,l=c.length;for(;c&&m<l;m++)if(c[m].apply(b,f)===!1&&a.stopOnFalse){e=!0;break}j=!1,c&&(a.once?e===!0?p.disable():c=[]:d&&d.length&&(e=d.shift(),p.fireWith(e[0],e[1])))},p={add:function(){if(c){var a=c.length;n(arguments),j?l=c.length:e&&e!==!0&&(k=a,o(e[0],e[1]))}return this},remove:function(){if(c){var b=arguments,d=0,e=b.length;for(;d<e;d++)for(var f=0;f<c.length;f++)if(b[d]===c[f]){j&&f<=l&&(l--,f<=m&&m--),c.splice(f--,1);if(a.unique)break}}return this},has:function(a){if(c){var b=0,d=c.length;for(;b<d;b++)if(a===c[b])return!0}return!1},empty:function(){c=[];return this},disable:function(){c=d=e=b;return this},disabled:function(){return!c},lock:function(){d=b,(!e||e===!0)&&p.disable();return this},locked:function(){return!d},fireWith:function(b,c){d&&(j?a.once||d.push([b,c]):(!a.once||!e)&&o(b,c));return this},fire:function(){p.fireWith(this,arguments);return this},fired:function(){return!!i}};return p};var i=[].slice;f.extend({Deferred:function(a){var b=f.Callbacks("once memory"),c=f.Callbacks("once memory"),d=f.Callbacks("memory"),e="pending",g={resolve:b,reject:c,notify:d},h={done:b.add,fail:c.add,progress:d.add,state:function(){return e},isResolved:b.fired,isRejected:c.fired,then:function(a,b,c){i.done(a).fail(b).progress(c);return this},always:function(){i.done.apply(i,arguments).fail.apply(i,arguments);return this},pipe:function(a,b,c){return f.Deferred(function(d){f.each({done:[a,"resolve"],fail:[b,"reject"],progress:[c,"notify"]},function(a,b){var c=b[0],e=b[1],g;f.isFunction(c)?i[a](function(){g=c.apply(this,arguments),g&&f.isFunction(g.promise)?g.promise().then(d.resolve,d.reject,d.notify):d[e+"With"](this===i?d:this,[g])}):i[a](d[e])})}).promise()},promise:function(a){if(a==null)a=h;else for(var b in h)a[b]=h[b];return a}},i=h.promise({}),j;for(j in g)i[j]=g[j].fire,i[j+"With"]=g[j].fireWith;i.done(function(){e="resolved"},c.disable,d.lock).fail(function(){e="rejected"},b.disable,d.lock),a&&a.call(i,i);return i},when:function(a){function m(a){return function(b){e[a]=arguments.length>1?i.call(arguments,0):b,j.notifyWith(k,e)}}function l(a){return function(c){b[a]=arguments.length>1?i.call(arguments,0):c,--g||j.resolveWith(j,b)}}var b=i.call(arguments,0),c=0,d=b.length,e=Array(d),g=d,h=d,j=d<=1&&a&&f.isFunction(a.promise)?a:f.Deferred(),k=j.promise();if(d>1){for(;c<d;c++)b[c]&&b[c].promise&&f.isFunction(b[c].promise)?b[c].promise().then(l(c),j.reject,m(c)):--g;g||j.resolveWith(j,b)}else j!==a&&j.resolveWith(j,d?[a]:[]);return k}}),f.support=function(){var b,d,e,g,h,i,j,k,l,m,n,o,p=c.createElement("div"),q=c.documentElement;p.setAttribute("className","t"),p.innerHTML="   <link/><table></table><a href='/a' style='top:1px;float:left;opacity:.55;'>a</a><input type='checkbox'/>",d=p.getElementsByTagName("*"),e=p.getElementsByTagName("a")[0];if(!d||!d.length||!e)return{};g=c.createElement("select"),h=g.appendChild(c.createElement("option")),i=p.getElementsByTagName("input")[0],b={leadingWhitespace:p.firstChild.nodeType===3,tbody:!p.getElementsByTagName("tbody").length,htmlSerialize:!!p.getElementsByTagName("link").length,style:/top/.test(e.getAttribute("style")),hrefNormalized:e.getAttribute("href")==="/a",opacity:/^0.55/.test(e.style.opacity),cssFloat:!!e.style.cssFloat,checkOn:i.value==="on",optSelected:h.selected,getSetAttribute:p.className!=="t",enctype:!!c.createElement("form").enctype,html5Clone:c.createElement("nav").cloneNode(!0).outerHTML!=="<:nav></:nav>",submitBubbles:!0,changeBubbles:!0,focusinBubbles:!1,deleteExpando:!0,noCloneEvent:!0,inlineBlockNeedsLayout:!1,shrinkWrapBlocks:!1,reliableMarginRight:!0,pixelMargin:!0},f.boxModel=b.boxModel=c.compatMode==="CSS1Compat",i.checked=!0,b.noCloneChecked=i.cloneNode(!0).checked,g.disabled=!0,b.optDisabled=!h.disabled;try{delete p.test}catch(r){b.deleteExpando=!1}!p.addEventListener&&p.attachEvent&&p.fireEvent&&(p.attachEvent("onclick",function(){b.noCloneEvent=!1}),p.cloneNode(!0).fireEvent("onclick")),i=c.createElement("input"),i.value="t",i.setAttribute("type","radio"),b.radioValue=i.value==="t",i.setAttribute("checked","checked"),i.setAttribute("name","t"),p.appendChild(i),j=c.createDocumentFragment(),j.appendChild(p.lastChild),b.checkClone=j.cloneNode(!0).cloneNode(!0).lastChild.checked,b.appendChecked=i.checked,j.removeChild(i),j.appendChild(p);if(p.attachEvent)for(n in{submit:1,change:1,focusin:1})m="on"+n,o=m in p,o||(p.setAttribute(m,"return;"),o=typeof p[m]=="function"),b[n+"Bubbles"]=o;j.removeChild(p),j=g=h=p=i=null,f(function(){var d,e,g,h,i,j,l,m,n,q,r,s,t,u=c.getElementsByTagName("body")[0];!u||(m=1,t="padding:0;margin:0;border:",r="position:absolute;top:0;left:0;width:1px;height:1px;",s=t+"0;visibility:hidden;",n="style='"+r+t+"5px solid #000;",q="<div "+n+"display:block;'><div style='"+t+"0;display:block;overflow:hidden;'></div></div>"+"<table "+n+"' cellpadding='0' cellspacing='0'>"+"<tr><td></td></tr></table>",d=c.createElement("div"),d.style.cssText=s+"width:0;height:0;position:static;top:0;margin-top:"+m+"px",u.insertBefore(d,u.firstChild),p=c.createElement("div"),d.appendChild(p),p.innerHTML="<table><tr><td style='"+t+"0;display:none'></td><td>t</td></tr></table>",k=p.getElementsByTagName("td"),o=k[0].offsetHeight===0,k[0].style.display="",k[1].style.display="none",b.reliableHiddenOffsets=o&&k[0].offsetHeight===0,a.getComputedStyle&&(p.innerHTML="",l=c.createElement("div"),l.style.width="0",l.style.marginRight="0",p.style.width="2px",p.appendChild(l),b.reliableMarginRight=(parseInt((a.getComputedStyle(l,null)||{marginRight:0}).marginRight,10)||0)===0),typeof p.style.zoom!="undefined"&&(p.innerHTML="",p.style.width=p.style.padding="1px",p.style.border=0,p.style.overflow="hidden",p.style.display="inline",p.style.zoom=1,b.inlineBlockNeedsLayout=p.offsetWidth===3,p.style.display="block",p.style.overflow="visible",p.innerHTML="<div style='width:5px;'></div>",b.shrinkWrapBlocks=p.offsetWidth!==3),p.style.cssText=r+s,p.innerHTML=q,e=p.firstChild,g=e.firstChild,i=e.nextSibling.firstChild.firstChild,j={doesNotAddBorder:g.offsetTop!==5,doesAddBorderForTableAndCells:i.offsetTop===5},g.style.position="fixed",g.style.top="20px",j.fixedPosition=g.offsetTop===20||g.offsetTop===15,g.style.position=g.style.top="",e.style.overflow="hidden",e.style.position="relative",j.subtractsBorderForOverflowNotVisible=g.offsetTop===-5,j.doesNotIncludeMarginInBodyOffset=u.offsetTop!==m,a.getComputedStyle&&(p.style.marginTop="1%",b.pixelMargin=(a.getComputedStyle(p,null)||{marginTop:0}).marginTop!=="1%"),typeof d.style.zoom!="undefined"&&(d.style.zoom=1),u.removeChild(d),l=p=d=null,f.extend(b,j))});return b}();var j=/^(?:\{.*\}|\[.*\])$/,k=/([A-Z])/g;f.extend({cache:{},uuid:0,expando:"jQuery"+(f.fn.jquery+Math.random()).replace(/\D/g,""),noData:{embed:!0,object:"clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",applet:!0},hasData:function(a){a=a.nodeType?f.cache[a[f.expando]]:a[f.expando];return!!a&&!m(a)},data:function(a,c,d,e){if(!!f.acceptData(a)){var g,h,i,j=f.expando,k=typeof c=="string",l=a.nodeType,m=l?f.cache:a,n=l?a[j]:a[j]&&j,o=c==="events";if((!n||!m[n]||!o&&!e&&!m[n].data)&&k&&d===b)return;n||(l?a[j]=n=++f.uuid:n=j),m[n]||(m[n]={},l||(m[n].toJSON=f.noop));if(typeof c=="object"||typeof c=="function")e?m[n]=f.extend(m[n],c):m[n].data=f.extend(m[n].data,c);g=h=m[n],e||(h.data||(h.data={}),h=h.data),d!==b&&(h[f.camelCase(c)]=d);if(o&&!h[c])return g.events;k?(i=h[c],i==null&&(i=h[f.camelCase(c)])):i=h;return i}},removeData:function(a,b,c){if(!!f.acceptData(a)){var d,e,g,h=f.expando,i=a.nodeType,j=i?f.cache:a,k=i?a[h]:h;if(!j[k])return;if(b){d=c?j[k]:j[k].data;if(d){f.isArray(b)||(b in d?b=[b]:(b=f.camelCase(b),b in d?b=[b]:b=b.split(" ")));for(e=0,g=b.length;e<g;e++)delete d[b[e]];if(!(c?m:f.isEmptyObject)(d))return}}if(!c){delete j[k].data;if(!m(j[k]))return}f.support.deleteExpando||!j.setInterval?delete j[k]:j[k]=null,i&&(f.support.deleteExpando?delete a[h]:a.removeAttribute?a.removeAttribute(h):a[h]=null)}},_data:function(a,b,c){return f.data(a,b,c,!0)},acceptData:function(a){if(a.nodeName){var b=f.noData[a.nodeName.toLowerCase()];if(b)return b!==!0&&a.getAttribute("classid")===b}return!0}}),f.fn.extend({data:function(a,c){var d,e,g,h,i,j=this[0],k=0,m=null;if(a===b){if(this.length){m=f.data(j);if(j.nodeType===1&&!f._data(j,"parsedAttrs")){g=j.attributes;for(i=g.length;k<i;k++)h=g[k].name,h.indexOf("data-")===0&&(h=f.camelCase(h.substring(5)),l(j,h,m[h]));f._data(j,"parsedAttrs",!0)}}return m}if(typeof a=="object")return this.each(function(){f.data(this,a)});d=a.split(".",2),d[1]=d[1]?"."+d[1]:"",e=d[1]+"!";return f.access(this,function(c){if(c===b){m=this.triggerHandler("getData"+e,[d[0]]),m===b&&j&&(m=f.data(j,a),m=l(j,a,m));return m===b&&d[1]?this.data(d[0]):m}d[1]=c,this.each(function(){var b=f(this);b.triggerHandler("setData"+e,d),f.data(this,a,c),b.triggerHandler("changeData"+e,d)})},null,c,arguments.length>1,null,!1)},removeData:function(a){return this.each(function(){f.removeData(this,a)})}}),f.extend({_mark:function(a,b){a&&(b=(b||"fx")+"mark",f._data(a,b,(f._data(a,b)||0)+1))},_unmark:function(a,b,c){a!==!0&&(c=b,b=a,a=!1);if(b){c=c||"fx";var d=c+"mark",e=a?0:(f._data(b,d)||1)-1;e?f._data(b,d,e):(f.removeData(b,d,!0),n(b,c,"mark"))}},queue:function(a,b,c){var d;if(a){b=(b||"fx")+"queue",d=f._data(a,b),c&&(!d||f.isArray(c)?d=f._data(a,b,f.makeArray(c)):d.push(c));return d||[]}},dequeue:function(a,b){b=b||"fx";var c=f.queue(a,b),d=c.shift(),e={};d==="inprogress"&&(d=c.shift()),d&&(b==="fx"&&c.unshift("inprogress"),f._data(a,b+".run",e),d.call(a,function(){f.dequeue(a,b)},e)),c.length||(f.removeData(a,b+"queue "+b+".run",!0),n(a,b,"queue"))}}),f.fn.extend({queue:function(a,c){var d=2;typeof a!="string"&&(c=a,a="fx",d--);if(arguments.length<d)return f.queue(this[0],a);return c===b?this:this.each(function(){var b=f.queue(this,a,c);a==="fx"&&b[0]!=="inprogress"&&f.dequeue(this,a)})},dequeue:function(a){return this.each(function(){f.dequeue(this,a)})},delay:function(a,b){a=f.fx?f.fx.speeds[a]||a:a,b=b||"fx";return this.queue(b,function(b,c){var d=setTimeout(b,a);c.stop=function(){clearTimeout(d)}})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,c){function m(){--h||d.resolveWith(e,[e])}typeof a!="string"&&(c=a,a=b),a=a||"fx";var d=f.Deferred(),e=this,g=e.length,h=1,i=a+"defer",j=a+"queue",k=a+"mark",l;while(g--)if(l=f.data(e[g],i,b,!0)||(f.data(e[g],j,b,!0)||f.data(e[g],k,b,!0))&&f.data(e[g],i,f.Callbacks("once memory"),!0))h++,l.add(m);m();return d.promise(c)}});var o=/[\n\t\r]/g,p=/\s+/,q=/\r/g,r=/^(?:button|input)$/i,s=/^(?:button|input|object|select|textarea)$/i,t=/^a(?:rea)?$/i,u=/^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,v=f.support.getSetAttribute,w,x,y;f.fn.extend({attr:function(a,b){return f.access(this,f.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){f.removeAttr(this,a)})},prop:function(a,b){return f.access(this,f.prop,a,b,arguments.length>1)},removeProp:function(a){a=f.propFix[a]||a;return this.each(function(){try{this[a]=b,delete this[a]}catch(c){}})},addClass:function(a){var b,c,d,e,g,h,i;if(f.isFunction(a))return this.each(function(b){f(this).addClass(a.call(this,b,this.className))});if(a&&typeof a=="string"){b=a.split(p);for(c=0,d=this.length;c<d;c++){e=this[c];if(e.nodeType===1)if(!e.className&&b.length===1)e.className=a;else{g=" "+e.className+" ";for(h=0,i=b.length;h<i;h++)~g.indexOf(" "+b[h]+" ")||(g+=b[h]+" ");e.className=f.trim(g)}}}return this},removeClass:function(a){var c,d,e,g,h,i,j;if(f.isFunction(a))return this.each(function(b){f(this).removeClass(a.call(this,b,this.className))});if(a&&typeof a=="string"||a===b){c=(a||"").split(p);for(d=0,e=this.length;d<e;d++){g=this[d];if(g.nodeType===1&&g.className)if(a){h=(" "+g.className+" ").replace(o," ");for(i=0,j=c.length;i<j;i++)h=h.replace(" "+c[i]+" "," ");g.className=f.trim(h)}else g.className=""}}return this},toggleClass:function(a,b){var c=typeof a,d=typeof b=="boolean";if(f.isFunction(a))return this.each(function(c){f(this).toggleClass(a.call(this,c,this.className,b),b)});return this.each(function(){if(c==="string"){var e,g=0,h=f(this),i=b,j=a.split(p);while(e=j[g++])i=d?i:!h.hasClass(e),h[i?"addClass":"removeClass"](e)}else if(c==="undefined"||c==="boolean")this.className&&f._data(this,"__className__",this.className),this.className=this.className||a===!1?"":f._data(this,"__className__")||""})},hasClass:function(a){var b=" "+a+" ",c=0,d=this.length;for(;c<d;c++)if(this[c].nodeType===1&&(" "+this[c].className+" ").replace(o," ").indexOf(b)>-1)return!0;return!1},val:function(a){var c,d,e,g=this[0];{if(!!arguments.length){e=f.isFunction(a);return this.each(function(d){var g=f(this),h;if(this.nodeType===1){e?h=a.call(this,d,g.val()):h=a,h==null?h="":typeof h=="number"?h+="":f.isArray(h)&&(h=f.map(h,function(a){return a==null?"":a+""})),c=f.valHooks[this.type]||f.valHooks[this.nodeName.toLowerCase()];if(!c||!("set"in c)||c.set(this,h,"value")===b)this.value=h}})}if(g){c=f.valHooks[g.type]||f.valHooks[g.nodeName.toLowerCase()];if(c&&"get"in c&&(d=c.get(g,"value"))!==b)return d;d=g.value;return typeof d=="string"?d.replace(q,""):d==null?"":d}}}}),f.extend({valHooks:{option:{get:function(a){var b=a.attributes.value;return!b||b.specified?a.value:a.text}},select:{get:function(a){var b,c,d,e,g=a.selectedIndex,h=[],i=a.options,j=a.type==="select-one";if(g<0)return null;c=j?g:0,d=j?g+1:i.length;for(;c<d;c++){e=i[c];if(e.selected&&(f.support.optDisabled?!e.disabled:e.getAttribute("disabled")===null)&&(!e.parentNode.disabled||!f.nodeName(e.parentNode,"optgroup"))){b=f(e).val();if(j)return b;h.push(b)}}if(j&&!h.length&&i.length)return f(i[g]).val();return h},set:function(a,b){var c=f.makeArray(b);f(a).find("option").each(function(){this.selected=f.inArray(f(this).val(),c)>=0}),c.length||(a.selectedIndex=-1);return c}}},attrFn:{val:!0,css:!0,html:!0,text:!0,data:!0,width:!0,height:!0,offset:!0},attr:function(a,c,d,e){var g,h,i,j=a.nodeType;if(!!a&&j!==3&&j!==8&&j!==2){if(e&&c in f.attrFn)return f(a)[c](d);if(typeof a.getAttribute=="undefined")return f.prop(a,c,d);i=j!==1||!f.isXMLDoc(a),i&&(c=c.toLowerCase(),h=f.attrHooks[c]||(u.test(c)?x:w));if(d!==b){if(d===null){f.removeAttr(a,c);return}if(h&&"set"in h&&i&&(g=h.set(a,d,c))!==b)return g;a.setAttribute(c,""+d);return d}if(h&&"get"in h&&i&&(g=h.get(a,c))!==null)return g;g=a.getAttribute(c);return g===null?b:g}},removeAttr:function(a,b){var c,d,e,g,h,i=0;if(b&&a.nodeType===1){d=b.toLowerCase().split(p),g=d.length;for(;i<g;i++)e=d[i],e&&(c=f.propFix[e]||e,h=u.test(e),h||f.attr(a,e,""),a.removeAttribute(v?e:c),h&&c in a&&(a[c]=!1))}},attrHooks:{type:{set:function(a,b){if(r.test(a.nodeName)&&a.parentNode)f.error("type property can't be changed");else if(!f.support.radioValue&&b==="radio"&&f.nodeName(a,"input")){var c=a.value;a.setAttribute("type",b),c&&(a.value=c);return b}}},value:{get:function(a,b){if(w&&f.nodeName(a,"button"))return w.get(a,b);return b in a?a.value:null},set:function(a,b,c){if(w&&f.nodeName(a,"button"))return w.set(a,b,c);a.value=b}}},propFix:{tabindex:"tabIndex",readonly:"readOnly","for":"htmlFor","class":"className",maxlength:"maxLength",cellspacing:"cellSpacing",cellpadding:"cellPadding",rowspan:"rowSpan",colspan:"colSpan",usemap:"useMap",frameborder:"frameBorder",contenteditable:"contentEditable"},prop:function(a,c,d){var e,g,h,i=a.nodeType;if(!!a&&i!==3&&i!==8&&i!==2){h=i!==1||!f.isXMLDoc(a),h&&(c=f.propFix[c]||c,g=f.propHooks[c]);return d!==b?g&&"set"in g&&(e=g.set(a,d,c))!==b?e:a[c]=d:g&&"get"in g&&(e=g.get(a,c))!==null?e:a[c]}},propHooks:{tabIndex:{get:function(a){var c=a.getAttributeNode("tabindex");return c&&c.specified?parseInt(c.value,10):s.test(a.nodeName)||t.test(a.nodeName)&&a.href?0:b}}}}),f.attrHooks.tabindex=f.propHooks.tabIndex,x={get:function(a,c){var d,e=f.prop(a,c);return e===!0||typeof e!="boolean"&&(d=a.getAttributeNode(c))&&d.nodeValue!==!1?c.toLowerCase():b},set:function(a,b,c){var d;b===!1?f.removeAttr(a,c):(d=f.propFix[c]||c,d in a&&(a[d]=!0),a.setAttribute(c,c.toLowerCase()));return c}},v||(y={name:!0,id:!0,coords:!0},w=f.valHooks.button={get:function(a,c){var d;d=a.getAttributeNode(c);return d&&(y[c]?d.nodeValue!=="":d.specified)?d.nodeValue:b},set:function(a,b,d){var e=a.getAttributeNode(d);e||(e=c.createAttribute(d),a.setAttributeNode(e));return e.nodeValue=b+""}},f.attrHooks.tabindex.set=w.set,f.each(["width","height"],function(a,b){f.attrHooks[b]=f.extend(f.attrHooks[b],{set:function(a,c){if(c===""){a.setAttribute(b,"auto");return c}}})}),f.attrHooks.contenteditable={get:w.get,set:function(a,b,c){b===""&&(b="false"),w.set(a,b,c)}}),f.support.hrefNormalized||f.each(["href","src","width","height"],function(a,c){f.attrHooks[c]=f.extend(f.attrHooks[c],{get:function(a){var d=a.getAttribute(c,2);return d===null?b:d}})}),f.support.style||(f.attrHooks.style={get:function(a){return a.style.cssText.toLowerCase()||b},set:function(a,b){return a.style.cssText=""+b}}),f.support.optSelected||(f.propHooks.selected=f.extend(f.propHooks.selected,{get:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex);return null}})),f.support.enctype||(f.propFix.enctype="encoding"),f.support.checkOn||f.each(["radio","checkbox"],function(){f.valHooks[this]={get:function(a){return a.getAttribute("value")===null?"on":a.value}}}),f.each(["radio","checkbox"],function(){f.valHooks[this]=f.extend(f.valHooks[this],{set:function(a,b){if(f.isArray(b))return a.checked=f.inArray(f(a).val(),b)>=0}})});var z=/^(?:textarea|input|select)$/i,A=/^([^\.]*)?(?:\.(.+))?$/,B=/(?:^|\s)hover(\.\S+)?\b/,C=/^key/,D=/^(?:mouse|contextmenu)|click/,E=/^(?:focusinfocus|focusoutblur)$/,F=/^(\w*)(?:#([\w\-]+))?(?:\.([\w\-]+))?$/,G=function(
a){var b=F.exec(a);b&&(b[1]=(b[1]||"").toLowerCase(),b[3]=b[3]&&new RegExp("(?:^|\\s)"+b[3]+"(?:\\s|$)"));return b},H=function(a,b){var c=a.attributes||{};return(!b[1]||a.nodeName.toLowerCase()===b[1])&&(!b[2]||(c.id||{}).value===b[2])&&(!b[3]||b[3].test((c["class"]||{}).value))},I=function(a){return f.event.special.hover?a:a.replace(B,"mouseenter$1 mouseleave$1")};f.event={add:function(a,c,d,e,g){var h,i,j,k,l,m,n,o,p,q,r,s;if(!(a.nodeType===3||a.nodeType===8||!c||!d||!(h=f._data(a)))){d.handler&&(p=d,d=p.handler,g=p.selector),d.guid||(d.guid=f.guid++),j=h.events,j||(h.events=j={}),i=h.handle,i||(h.handle=i=function(a){return typeof f!="undefined"&&(!a||f.event.triggered!==a.type)?f.event.dispatch.apply(i.elem,arguments):b},i.elem=a),c=f.trim(I(c)).split(" ");for(k=0;k<c.length;k++){l=A.exec(c[k])||[],m=l[1],n=(l[2]||"").split(".").sort(),s=f.event.special[m]||{},m=(g?s.delegateType:s.bindType)||m,s=f.event.special[m]||{},o=f.extend({type:m,origType:l[1],data:e,handler:d,guid:d.guid,selector:g,quick:g&&G(g),namespace:n.join(".")},p),r=j[m];if(!r){r=j[m]=[],r.delegateCount=0;if(!s.setup||s.setup.call(a,e,n,i)===!1)a.addEventListener?a.addEventListener(m,i,!1):a.attachEvent&&a.attachEvent("on"+m,i)}s.add&&(s.add.call(a,o),o.handler.guid||(o.handler.guid=d.guid)),g?r.splice(r.delegateCount++,0,o):r.push(o),f.event.global[m]=!0}a=null}},global:{},remove:function(a,b,c,d,e){var g=f.hasData(a)&&f._data(a),h,i,j,k,l,m,n,o,p,q,r,s;if(!!g&&!!(o=g.events)){b=f.trim(I(b||"")).split(" ");for(h=0;h<b.length;h++){i=A.exec(b[h])||[],j=k=i[1],l=i[2];if(!j){for(j in o)f.event.remove(a,j+b[h],c,d,!0);continue}p=f.event.special[j]||{},j=(d?p.delegateType:p.bindType)||j,r=o[j]||[],m=r.length,l=l?new RegExp("(^|\\.)"+l.split(".").sort().join("\\.(?:.*\\.)?")+"(\\.|$)"):null;for(n=0;n<r.length;n++)s=r[n],(e||k===s.origType)&&(!c||c.guid===s.guid)&&(!l||l.test(s.namespace))&&(!d||d===s.selector||d==="**"&&s.selector)&&(r.splice(n--,1),s.selector&&r.delegateCount--,p.remove&&p.remove.call(a,s));r.length===0&&m!==r.length&&((!p.teardown||p.teardown.call(a,l)===!1)&&f.removeEvent(a,j,g.handle),delete o[j])}f.isEmptyObject(o)&&(q=g.handle,q&&(q.elem=null),f.removeData(a,["events","handle"],!0))}},customEvent:{getData:!0,setData:!0,changeData:!0},trigger:function(c,d,e,g){if(!e||e.nodeType!==3&&e.nodeType!==8){var h=c.type||c,i=[],j,k,l,m,n,o,p,q,r,s;if(E.test(h+f.event.triggered))return;h.indexOf("!")>=0&&(h=h.slice(0,-1),k=!0),h.indexOf(".")>=0&&(i=h.split("."),h=i.shift(),i.sort());if((!e||f.event.customEvent[h])&&!f.event.global[h])return;c=typeof c=="object"?c[f.expando]?c:new f.Event(h,c):new f.Event(h),c.type=h,c.isTrigger=!0,c.exclusive=k,c.namespace=i.join("."),c.namespace_re=c.namespace?new RegExp("(^|\\.)"+i.join("\\.(?:.*\\.)?")+"(\\.|$)"):null,o=h.indexOf(":")<0?"on"+h:"";if(!e){j=f.cache;for(l in j)j[l].events&&j[l].events[h]&&f.event.trigger(c,d,j[l].handle.elem,!0);return}c.result=b,c.target||(c.target=e),d=d!=null?f.makeArray(d):[],d.unshift(c),p=f.event.special[h]||{};if(p.trigger&&p.trigger.apply(e,d)===!1)return;r=[[e,p.bindType||h]];if(!g&&!p.noBubble&&!f.isWindow(e)){s=p.delegateType||h,m=E.test(s+h)?e:e.parentNode,n=null;for(;m;m=m.parentNode)r.push([m,s]),n=m;n&&n===e.ownerDocument&&r.push([n.defaultView||n.parentWindow||a,s])}for(l=0;l<r.length&&!c.isPropagationStopped();l++)m=r[l][0],c.type=r[l][1],q=(f._data(m,"events")||{})[c.type]&&f._data(m,"handle"),q&&q.apply(m,d),q=o&&m[o],q&&f.acceptData(m)&&q.apply(m,d)===!1&&c.preventDefault();c.type=h,!g&&!c.isDefaultPrevented()&&(!p._default||p._default.apply(e.ownerDocument,d)===!1)&&(h!=="click"||!f.nodeName(e,"a"))&&f.acceptData(e)&&o&&e[h]&&(h!=="focus"&&h!=="blur"||c.target.offsetWidth!==0)&&!f.isWindow(e)&&(n=e[o],n&&(e[o]=null),f.event.triggered=h,e[h](),f.event.triggered=b,n&&(e[o]=n));return c.result}},dispatch:function(c){c=f.event.fix(c||a.event);var d=(f._data(this,"events")||{})[c.type]||[],e=d.delegateCount,g=[].slice.call(arguments,0),h=!c.exclusive&&!c.namespace,i=f.event.special[c.type]||{},j=[],k,l,m,n,o,p,q,r,s,t,u;g[0]=c,c.delegateTarget=this;if(!i.preDispatch||i.preDispatch.call(this,c)!==!1){if(e&&(!c.button||c.type!=="click")){n=f(this),n.context=this.ownerDocument||this;for(m=c.target;m!=this;m=m.parentNode||this)if(m.disabled!==!0){p={},r=[],n[0]=m;for(k=0;k<e;k++)s=d[k],t=s.selector,p[t]===b&&(p[t]=s.quick?H(m,s.quick):n.is(t)),p[t]&&r.push(s);r.length&&j.push({elem:m,matches:r})}}d.length>e&&j.push({elem:this,matches:d.slice(e)});for(k=0;k<j.length&&!c.isPropagationStopped();k++){q=j[k],c.currentTarget=q.elem;for(l=0;l<q.matches.length&&!c.isImmediatePropagationStopped();l++){s=q.matches[l];if(h||!c.namespace&&!s.namespace||c.namespace_re&&c.namespace_re.test(s.namespace))c.data=s.data,c.handleObj=s,o=((f.event.special[s.origType]||{}).handle||s.handler).apply(q.elem,g),o!==b&&(c.result=o,o===!1&&(c.preventDefault(),c.stopPropagation()))}}i.postDispatch&&i.postDispatch.call(this,c);return c.result}},props:"attrChange attrName relatedNode srcElement altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),fixHooks:{},keyHooks:{props:"char charCode key keyCode".split(" "),filter:function(a,b){a.which==null&&(a.which=b.charCode!=null?b.charCode:b.keyCode);return a}},mouseHooks:{props:"button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),filter:function(a,d){var e,f,g,h=d.button,i=d.fromElement;a.pageX==null&&d.clientX!=null&&(e=a.target.ownerDocument||c,f=e.documentElement,g=e.body,a.pageX=d.clientX+(f&&f.scrollLeft||g&&g.scrollLeft||0)-(f&&f.clientLeft||g&&g.clientLeft||0),a.pageY=d.clientY+(f&&f.scrollTop||g&&g.scrollTop||0)-(f&&f.clientTop||g&&g.clientTop||0)),!a.relatedTarget&&i&&(a.relatedTarget=i===a.target?d.toElement:i),!a.which&&h!==b&&(a.which=h&1?1:h&2?3:h&4?2:0);return a}},fix:function(a){if(a[f.expando])return a;var d,e,g=a,h=f.event.fixHooks[a.type]||{},i=h.props?this.props.concat(h.props):this.props;a=f.Event(g);for(d=i.length;d;)e=i[--d],a[e]=g[e];a.target||(a.target=g.srcElement||c),a.target.nodeType===3&&(a.target=a.target.parentNode),a.metaKey===b&&(a.metaKey=a.ctrlKey);return h.filter?h.filter(a,g):a},special:{ready:{setup:f.bindReady},load:{noBubble:!0},focus:{delegateType:"focusin"},blur:{delegateType:"focusout"},beforeunload:{setup:function(a,b,c){f.isWindow(this)&&(this.onbeforeunload=c)},teardown:function(a,b){this.onbeforeunload===b&&(this.onbeforeunload=null)}}},simulate:function(a,b,c,d){var e=f.extend(new f.Event,c,{type:a,isSimulated:!0,originalEvent:{}});d?f.event.trigger(e,null,b):f.event.dispatch.call(b,e),e.isDefaultPrevented()&&c.preventDefault()}},f.event.handle=f.event.dispatch,f.removeEvent=c.removeEventListener?function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c,!1)}:function(a,b,c){a.detachEvent&&a.detachEvent("on"+b,c)},f.Event=function(a,b){if(!(this instanceof f.Event))return new f.Event(a,b);a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||a.returnValue===!1||a.getPreventDefault&&a.getPreventDefault()?K:J):this.type=a,b&&f.extend(this,b),this.timeStamp=a&&a.timeStamp||f.now(),this[f.expando]=!0},f.Event.prototype={preventDefault:function(){this.isDefaultPrevented=K;var a=this.originalEvent;!a||(a.preventDefault?a.preventDefault():a.returnValue=!1)},stopPropagation:function(){this.isPropagationStopped=K;var a=this.originalEvent;!a||(a.stopPropagation&&a.stopPropagation(),a.cancelBubble=!0)},stopImmediatePropagation:function(){this.isImmediatePropagationStopped=K,this.stopPropagation()},isDefaultPrevented:J,isPropagationStopped:J,isImmediatePropagationStopped:J},f.each({mouseenter:"mouseover",mouseleave:"mouseout"},function(a,b){f.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c=this,d=a.relatedTarget,e=a.handleObj,g=e.selector,h;if(!d||d!==c&&!f.contains(c,d))a.type=e.origType,h=e.handler.apply(this,arguments),a.type=b;return h}}}),f.support.submitBubbles||(f.event.special.submit={setup:function(){if(f.nodeName(this,"form"))return!1;f.event.add(this,"click._submit keypress._submit",function(a){var c=a.target,d=f.nodeName(c,"input")||f.nodeName(c,"button")?c.form:b;d&&!d._submit_attached&&(f.event.add(d,"submit._submit",function(a){a._submit_bubble=!0}),d._submit_attached=!0)})},postDispatch:function(a){a._submit_bubble&&(delete a._submit_bubble,this.parentNode&&!a.isTrigger&&f.event.simulate("submit",this.parentNode,a,!0))},teardown:function(){if(f.nodeName(this,"form"))return!1;f.event.remove(this,"._submit")}}),f.support.changeBubbles||(f.event.special.change={setup:function(){if(z.test(this.nodeName)){if(this.type==="checkbox"||this.type==="radio")f.event.add(this,"propertychange._change",function(a){a.originalEvent.propertyName==="checked"&&(this._just_changed=!0)}),f.event.add(this,"click._change",function(a){this._just_changed&&!a.isTrigger&&(this._just_changed=!1,f.event.simulate("change",this,a,!0))});return!1}f.event.add(this,"beforeactivate._change",function(a){var b=a.target;z.test(b.nodeName)&&!b._change_attached&&(f.event.add(b,"change._change",function(a){this.parentNode&&!a.isSimulated&&!a.isTrigger&&f.event.simulate("change",this.parentNode,a,!0)}),b._change_attached=!0)})},handle:function(a){var b=a.target;if(this!==b||a.isSimulated||a.isTrigger||b.type!=="radio"&&b.type!=="checkbox")return a.handleObj.handler.apply(this,arguments)},teardown:function(){f.event.remove(this,"._change");return z.test(this.nodeName)}}),f.support.focusinBubbles||f.each({focus:"focusin",blur:"focusout"},function(a,b){var d=0,e=function(a){f.event.simulate(b,a.target,f.event.fix(a),!0)};f.event.special[b]={setup:function(){d++===0&&c.addEventListener(a,e,!0)},teardown:function(){--d===0&&c.removeEventListener(a,e,!0)}}}),f.fn.extend({on:function(a,c,d,e,g){var h,i;if(typeof a=="object"){typeof c!="string"&&(d=d||c,c=b);for(i in a)this.on(i,c,d,a[i],g);return this}d==null&&e==null?(e=c,d=c=b):e==null&&(typeof c=="string"?(e=d,d=b):(e=d,d=c,c=b));if(e===!1)e=J;else if(!e)return this;g===1&&(h=e,e=function(a){f().off(a);return h.apply(this,arguments)},e.guid=h.guid||(h.guid=f.guid++));return this.each(function(){f.event.add(this,a,e,d,c)})},one:function(a,b,c,d){return this.on(a,b,c,d,1)},off:function(a,c,d){if(a&&a.preventDefault&&a.handleObj){var e=a.handleObj;f(a.delegateTarget).off(e.namespace?e.origType+"."+e.namespace:e.origType,e.selector,e.handler);return this}if(typeof a=="object"){for(var g in a)this.off(g,c,a[g]);return this}if(c===!1||typeof c=="function")d=c,c=b;d===!1&&(d=J);return this.each(function(){f.event.remove(this,a,d,c)})},bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},live:function(a,b,c){f(this.context).on(a,this.selector,b,c);return this},die:function(a,b){f(this.context).off(a,this.selector||"**",b);return this},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return arguments.length==1?this.off(a,"**"):this.off(b,a,c)},trigger:function(a,b){return this.each(function(){f.event.trigger(a,b,this)})},triggerHandler:function(a,b){if(this[0])return f.event.trigger(a,b,this[0],!0)},toggle:function(a){var b=arguments,c=a.guid||f.guid++,d=0,e=function(c){var e=(f._data(this,"lastToggle"+a.guid)||0)%d;f._data(this,"lastToggle"+a.guid,e+1),c.preventDefault();return b[e].apply(this,arguments)||!1};e.guid=c;while(d<b.length)b[d++].guid=c;return this.click(e)},hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),f.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "),function(a,b){f.fn[b]=function(a,c){c==null&&(c=a,a=null);return arguments.length>0?this.on(b,null,a,c):this.trigger(b)},f.attrFn&&(f.attrFn[b]=!0),C.test(b)&&(f.event.fixHooks[b]=f.event.keyHooks),D.test(b)&&(f.event.fixHooks[b]=f.event.mouseHooks)}),function(){function x(a,b,c,e,f,g){for(var h=0,i=e.length;h<i;h++){var j=e[h];if(j){var k=!1;j=j[a];while(j){if(j[d]===c){k=e[j.sizset];break}if(j.nodeType===1){g||(j[d]=c,j.sizset=h);if(typeof b!="string"){if(j===b){k=!0;break}}else if(m.filter(b,[j]).length>0){k=j;break}}j=j[a]}e[h]=k}}}function w(a,b,c,e,f,g){for(var h=0,i=e.length;h<i;h++){var j=e[h];if(j){var k=!1;j=j[a];while(j){if(j[d]===c){k=e[j.sizset];break}j.nodeType===1&&!g&&(j[d]=c,j.sizset=h);if(j.nodeName.toLowerCase()===b){k=j;break}j=j[a]}e[h]=k}}}var a=/((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,d="sizcache"+(Math.random()+"").replace(".",""),e=0,g=Object.prototype.toString,h=!1,i=!0,j=/\\/g,k=/\r\n/g,l=/\W/;[0,0].sort(function(){i=!1;return 0});var m=function(b,d,e,f){e=e||[],d=d||c;var h=d;if(d.nodeType!==1&&d.nodeType!==9)return[];if(!b||typeof b!="string")return e;var i,j,k,l,n,q,r,t,u=!0,v=m.isXML(d),w=[],x=b;do{a.exec(""),i=a.exec(x);if(i){x=i[3],w.push(i[1]);if(i[2]){l=i[3];break}}}while(i);if(w.length>1&&p.exec(b))if(w.length===2&&o.relative[w[0]])j=y(w[0]+w[1],d,f);else{j=o.relative[w[0]]?[d]:m(w.shift(),d);while(w.length)b=w.shift(),o.relative[b]&&(b+=w.shift()),j=y(b,j,f)}else{!f&&w.length>1&&d.nodeType===9&&!v&&o.match.ID.test(w[0])&&!o.match.ID.test(w[w.length-1])&&(n=m.find(w.shift(),d,v),d=n.expr?m.filter(n.expr,n.set)[0]:n.set[0]);if(d){n=f?{expr:w.pop(),set:s(f)}:m.find(w.pop(),w.length===1&&(w[0]==="~"||w[0]==="+")&&d.parentNode?d.parentNode:d,v),j=n.expr?m.filter(n.expr,n.set):n.set,w.length>0?k=s(j):u=!1;while(w.length)q=w.pop(),r=q,o.relative[q]?r=w.pop():q="",r==null&&(r=d),o.relative[q](k,r,v)}else k=w=[]}k||(k=j),k||m.error(q||b);if(g.call(k)==="[object Array]")if(!u)e.push.apply(e,k);else if(d&&d.nodeType===1)for(t=0;k[t]!=null;t++)k[t]&&(k[t]===!0||k[t].nodeType===1&&m.contains(d,k[t]))&&e.push(j[t]);else for(t=0;k[t]!=null;t++)k[t]&&k[t].nodeType===1&&e.push(j[t]);else s(k,e);l&&(m(l,h,e,f),m.uniqueSort(e));return e};m.uniqueSort=function(a){if(u){h=i,a.sort(u);if(h)for(var b=1;b<a.length;b++)a[b]===a[b-1]&&a.splice(b--,1)}return a},m.matches=function(a,b){return m(a,null,null,b)},m.matchesSelector=function(a,b){return m(b,null,null,[a]).length>0},m.find=function(a,b,c){var d,e,f,g,h,i;if(!a)return[];for(e=0,f=o.order.length;e<f;e++){h=o.order[e];if(g=o.leftMatch[h].exec(a)){i=g[1],g.splice(1,1);if(i.substr(i.length-1)!=="\\"){g[1]=(g[1]||"").replace(j,""),d=o.find[h](g,b,c);if(d!=null){a=a.replace(o.match[h],"");break}}}}d||(d=typeof b.getElementsByTagName!="undefined"?b.getElementsByTagName("*"):[]);return{set:d,expr:a}},m.filter=function(a,c,d,e){var f,g,h,i,j,k,l,n,p,q=a,r=[],s=c,t=c&&c[0]&&m.isXML(c[0]);while(a&&c.length){for(h in o.filter)if((f=o.leftMatch[h].exec(a))!=null&&f[2]){k=o.filter[h],l=f[1],g=!1,f.splice(1,1);if(l.substr(l.length-1)==="\\")continue;s===r&&(r=[]);if(o.preFilter[h]){f=o.preFilter[h](f,s,d,r,e,t);if(!f)g=i=!0;else if(f===!0)continue}if(f)for(n=0;(j=s[n])!=null;n++)j&&(i=k(j,f,n,s),p=e^i,d&&i!=null?p?g=!0:s[n]=!1:p&&(r.push(j),g=!0));if(i!==b){d||(s=r),a=a.replace(o.match[h],"");if(!g)return[];break}}if(a===q)if(g==null)m.error(a);else break;q=a}return s},m.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)};var n=m.getText=function(a){var b,c,d=a.nodeType,e="";if(d){if(d===1||d===9||d===11){if(typeof a.textContent=="string")return a.textContent;if(typeof a.innerText=="string")return a.innerText.replace(k,"");for(a=a.firstChild;a;a=a.nextSibling)e+=n(a)}else if(d===3||d===4)return a.nodeValue}else for(b=0;c=a[b];b++)c.nodeType!==8&&(e+=n(c));return e},o=m.selectors={order:["ID","NAME","TAG"],match:{ID:/#((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,CLASS:/\.((?:[\w\u00c0-\uFFFF\-]|\\.)+)/,NAME:/\[name=['"]*((?:[\w\u00c0-\uFFFF\-]|\\.)+)['"]*\]/,ATTR:/\[\s*((?:[\w\u00c0-\uFFFF\-]|\\.)+)\s*(?:(\S?=)\s*(?:(['"])(.*?)\3|(#?(?:[\w\u00c0-\uFFFF\-]|\\.)*)|)|)\s*\]/,TAG:/^((?:[\w\u00c0-\uFFFF\*\-]|\\.)+)/,CHILD:/:(only|nth|last|first)-child(?:\(\s*(even|odd|(?:[+\-]?\d+|(?:[+\-]?\d*)?n\s*(?:[+\-]\s*\d+)?))\s*\))?/,POS:/:(nth|eq|gt|lt|first|last|even|odd)(?:\((\d*)\))?(?=[^\-]|$)/,PSEUDO:/:((?:[\w\u00c0-\uFFFF\-]|\\.)+)(?:\((['"]?)((?:\([^\)]+\)|[^\(\)]*)+)\2\))?/},leftMatch:{},attrMap:{"class":"className","for":"htmlFor"},attrHandle:{href:function(a){return a.getAttribute("href")},type:function(a){return a.getAttribute("type")}},relative:{"+":function(a,b){var c=typeof b=="string",d=c&&!l.test(b),e=c&&!d;d&&(b=b.toLowerCase());for(var f=0,g=a.length,h;f<g;f++)if(h=a[f]){while((h=h.previousSibling)&&h.nodeType!==1);a[f]=e||h&&h.nodeName.toLowerCase()===b?h||!1:h===b}e&&m.filter(b,a,!0)},">":function(a,b){var c,d=typeof b=="string",e=0,f=a.length;if(d&&!l.test(b)){b=b.toLowerCase();for(;e<f;e++){c=a[e];if(c){var g=c.parentNode;a[e]=g.nodeName.toLowerCase()===b?g:!1}}}else{for(;e<f;e++)c=a[e],c&&(a[e]=d?c.parentNode:c.parentNode===b);d&&m.filter(b,a,!0)}},"":function(a,b,c){var d,f=e++,g=x;typeof b=="string"&&!l.test(b)&&(b=b.toLowerCase(),d=b,g=w),g("parentNode",b,f,a,d,c)},"~":function(a,b,c){var d,f=e++,g=x;typeof b=="string"&&!l.test(b)&&(b=b.toLowerCase(),d=b,g=w),g("previousSibling",b,f,a,d,c)}},find:{ID:function(a,b,c){if(typeof b.getElementById!="undefined"&&!c){var d=b.getElementById(a[1]);return d&&d.parentNode?[d]:[]}},NAME:function(a,b){if(typeof b.getElementsByName!="undefined"){var c=[],d=b.getElementsByName(a[1]);for(var e=0,f=d.length;e<f;e++)d[e].getAttribute("name")===a[1]&&c.push(d[e]);return c.length===0?null:c}},TAG:function(a,b){if(typeof b.getElementsByTagName!="undefined")return b.getElementsByTagName(a[1])}},preFilter:{CLASS:function(a,b,c,d,e,f){a=" "+a[1].replace(j,"")+" ";if(f)return a;for(var g=0,h;(h=b[g])!=null;g++)h&&(e^(h.className&&(" "+h.className+" ").replace(/[\t\n\r]/g," ").indexOf(a)>=0)?c||d.push(h):c&&(b[g]=!1));return!1},ID:function(a){return a[1].replace(j,"")},TAG:function(a,b){return a[1].replace(j,"").toLowerCase()},CHILD:function(a){if(a[1]==="nth"){a[2]||m.error(a[0]),a[2]=a[2].replace(/^\+|\s*/g,"");var b=/(-?)(\d*)(?:n([+\-]?\d*))?/.exec(a[2]==="even"&&"2n"||a[2]==="odd"&&"2n+1"||!/\D/.test(a[2])&&"0n+"+a[2]||a[2]);a[2]=b[1]+(b[2]||1)-0,a[3]=b[3]-0}else a[2]&&m.error(a[0]);a[0]=e++;return a},ATTR:function(a,b,c,d,e,f){var g=a[1]=a[1].replace(j,"");!f&&o.attrMap[g]&&(a[1]=o.attrMap[g]),a[4]=(a[4]||a[5]||"").replace(j,""),a[2]==="~="&&(a[4]=" "+a[4]+" ");return a},PSEUDO:function(b,c,d,e,f){if(b[1]==="not")if((a.exec(b[3])||"").length>1||/^\w/.test(b[3]))b[3]=m(b[3],null,null,c);else{var g=m.filter(b[3],c,d,!0^f);d||e.push.apply(e,g);return!1}else if(o.match.POS.test(b[0])||o.match.CHILD.test(b[0]))return!0;return b},POS:function(a){a.unshift(!0);return a}},filters:{enabled:function(a){return a.disabled===!1&&a.type!=="hidden"},disabled:function(a){return a.disabled===!0},checked:function(a){return a.checked===!0},selected:function(a){a.parentNode&&a.parentNode.selectedIndex;return a.selected===!0},parent:function(a){return!!a.firstChild},empty:function(a){return!a.firstChild},has:function(a,b,c){return!!m(c[3],a).length},header:function(a){return/h\d/i.test(a.nodeName)},text:function(a){var b=a.getAttribute("type"),c=a.type;return a.nodeName.toLowerCase()==="input"&&"text"===c&&(b===c||b===null)},radio:function(a){return a.nodeName.toLowerCase()==="input"&&"radio"===a.type},checkbox:function(a){return a.nodeName.toLowerCase()==="input"&&"checkbox"===a.type},file:function(a){return a.nodeName.toLowerCase()==="input"&&"file"===a.type},password:function(a){return a.nodeName.toLowerCase()==="input"&&"password"===a.type},submit:function(a){var b=a.nodeName.toLowerCase();return(b==="input"||b==="button")&&"submit"===a.type},image:function(a){return a.nodeName.toLowerCase()==="input"&&"image"===a.type},reset:function(a){var b=a.nodeName.toLowerCase();return(b==="input"||b==="button")&&"reset"===a.type},button:function(a){var b=a.nodeName.toLowerCase();return b==="input"&&"button"===a.type||b==="button"},input:function(a){return/input|select|textarea|button/i.test(a.nodeName)},focus:function(a){return a===a.ownerDocument.activeElement}},setFilters:{first:function(a,b){return b===0},last:function(a,b,c,d){return b===d.length-1},even:function(a,b){return b%2===0},odd:function(a,b){return b%2===1},lt:function(a,b,c){return b<c[3]-0},gt:function(a,b,c){return b>c[3]-0},nth:function(a,b,c){return c[3]-0===b},eq:function(a,b,c){return c[3]-0===b}},filter:{PSEUDO:function(a,b,c,d){var e=b[1],f=o.filters[e];if(f)return f(a,c,b,d);if(e==="contains")return(a.textContent||a.innerText||n([a])||"").indexOf(b[3])>=0;if(e==="not"){var g=b[3];for(var h=0,i=g.length;h<i;h++)if(g[h]===a)return!1;return!0}m.error(e)},CHILD:function(a,b){var c,e,f,g,h,i,j,k=b[1],l=a;switch(k){case"only":case"first":while(l=l.previousSibling)if(l.nodeType===1)return!1;if(k==="first")return!0;l=a;case"last":while(l=l.nextSibling)if(l.nodeType===1)return!1;return!0;case"nth":c=b[2],e=b[3];if(c===1&&e===0)return!0;f=b[0],g=a.parentNode;if(g&&(g[d]!==f||!a.nodeIndex)){i=0;for(l=g.firstChild;l;l=l.nextSibling)l.nodeType===1&&(l.nodeIndex=++i);g[d]=f}j=a.nodeIndex-e;return c===0?j===0:j%c===0&&j/c>=0}},ID:function(a,b){return a.nodeType===1&&a.getAttribute("id")===b},TAG:function(a,b){return b==="*"&&a.nodeType===1||!!a.nodeName&&a.nodeName.toLowerCase()===b},CLASS:function(a,b){return(" "+(a.className||a.getAttribute("class"))+" ").indexOf(b)>-1},ATTR:function(a,b){var c=b[1],d=m.attr?m.attr(a,c):o.attrHandle[c]?o.attrHandle[c](a):a[c]!=null?a[c]:a.getAttribute(c),e=d+"",f=b[2],g=b[4];return d==null?f==="!=":!f&&m.attr?d!=null:f==="="?e===g:f==="*="?e.indexOf(g)>=0:f==="~="?(" "+e+" ").indexOf(g)>=0:g?f==="!="?e!==g:f==="^="?e.indexOf(g)===0:f==="$="?e.substr(e.length-g.length)===g:f==="|="?e===g||e.substr(0,g.length+1)===g+"-":!1:e&&d!==!1},POS:function(a,b,c,d){var e=b[2],f=o.setFilters[e];if(f)return f(a,c,b,d)}}},p=o.match.POS,q=function(a,b){return"\\"+(b-0+1)};for(var r in o.match)o.match[r]=new RegExp(o.match[r].source+/(?![^\[]*\])(?![^\(]*\))/.source),o.leftMatch[r]=new RegExp(/(^(?:.|\r|\n)*?)/.source+o.match[r].source.replace(/\\(\d+)/g,q));o.match.globalPOS=p;var s=function(a,b){a=Array.prototype.slice.call(a,0);if(b){b.push.apply(b,a);return b}return a};try{Array.prototype.slice.call(c.documentElement.childNodes,0)[0].nodeType}catch(t){s=function(a,b){var c=0,d=b||[];if(g.call(a)==="[object Array]")Array.prototype.push.apply(d,a);else if(typeof a.length=="number")for(var e=a.length;c<e;c++)d.push(a[c]);else for(;a[c];c++)d.push(a[c]);return d}}var u,v;c.documentElement.compareDocumentPosition?u=function(a,b){if(a===b){h=!0;return 0}if(!a.compareDocumentPosition||!b.compareDocumentPosition)return a.compareDocumentPosition?-1:1;return a.compareDocumentPosition(b)&4?-1:1}:(u=function(a,b){if(a===b){h=!0;return 0}if(a.sourceIndex&&b.sourceIndex)return a.sourceIndex-b.sourceIndex;var c,d,e=[],f=[],g=a.parentNode,i=b.parentNode,j=g;if(g===i)return v(a,b);if(!g)return-1;if(!i)return 1;while(j)e.unshift(j),j=j.parentNode;j=i;while(j)f.unshift(j),j=j.parentNode;c=e.length,d=f.length;for(var k=0;k<c&&k<d;k++)if(e[k]!==f[k])return v(e[k],f[k]);return k===c?v(a,f[k],-1):v(e[k],b,1)},v=function(a,b,c){if(a===b)return c;var d=a.nextSibling;while(d){if(d===b)return-1;d=d.nextSibling}return 1}),function(){var a=c.createElement("div"),d="script"+(new Date).getTime(),e=c.documentElement;a.innerHTML="<a name='"+d+"'/>",e.insertBefore(a,e.firstChild),c.getElementById(d)&&(o.find.ID=function(a,c,d){if(typeof c.getElementById!="undefined"&&!d){var e=c.getElementById(a[1]);return e?e.id===a[1]||typeof e.getAttributeNode!="undefined"&&e.getAttributeNode("id").nodeValue===a[1]?[e]:b:[]}},o.filter.ID=function(a,b){var c=typeof a.getAttributeNode!="undefined"&&a.getAttributeNode("id");return a.nodeType===1&&c&&c.nodeValue===b}),e.removeChild(a),e=a=null}(),function(){var a=c.createElement("div");a.appendChild(c.createComment("")),a.getElementsByTagName("*").length>0&&(o.find.TAG=function(a,b){var c=b.getElementsByTagName(a[1]);if(a[1]==="*"){var d=[];for(var e=0;c[e];e++)c[e].nodeType===1&&d.push(c[e]);c=d}return c}),a.innerHTML="<a href='#'></a>",a.firstChild&&typeof a.firstChild.getAttribute!="undefined"&&a.firstChild.getAttribute("href")!=="#"&&(o.attrHandle.href=function(a){return a.getAttribute("href",2)}),a=null}(),c.querySelectorAll&&function(){var a=m,b=c.createElement("div"),d="__sizzle__";b.innerHTML="<p class='TEST'></p>";if(!b.querySelectorAll||b.querySelectorAll(".TEST").length!==0){m=function(b,e,f,g){e=e||c;if(!g&&!m.isXML(e)){var h=/^(\w+$)|^\.([\w\-]+$)|^#([\w\-]+$)/.exec(b);if(h&&(e.nodeType===1||e.nodeType===9)){if(h[1])return s(e.getElementsByTagName(b),f);if(h[2]&&o.find.CLASS&&e.getElementsByClassName)return s(e.getElementsByClassName(h[2]),f)}if(e.nodeType===9){if(b==="body"&&e.body)return s([e.body],f);if(h&&h[3]){var i=e.getElementById(h[3]);if(!i||!i.parentNode)return s([],f);if(i.id===h[3])return s([i],f)}try{return s(e.querySelectorAll(b),f)}catch(j){}}else if(e.nodeType===1&&e.nodeName.toLowerCase()!=="object"){var k=e,l=e.getAttribute("id"),n=l||d,p=e.parentNode,q=/^\s*[+~]/.test(b);l?n=n.replace(/'/g,"\\$&"):e.setAttribute("id",n),q&&p&&(e=e.parentNode);try{if(!q||p)return s(e.querySelectorAll("[id='"+n+"'] "+b),f)}catch(r){}finally{l||k.removeAttribute("id")}}}return a(b,e,f,g)};for(var e in a)m[e]=a[e];b=null}}(),function(){var a=c.documentElement,b=a.matchesSelector||a.mozMatchesSelector||a.webkitMatchesSelector||a.msMatchesSelector;if(b){var d=!b.call(c.createElement("div"),"div"),e=!1;try{b.call(c.documentElement,"[test!='']:sizzle")}catch(f){e=!0}m.matchesSelector=function(a,c){c=c.replace(/\=\s*([^'"\]]*)\s*\]/g,"='$1']");if(!m.isXML(a))try{if(e||!o.match.PSEUDO.test(c)&&!/!=/.test(c)){var f=b.call(a,c);if(f||!d||a.document&&a.document.nodeType!==11)return f}}catch(g){}return m(c,null,null,[a]).length>0}}}(),function(){var a=c.createElement("div");a.innerHTML="<div class='test e'></div><div class='test'></div>";if(!!a.getElementsByClassName&&a.getElementsByClassName("e").length!==0){a.lastChild.className="e";if(a.getElementsByClassName("e").length===1)return;o.order.splice(1,0,"CLASS"),o.find.CLASS=function(a,b,c){if(typeof b.getElementsByClassName!="undefined"&&!c)return b.getElementsByClassName(a[1])},a=null}}(),c.documentElement.contains?m.contains=function(a,b){return a!==b&&(a.contains?a.contains(b):!0)}:c.documentElement.compareDocumentPosition?m.contains=function(a,b){return!!(a.compareDocumentPosition(b)&16)}:m.contains=function(){return!1},m.isXML=function(a){var b=(a?a.ownerDocument||a:0).documentElement;return b?b.nodeName!=="HTML":!1};var y=function(a,b,c){var d,e=[],f="",g=b.nodeType?[b]:b;while(d=o.match.PSEUDO.exec(a))f+=d[0],a=a.replace(o.match.PSEUDO,"");a=o.relative[a]?a+"*":a;for(var h=0,i=g.length;h<i;h++)m(a,g[h],e,c);return m.filter(f,e)};m.attr=f.attr,m.selectors.attrMap={},f.find=m,f.expr=m.selectors,f.expr[":"]=f.expr.filters,f.unique=m.uniqueSort,f.text=m.getText,f.isXMLDoc=m.isXML,f.contains=m.contains}();var L=/Until$/,M=/^(?:parents|prevUntil|prevAll)/,N=/,/,O=/^.[^:#\[\.,]*$/,P=Array.prototype.slice,Q=f.expr.match.globalPOS,R={children:!0,contents:!0,next:!0,prev:!0};f.fn.extend({find:function(a){var b=this,c,d;if(typeof a!="string")return f(a).filter(function(){for(c=0,d=b.length;c<d;c++)if(f.contains(b[c],this))return!0});var e=this.pushStack("","find",a),g,h,i;for(c=0,d=this.length;c<d;c++){g=e.length,f.find(a,this[c],e);if(c>0)for(h=g;h<e.length;h++)for(i=0;i<g;i++)if(e[i]===e[h]){e.splice(h--,1);break}}return e},has:function(a){var b=f(a);return this.filter(function(){for(var a=0,c=b.length;a<c;a++)if(f.contains(this,b[a]))return!0})},not:function(a){return this.pushStack(T(this,a,!1),"not",a)},filter:function(a){return this.pushStack(T(this,a,!0),"filter",a)},is:function(a){return!!a&&(typeof a=="string"?Q.test(a)?f(a,this.context).index(this[0])>=0:f.filter(a,this).length>0:this.filter(a).length>0)},closest:function(a,b){var c=[],d,e,g=this[0];if(f.isArray(a)){var h=1;while(g&&g.ownerDocument&&g!==b){for(d=0;d<a.length;d++)f(g).is(a[d])&&c.push({selector:a[d],elem:g,level:h});g=g.parentNode,h++}return c}var i=Q.test(a)||typeof a!="string"?f(a,b||this.context):0;for(d=0,e=this.length;d<e;d++){g=this[d];while(g){if(i?i.index(g)>-1:f.find.matchesSelector(g,a)){c.push(g);break}g=g.parentNode;if(!g||!g.ownerDocument||g===b||g.nodeType===11)break}}c=c.length>1?f.unique(c):c;return this.pushStack(c,"closest",a)},index:function(a){if(!a)return this[0]&&this[0].parentNode?this.prevAll().length:-1;if(typeof a=="string")return f.inArray(this[0],f(a));return f.inArray(a.jquery?a[0]:a,this)},add:function(a,b){var c=typeof a=="string"?f(a,b):f.makeArray(a&&a.nodeType?[a]:a),d=f.merge(this.get(),c);return this.pushStack(S(c[0])||S(d[0])?d:f.unique(d))},andSelf:function(){return this.add(this.prevObject)}}),f.each({parent:function(a){var b=a.parentNode;return b&&b.nodeType!==11?b:null},parents:function(a){return f.dir(a,"parentNode")},parentsUntil:function(a,b,c){return f.dir(a,"parentNode",c)},next:function(a){return f.nth(a,2,"nextSibling")},prev:function(a){return f.nth(a,2,"previousSibling")},nextAll:function(a){return f.dir(a,"nextSibling")},prevAll:function(a){return f.dir(a,"previousSibling")},nextUntil:function(a,b,c){return f.dir(a,"nextSibling",c)},prevUntil:function(a,b,c){return f.dir(a,"previousSibling",c)},siblings:function(a){return f.sibling((a.parentNode||{}).firstChild,a)},children:function(a){return f.sibling(a.firstChild)},contents:function(a){return f.nodeName(a,"iframe")?a.contentDocument||a.contentWindow.document:f.makeArray(a.childNodes)}},function(a,b){f.fn[a]=function(c,d){var e=f.map(this,b,c);L.test(a)||(d=c),d&&typeof d=="string"&&(e=f.filter(d,e)),e=this.length>1&&!R[a]?f.unique(e):e,(this.length>1||N.test(d))&&M.test(a)&&(e=e.reverse());return this.pushStack(e,a,P.call(arguments).join(","))}}),f.extend({filter:function(a,b,c){c&&(a=":not("+a+")");return b.length===1?f.find.matchesSelector(b[0],a)?[b[0]]:[]:f.find.matches(a,b)},dir:function(a,c,d){var e=[],g=a[c];while(g&&g.nodeType!==9&&(d===b||g.nodeType!==1||!f(g).is(d)))g.nodeType===1&&e.push(g),g=g[c];return e},nth:function(a,b,c,d){b=b||1;var e=0;for(;a;a=a[c])if(a.nodeType===1&&++e===b)break;return a},sibling:function(a,b){var c=[];for(;a;a=a.nextSibling)a.nodeType===1&&a!==b&&c.push(a);return c}});var V="abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",W=/ jQuery\d+="(?:\d+|null)"/g,X=/^\s+/,Y=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/ig,Z=/<([\w:]+)/,$=/<tbody/i,_=/<|&#?\w+;/,ba=/<(?:script|style)/i,bb=/<(?:script|object|embed|option|style)/i,bc=new RegExp("<(?:"+V+")[\\s/>]","i"),bd=/checked\s*(?:[^=]|=\s*.checked.)/i,be=/\/(java|ecma)script/i,bf=/^\s*<!(?:\[CDATA\[|\-\-)/,bg={option:[1,"<select multiple='multiple'>","</select>"],legend:[1,"<fieldset>","</fieldset>"],thead:[1,"<table>","</table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],area:[1,"<map>","</map>"],_default:[0,"",""]},bh=U(c);bg.optgroup=bg.option,bg.tbody=bg.tfoot=bg.colgroup=bg.caption=bg.thead,bg.th=bg.td,f.support.htmlSerialize||(bg._default=[1,"div<div>","</div>"]),f.fn.extend({text:function(a){return f.access(this,function(a){return a===b?f.text(this):this.empty().append((this[0]&&this[0].ownerDocument||c).createTextNode(a))},null,a,arguments.length)},wrapAll:function(a){if(f.isFunction(a))return this.each(function(b){f(this).wrapAll(a.call(this,b))});if(this[0]){var b=f(a,this[0].ownerDocument).eq(0).clone(!0);this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstChild&&a.firstChild.nodeType===1)a=a.firstChild;return a}).append(this)}return this},wrapInner:function(a){if(f.isFunction(a))return this.each(function(b){f(this).wrapInner(a.call(this,b))});return this.each(function(){var b=f(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=f.isFunction(a);return this.each(function(c){f(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(){return this.parent().each(function(){f.nodeName(this,"body")||f(this).replaceWith(this.childNodes)}).end()},append:function(){return this.domManip(arguments,!0,function(a){this.nodeType===1&&this.appendChild(a)})},prepend:function(){return this.domManip(arguments,!0,function(a){this.nodeType===1&&this.insertBefore(a,this.firstChild)})},before:function(){if(this[0]&&this[0].parentNode)return this.domManip(arguments,!1,function(a){this.parentNode.insertBefore(a,this)});if(arguments.length){var a=f
.clean(arguments);a.push.apply(a,this.toArray());return this.pushStack(a,"before",arguments)}},after:function(){if(this[0]&&this[0].parentNode)return this.domManip(arguments,!1,function(a){this.parentNode.insertBefore(a,this.nextSibling)});if(arguments.length){var a=this.pushStack(this,"after",arguments);a.push.apply(a,f.clean(arguments));return a}},remove:function(a,b){for(var c=0,d;(d=this[c])!=null;c++)if(!a||f.filter(a,[d]).length)!b&&d.nodeType===1&&(f.cleanData(d.getElementsByTagName("*")),f.cleanData([d])),d.parentNode&&d.parentNode.removeChild(d);return this},empty:function(){for(var a=0,b;(b=this[a])!=null;a++){b.nodeType===1&&f.cleanData(b.getElementsByTagName("*"));while(b.firstChild)b.removeChild(b.firstChild)}return this},clone:function(a,b){a=a==null?!1:a,b=b==null?a:b;return this.map(function(){return f.clone(this,a,b)})},html:function(a){return f.access(this,function(a){var c=this[0]||{},d=0,e=this.length;if(a===b)return c.nodeType===1?c.innerHTML.replace(W,""):null;if(typeof a=="string"&&!ba.test(a)&&(f.support.leadingWhitespace||!X.test(a))&&!bg[(Z.exec(a)||["",""])[1].toLowerCase()]){a=a.replace(Y,"<$1></$2>");try{for(;d<e;d++)c=this[d]||{},c.nodeType===1&&(f.cleanData(c.getElementsByTagName("*")),c.innerHTML=a);c=0}catch(g){}}c&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(a){if(this[0]&&this[0].parentNode){if(f.isFunction(a))return this.each(function(b){var c=f(this),d=c.html();c.replaceWith(a.call(this,b,d))});typeof a!="string"&&(a=f(a).detach());return this.each(function(){var b=this.nextSibling,c=this.parentNode;f(this).remove(),b?f(b).before(a):f(c).append(a)})}return this.length?this.pushStack(f(f.isFunction(a)?a():a),"replaceWith",a):this},detach:function(a){return this.remove(a,!0)},domManip:function(a,c,d){var e,g,h,i,j=a[0],k=[];if(!f.support.checkClone&&arguments.length===3&&typeof j=="string"&&bd.test(j))return this.each(function(){f(this).domManip(a,c,d,!0)});if(f.isFunction(j))return this.each(function(e){var g=f(this);a[0]=j.call(this,e,c?g.html():b),g.domManip(a,c,d)});if(this[0]){i=j&&j.parentNode,f.support.parentNode&&i&&i.nodeType===11&&i.childNodes.length===this.length?e={fragment:i}:e=f.buildFragment(a,this,k),h=e.fragment,h.childNodes.length===1?g=h=h.firstChild:g=h.firstChild;if(g){c=c&&f.nodeName(g,"tr");for(var l=0,m=this.length,n=m-1;l<m;l++)d.call(c?bi(this[l],g):this[l],e.cacheable||m>1&&l<n?f.clone(h,!0,!0):h)}k.length&&f.each(k,function(a,b){b.src?f.ajax({type:"GET",global:!1,url:b.src,async:!1,dataType:"script"}):f.globalEval((b.text||b.textContent||b.innerHTML||"").replace(bf,"/*$0*/")),b.parentNode&&b.parentNode.removeChild(b)})}return this}}),f.buildFragment=function(a,b,d){var e,g,h,i,j=a[0];b&&b[0]&&(i=b[0].ownerDocument||b[0]),i.createDocumentFragment||(i=c),a.length===1&&typeof j=="string"&&j.length<512&&i===c&&j.charAt(0)==="<"&&!bb.test(j)&&(f.support.checkClone||!bd.test(j))&&(f.support.html5Clone||!bc.test(j))&&(g=!0,h=f.fragments[j],h&&h!==1&&(e=h)),e||(e=i.createDocumentFragment(),f.clean(a,i,e,d)),g&&(f.fragments[j]=h?e:1);return{fragment:e,cacheable:g}},f.fragments={},f.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){f.fn[a]=function(c){var d=[],e=f(c),g=this.length===1&&this[0].parentNode;if(g&&g.nodeType===11&&g.childNodes.length===1&&e.length===1){e[b](this[0]);return this}for(var h=0,i=e.length;h<i;h++){var j=(h>0?this.clone(!0):this).get();f(e[h])[b](j),d=d.concat(j)}return this.pushStack(d,a,e.selector)}}),f.extend({clone:function(a,b,c){var d,e,g,h=f.support.html5Clone||f.isXMLDoc(a)||!bc.test("<"+a.nodeName+">")?a.cloneNode(!0):bo(a);if((!f.support.noCloneEvent||!f.support.noCloneChecked)&&(a.nodeType===1||a.nodeType===11)&&!f.isXMLDoc(a)){bk(a,h),d=bl(a),e=bl(h);for(g=0;d[g];++g)e[g]&&bk(d[g],e[g])}if(b){bj(a,h);if(c){d=bl(a),e=bl(h);for(g=0;d[g];++g)bj(d[g],e[g])}}d=e=null;return h},clean:function(a,b,d,e){var g,h,i,j=[];b=b||c,typeof b.createElement=="undefined"&&(b=b.ownerDocument||b[0]&&b[0].ownerDocument||c);for(var k=0,l;(l=a[k])!=null;k++){typeof l=="number"&&(l+="");if(!l)continue;if(typeof l=="string")if(!_.test(l))l=b.createTextNode(l);else{l=l.replace(Y,"<$1></$2>");var m=(Z.exec(l)||["",""])[1].toLowerCase(),n=bg[m]||bg._default,o=n[0],p=b.createElement("div"),q=bh.childNodes,r;b===c?bh.appendChild(p):U(b).appendChild(p),p.innerHTML=n[1]+l+n[2];while(o--)p=p.lastChild;if(!f.support.tbody){var s=$.test(l),t=m==="table"&&!s?p.firstChild&&p.firstChild.childNodes:n[1]==="<table>"&&!s?p.childNodes:[];for(i=t.length-1;i>=0;--i)f.nodeName(t[i],"tbody")&&!t[i].childNodes.length&&t[i].parentNode.removeChild(t[i])}!f.support.leadingWhitespace&&X.test(l)&&p.insertBefore(b.createTextNode(X.exec(l)[0]),p.firstChild),l=p.childNodes,p&&(p.parentNode.removeChild(p),q.length>0&&(r=q[q.length-1],r&&r.parentNode&&r.parentNode.removeChild(r)))}var u;if(!f.support.appendChecked)if(l[0]&&typeof (u=l.length)=="number")for(i=0;i<u;i++)bn(l[i]);else bn(l);l.nodeType?j.push(l):j=f.merge(j,l)}if(d){g=function(a){return!a.type||be.test(a.type)};for(k=0;j[k];k++){h=j[k];if(e&&f.nodeName(h,"script")&&(!h.type||be.test(h.type)))e.push(h.parentNode?h.parentNode.removeChild(h):h);else{if(h.nodeType===1){var v=f.grep(h.getElementsByTagName("script"),g);j.splice.apply(j,[k+1,0].concat(v))}d.appendChild(h)}}}return j},cleanData:function(a){var b,c,d=f.cache,e=f.event.special,g=f.support.deleteExpando;for(var h=0,i;(i=a[h])!=null;h++){if(i.nodeName&&f.noData[i.nodeName.toLowerCase()])continue;c=i[f.expando];if(c){b=d[c];if(b&&b.events){for(var j in b.events)e[j]?f.event.remove(i,j):f.removeEvent(i,j,b.handle);b.handle&&(b.handle.elem=null)}g?delete i[f.expando]:i.removeAttribute&&i.removeAttribute(f.expando),delete d[c]}}}});var bp=/alpha\([^)]*\)/i,bq=/opacity=([^)]*)/,br=/([A-Z]|^ms)/g,bs=/^[\-+]?(?:\d*\.)?\d+$/i,bt=/^-?(?:\d*\.)?\d+(?!px)[^\d\s]+$/i,bu=/^([\-+])=([\-+.\de]+)/,bv=/^margin/,bw={position:"absolute",visibility:"hidden",display:"block"},bx=["Top","Right","Bottom","Left"],by,bz,bA;f.fn.css=function(a,c){return f.access(this,function(a,c,d){return d!==b?f.style(a,c,d):f.css(a,c)},a,c,arguments.length>1)},f.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=by(a,"opacity");return c===""?"1":c}return a.style.opacity}}},cssNumber:{fillOpacity:!0,fontWeight:!0,lineHeight:!0,opacity:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":f.support.cssFloat?"cssFloat":"styleFloat"},style:function(a,c,d,e){if(!!a&&a.nodeType!==3&&a.nodeType!==8&&!!a.style){var g,h,i=f.camelCase(c),j=a.style,k=f.cssHooks[i];c=f.cssProps[i]||i;if(d===b){if(k&&"get"in k&&(g=k.get(a,!1,e))!==b)return g;return j[c]}h=typeof d,h==="string"&&(g=bu.exec(d))&&(d=+(g[1]+1)*+g[2]+parseFloat(f.css(a,c)),h="number");if(d==null||h==="number"&&isNaN(d))return;h==="number"&&!f.cssNumber[i]&&(d+="px");if(!k||!("set"in k)||(d=k.set(a,d))!==b)try{j[c]=d}catch(l){}}},css:function(a,c,d){var e,g;c=f.camelCase(c),g=f.cssHooks[c],c=f.cssProps[c]||c,c==="cssFloat"&&(c="float");if(g&&"get"in g&&(e=g.get(a,!0,d))!==b)return e;if(by)return by(a,c)},swap:function(a,b,c){var d={},e,f;for(f in b)d[f]=a.style[f],a.style[f]=b[f];e=c.call(a);for(f in b)a.style[f]=d[f];return e}}),f.curCSS=f.css,c.defaultView&&c.defaultView.getComputedStyle&&(bz=function(a,b){var c,d,e,g,h=a.style;b=b.replace(br,"-$1").toLowerCase(),(d=a.ownerDocument.defaultView)&&(e=d.getComputedStyle(a,null))&&(c=e.getPropertyValue(b),c===""&&!f.contains(a.ownerDocument.documentElement,a)&&(c=f.style(a,b))),!f.support.pixelMargin&&e&&bv.test(b)&&bt.test(c)&&(g=h.width,h.width=c,c=e.width,h.width=g);return c}),c.documentElement.currentStyle&&(bA=function(a,b){var c,d,e,f=a.currentStyle&&a.currentStyle[b],g=a.style;f==null&&g&&(e=g[b])&&(f=e),bt.test(f)&&(c=g.left,d=a.runtimeStyle&&a.runtimeStyle.left,d&&(a.runtimeStyle.left=a.currentStyle.left),g.left=b==="fontSize"?"1em":f,f=g.pixelLeft+"px",g.left=c,d&&(a.runtimeStyle.left=d));return f===""?"auto":f}),by=bz||bA,f.each(["height","width"],function(a,b){f.cssHooks[b]={get:function(a,c,d){if(c)return a.offsetWidth!==0?bB(a,b,d):f.swap(a,bw,function(){return bB(a,b,d)})},set:function(a,b){return bs.test(b)?b+"px":b}}}),f.support.opacity||(f.cssHooks.opacity={get:function(a,b){return bq.test((b&&a.currentStyle?a.currentStyle.filter:a.style.filter)||"")?parseFloat(RegExp.$1)/100+"":b?"1":""},set:function(a,b){var c=a.style,d=a.currentStyle,e=f.isNumeric(b)?"alpha(opacity="+b*100+")":"",g=d&&d.filter||c.filter||"";c.zoom=1;if(b>=1&&f.trim(g.replace(bp,""))===""){c.removeAttribute("filter");if(d&&!d.filter)return}c.filter=bp.test(g)?g.replace(bp,e):g+" "+e}}),f(function(){f.support.reliableMarginRight||(f.cssHooks.marginRight={get:function(a,b){return f.swap(a,{display:"inline-block"},function(){return b?by(a,"margin-right"):a.style.marginRight})}})}),f.expr&&f.expr.filters&&(f.expr.filters.hidden=function(a){var b=a.offsetWidth,c=a.offsetHeight;return b===0&&c===0||!f.support.reliableHiddenOffsets&&(a.style&&a.style.display||f.css(a,"display"))==="none"},f.expr.filters.visible=function(a){return!f.expr.filters.hidden(a)}),f.each({margin:"",padding:"",border:"Width"},function(a,b){f.cssHooks[a+b]={expand:function(c){var d,e=typeof c=="string"?c.split(" "):[c],f={};for(d=0;d<4;d++)f[a+bx[d]+b]=e[d]||e[d-2]||e[0];return f}}});var bC=/%20/g,bD=/\[\]$/,bE=/\r?\n/g,bF=/#.*$/,bG=/^(.*?):[ \t]*([^\r\n]*)\r?$/mg,bH=/^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i,bI=/^(?:about|app|app\-storage|.+\-extension|file|res|widget):$/,bJ=/^(?:GET|HEAD)$/,bK=/^\/\//,bL=/\?/,bM=/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,bN=/^(?:select|textarea)/i,bO=/\s+/,bP=/([?&])_=[^&]*/,bQ=/^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+))?)?/,bR=f.fn.load,bS={},bT={},bU,bV,bW=["*/"]+["*"];try{bU=e.href}catch(bX){bU=c.createElement("a"),bU.href="",bU=bU.href}bV=bQ.exec(bU.toLowerCase())||[],f.fn.extend({load:function(a,c,d){if(typeof a!="string"&&bR)return bR.apply(this,arguments);if(!this.length)return this;var e=a.indexOf(" ");if(e>=0){var g=a.slice(e,a.length);a=a.slice(0,e)}var h="GET";c&&(f.isFunction(c)?(d=c,c=b):typeof c=="object"&&(c=f.param(c,f.ajaxSettings.traditional),h="POST"));var i=this;f.ajax({url:a,type:h,dataType:"html",data:c,complete:function(a,b,c){c=a.responseText,a.isResolved()&&(a.done(function(a){c=a}),i.html(g?f("<div>").append(c.replace(bM,"")).find(g):c)),d&&i.each(d,[c,b,a])}});return this},serialize:function(){return f.param(this.serializeArray())},serializeArray:function(){return this.map(function(){return this.elements?f.makeArray(this.elements):this}).filter(function(){return this.name&&!this.disabled&&(this.checked||bN.test(this.nodeName)||bH.test(this.type))}).map(function(a,b){var c=f(this).val();return c==null?null:f.isArray(c)?f.map(c,function(a,c){return{name:b.name,value:a.replace(bE,"\r\n")}}):{name:b.name,value:c.replace(bE,"\r\n")}}).get()}}),f.each("ajaxStart ajaxStop ajaxComplete ajaxError ajaxSuccess ajaxSend".split(" "),function(a,b){f.fn[b]=function(a){return this.on(b,a)}}),f.each(["get","post"],function(a,c){f[c]=function(a,d,e,g){f.isFunction(d)&&(g=g||e,e=d,d=b);return f.ajax({type:c,url:a,data:d,success:e,dataType:g})}}),f.extend({getScript:function(a,c){return f.get(a,b,c,"script")},getJSON:function(a,b,c){return f.get(a,b,c,"json")},ajaxSetup:function(a,b){b?b$(a,f.ajaxSettings):(b=a,a=f.ajaxSettings),b$(a,b);return a},ajaxSettings:{url:bU,isLocal:bI.test(bV[1]),global:!0,type:"GET",contentType:"application/x-www-form-urlencoded; charset=UTF-8",processData:!0,async:!0,accepts:{xml:"application/xml, text/xml",html:"text/html",text:"text/plain",json:"application/json, text/javascript","*":bW},contents:{xml:/xml/,html:/html/,json:/json/},responseFields:{xml:"responseXML",text:"responseText"},converters:{"* text":a.String,"text html":!0,"text json":f.parseJSON,"text xml":f.parseXML},flatOptions:{context:!0,url:!0}},ajaxPrefilter:bY(bS),ajaxTransport:bY(bT),ajax:function(a,c){function w(a,c,l,m){if(s!==2){s=2,q&&clearTimeout(q),p=b,n=m||"",v.readyState=a>0?4:0;var o,r,u,w=c,x=l?ca(d,v,l):b,y,z;if(a>=200&&a<300||a===304){if(d.ifModified){if(y=v.getResponseHeader("Last-Modified"))f.lastModified[k]=y;if(z=v.getResponseHeader("Etag"))f.etag[k]=z}if(a===304)w="notmodified",o=!0;else try{r=cb(d,x),w="success",o=!0}catch(A){w="parsererror",u=A}}else{u=w;if(!w||a)w="error",a<0&&(a=0)}v.status=a,v.statusText=""+(c||w),o?h.resolveWith(e,[r,w,v]):h.rejectWith(e,[v,w,u]),v.statusCode(j),j=b,t&&g.trigger("ajax"+(o?"Success":"Error"),[v,d,o?r:u]),i.fireWith(e,[v,w]),t&&(g.trigger("ajaxComplete",[v,d]),--f.active||f.event.trigger("ajaxStop"))}}typeof a=="object"&&(c=a,a=b),c=c||{};var d=f.ajaxSetup({},c),e=d.context||d,g=e!==d&&(e.nodeType||e instanceof f)?f(e):f.event,h=f.Deferred(),i=f.Callbacks("once memory"),j=d.statusCode||{},k,l={},m={},n,o,p,q,r,s=0,t,u,v={readyState:0,setRequestHeader:function(a,b){if(!s){var c=a.toLowerCase();a=m[c]=m[c]||a,l[a]=b}return this},getAllResponseHeaders:function(){return s===2?n:null},getResponseHeader:function(a){var c;if(s===2){if(!o){o={};while(c=bG.exec(n))o[c[1].toLowerCase()]=c[2]}c=o[a.toLowerCase()]}return c===b?null:c},overrideMimeType:function(a){s||(d.mimeType=a);return this},abort:function(a){a=a||"abort",p&&p.abort(a),w(0,a);return this}};h.promise(v),v.success=v.done,v.error=v.fail,v.complete=i.add,v.statusCode=function(a){if(a){var b;if(s<2)for(b in a)j[b]=[j[b],a[b]];else b=a[v.status],v.then(b,b)}return this},d.url=((a||d.url)+"").replace(bF,"").replace(bK,bV[1]+"//"),d.dataTypes=f.trim(d.dataType||"*").toLowerCase().split(bO),d.crossDomain==null&&(r=bQ.exec(d.url.toLowerCase()),d.crossDomain=!(!r||r[1]==bV[1]&&r[2]==bV[2]&&(r[3]||(r[1]==="http:"?80:443))==(bV[3]||(bV[1]==="http:"?80:443)))),d.data&&d.processData&&typeof d.data!="string"&&(d.data=f.param(d.data,d.traditional)),bZ(bS,d,c,v);if(s===2)return!1;t=d.global,d.type=d.type.toUpperCase(),d.hasContent=!bJ.test(d.type),t&&f.active++===0&&f.event.trigger("ajaxStart");if(!d.hasContent){d.data&&(d.url+=(bL.test(d.url)?"&":"?")+d.data,delete d.data),k=d.url;if(d.cache===!1){var x=f.now(),y=d.url.replace(bP,"$1_="+x);d.url=y+(y===d.url?(bL.test(d.url)?"&":"?")+"_="+x:"")}}(d.data&&d.hasContent&&d.contentType!==!1||c.contentType)&&v.setRequestHeader("Content-Type",d.contentType),d.ifModified&&(k=k||d.url,f.lastModified[k]&&v.setRequestHeader("If-Modified-Since",f.lastModified[k]),f.etag[k]&&v.setRequestHeader("If-None-Match",f.etag[k])),v.setRequestHeader("Accept",d.dataTypes[0]&&d.accepts[d.dataTypes[0]]?d.accepts[d.dataTypes[0]]+(d.dataTypes[0]!=="*"?", "+bW+"; q=0.01":""):d.accepts["*"]);for(u in d.headers)v.setRequestHeader(u,d.headers[u]);if(d.beforeSend&&(d.beforeSend.call(e,v,d)===!1||s===2)){v.abort();return!1}for(u in{success:1,error:1,complete:1})v[u](d[u]);p=bZ(bT,d,c,v);if(!p)w(-1,"No Transport");else{v.readyState=1,t&&g.trigger("ajaxSend",[v,d]),d.async&&d.timeout>0&&(q=setTimeout(function(){v.abort("timeout")},d.timeout));try{s=1,p.send(l,w)}catch(z){if(s<2)w(-1,z);else throw z}}return v},param:function(a,c){var d=[],e=function(a,b){b=f.isFunction(b)?b():b,d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(b)};c===b&&(c=f.ajaxSettings.traditional);if(f.isArray(a)||a.jquery&&!f.isPlainObject(a))f.each(a,function(){e(this.name,this.value)});else for(var g in a)b_(g,a[g],c,e);return d.join("&").replace(bC,"+")}}),f.extend({active:0,lastModified:{},etag:{}});var cc=f.now(),cd=/(\=)\?(&|$)|\?\?/i;f.ajaxSetup({jsonp:"callback",jsonpCallback:function(){return f.expando+"_"+cc++}}),f.ajaxPrefilter("json jsonp",function(b,c,d){var e=typeof b.data=="string"&&/^application\/x\-www\-form\-urlencoded/.test(b.contentType);if(b.dataTypes[0]==="jsonp"||b.jsonp!==!1&&(cd.test(b.url)||e&&cd.test(b.data))){var g,h=b.jsonpCallback=f.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,i=a[h],j=b.url,k=b.data,l="$1"+h+"$2";b.jsonp!==!1&&(j=j.replace(cd,l),b.url===j&&(e&&(k=k.replace(cd,l)),b.data===k&&(j+=(/\?/.test(j)?"&":"?")+b.jsonp+"="+h))),b.url=j,b.data=k,a[h]=function(a){g=[a]},d.always(function(){a[h]=i,g&&f.isFunction(i)&&a[h](g[0])}),b.converters["script json"]=function(){g||f.error(h+" was not called");return g[0]},b.dataTypes[0]="json";return"script"}}),f.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/javascript|ecmascript/},converters:{"text script":function(a){f.globalEval(a);return a}}}),f.ajaxPrefilter("script",function(a){a.cache===b&&(a.cache=!1),a.crossDomain&&(a.type="GET",a.global=!1)}),f.ajaxTransport("script",function(a){if(a.crossDomain){var d,e=c.head||c.getElementsByTagName("head")[0]||c.documentElement;return{send:function(f,g){d=c.createElement("script"),d.async="async",a.scriptCharset&&(d.charset=a.scriptCharset),d.src=a.url,d.onload=d.onreadystatechange=function(a,c){if(c||!d.readyState||/loaded|complete/.test(d.readyState))d.onload=d.onreadystatechange=null,e&&d.parentNode&&e.removeChild(d),d=b,c||g(200,"success")},e.insertBefore(d,e.firstChild)},abort:function(){d&&d.onload(0,1)}}}});var ce=a.ActiveXObject?function(){for(var a in cg)cg[a](0,1)}:!1,cf=0,cg;f.ajaxSettings.xhr=a.ActiveXObject?function(){return!this.isLocal&&ch()||ci()}:ch,function(a){f.extend(f.support,{ajax:!!a,cors:!!a&&"withCredentials"in a})}(f.ajaxSettings.xhr()),f.support.ajax&&f.ajaxTransport(function(c){if(!c.crossDomain||f.support.cors){var d;return{send:function(e,g){var h=c.xhr(),i,j;c.username?h.open(c.type,c.url,c.async,c.username,c.password):h.open(c.type,c.url,c.async);if(c.xhrFields)for(j in c.xhrFields)h[j]=c.xhrFields[j];c.mimeType&&h.overrideMimeType&&h.overrideMimeType(c.mimeType),!c.crossDomain&&!e["X-Requested-With"]&&(e["X-Requested-With"]="XMLHttpRequest");try{for(j in e)h.setRequestHeader(j,e[j])}catch(k){}h.send(c.hasContent&&c.data||null),d=function(a,e){var j,k,l,m,n;try{if(d&&(e||h.readyState===4)){d=b,i&&(h.onreadystatechange=f.noop,ce&&delete cg[i]);if(e)h.readyState!==4&&h.abort();else{j=h.status,l=h.getAllResponseHeaders(),m={},n=h.responseXML,n&&n.documentElement&&(m.xml=n);try{m.text=h.responseText}catch(a){}try{k=h.statusText}catch(o){k=""}!j&&c.isLocal&&!c.crossDomain?j=m.text?200:404:j===1223&&(j=204)}}}catch(p){e||g(-1,p)}m&&g(j,k,m,l)},!c.async||h.readyState===4?d():(i=++cf,ce&&(cg||(cg={},f(a).unload(ce)),cg[i]=d),h.onreadystatechange=d)},abort:function(){d&&d(0,1)}}}});var cj={},ck,cl,cm=/^(?:toggle|show|hide)$/,cn=/^([+\-]=)?([\d+.\-]+)([a-z%]*)$/i,co,cp=[["height","marginTop","marginBottom","paddingTop","paddingBottom"],["width","marginLeft","marginRight","paddingLeft","paddingRight"],["opacity"]],cq;f.fn.extend({show:function(a,b,c){var d,e;if(a||a===0)return this.animate(ct("show",3),a,b,c);for(var g=0,h=this.length;g<h;g++)d=this[g],d.style&&(e=d.style.display,!f._data(d,"olddisplay")&&e==="none"&&(e=d.style.display=""),(e===""&&f.css(d,"display")==="none"||!f.contains(d.ownerDocument.documentElement,d))&&f._data(d,"olddisplay",cu(d.nodeName)));for(g=0;g<h;g++){d=this[g];if(d.style){e=d.style.display;if(e===""||e==="none")d.style.display=f._data(d,"olddisplay")||""}}return this},hide:function(a,b,c){if(a||a===0)return this.animate(ct("hide",3),a,b,c);var d,e,g=0,h=this.length;for(;g<h;g++)d=this[g],d.style&&(e=f.css(d,"display"),e!=="none"&&!f._data(d,"olddisplay")&&f._data(d,"olddisplay",e));for(g=0;g<h;g++)this[g].style&&(this[g].style.display="none");return this},_toggle:f.fn.toggle,toggle:function(a,b,c){var d=typeof a=="boolean";f.isFunction(a)&&f.isFunction(b)?this._toggle.apply(this,arguments):a==null||d?this.each(function(){var b=d?a:f(this).is(":hidden");f(this)[b?"show":"hide"]()}):this.animate(ct("toggle",3),a,b,c);return this},fadeTo:function(a,b,c,d){return this.filter(":hidden").css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){function g(){e.queue===!1&&f._mark(this);var b=f.extend({},e),c=this.nodeType===1,d=c&&f(this).is(":hidden"),g,h,i,j,k,l,m,n,o,p,q;b.animatedProperties={};for(i in a){g=f.camelCase(i),i!==g&&(a[g]=a[i],delete a[i]);if((k=f.cssHooks[g])&&"expand"in k){l=k.expand(a[g]),delete a[g];for(i in l)i in a||(a[i]=l[i])}}for(g in a){h=a[g],f.isArray(h)?(b.animatedProperties[g]=h[1],h=a[g]=h[0]):b.animatedProperties[g]=b.specialEasing&&b.specialEasing[g]||b.easing||"swing";if(h==="hide"&&d||h==="show"&&!d)return b.complete.call(this);c&&(g==="height"||g==="width")&&(b.overflow=[this.style.overflow,this.style.overflowX,this.style.overflowY],f.css(this,"display")==="inline"&&f.css(this,"float")==="none"&&(!f.support.inlineBlockNeedsLayout||cu(this.nodeName)==="inline"?this.style.display="inline-block":this.style.zoom=1))}b.overflow!=null&&(this.style.overflow="hidden");for(i in a)j=new f.fx(this,b,i),h=a[i],cm.test(h)?(q=f._data(this,"toggle"+i)||(h==="toggle"?d?"show":"hide":0),q?(f._data(this,"toggle"+i,q==="show"?"hide":"show"),j[q]()):j[h]()):(m=cn.exec(h),n=j.cur(),m?(o=parseFloat(m[2]),p=m[3]||(f.cssNumber[i]?"":"px"),p!=="px"&&(f.style(this,i,(o||1)+p),n=(o||1)/j.cur()*n,f.style(this,i,n+p)),m[1]&&(o=(m[1]==="-="?-1:1)*o+n),j.custom(n,o,p)):j.custom(n,h,""));return!0}var e=f.speed(b,c,d);if(f.isEmptyObject(a))return this.each(e.complete,[!1]);a=f.extend({},a);return e.queue===!1?this.each(g):this.queue(e.queue,g)},stop:function(a,c,d){typeof a!="string"&&(d=c,c=a,a=b),c&&a!==!1&&this.queue(a||"fx",[]);return this.each(function(){function h(a,b,c){var e=b[c];f.removeData(a,c,!0),e.stop(d)}var b,c=!1,e=f.timers,g=f._data(this);d||f._unmark(!0,this);if(a==null)for(b in g)g[b]&&g[b].stop&&b.indexOf(".run")===b.length-4&&h(this,g,b);else g[b=a+".run"]&&g[b].stop&&h(this,g,b);for(b=e.length;b--;)e[b].elem===this&&(a==null||e[b].queue===a)&&(d?e[b](!0):e[b].saveState(),c=!0,e.splice(b,1));(!d||!c)&&f.dequeue(this,a)})}}),f.each({slideDown:ct("show",1),slideUp:ct("hide",1),slideToggle:ct("toggle",1),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){f.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),f.extend({speed:function(a,b,c){var d=a&&typeof a=="object"?f.extend({},a):{complete:c||!c&&b||f.isFunction(a)&&a,duration:a,easing:c&&b||b&&!f.isFunction(b)&&b};d.duration=f.fx.off?0:typeof d.duration=="number"?d.duration:d.duration in f.fx.speeds?f.fx.speeds[d.duration]:f.fx.speeds._default;if(d.queue==null||d.queue===!0)d.queue="fx";d.old=d.complete,d.complete=function(a){f.isFunction(d.old)&&d.old.call(this),d.queue?f.dequeue(this,d.queue):a!==!1&&f._unmark(this)};return d},easing:{linear:function(a){return a},swing:function(a){return-Math.cos(a*Math.PI)/2+.5}},timers:[],fx:function(a,b,c){this.options=b,this.elem=a,this.prop=c,b.orig=b.orig||{}}}),f.fx.prototype={update:function(){this.options.step&&this.options.step.call(this.elem,this.now,this),(f.fx.step[this.prop]||f.fx.step._default)(this)},cur:function(){if(this.elem[this.prop]!=null&&(!this.elem.style||this.elem.style[this.prop]==null))return this.elem[this.prop];var a,b=f.css(this.elem,this.prop);return isNaN(a=parseFloat(b))?!b||b==="auto"?0:b:a},custom:function(a,c,d){function h(a){return e.step(a)}var e=this,g=f.fx;this.startTime=cq||cr(),this.end=c,this.now=this.start=a,this.pos=this.state=0,this.unit=d||this.unit||(f.cssNumber[this.prop]?"":"px"),h.queue=this.options.queue,h.elem=this.elem,h.saveState=function(){f._data(e.elem,"fxshow"+e.prop)===b&&(e.options.hide?f._data(e.elem,"fxshow"+e.prop,e.start):e.options.show&&f._data(e.elem,"fxshow"+e.prop,e.end))},h()&&f.timers.push(h)&&!co&&(co=setInterval(g.tick,g.interval))},show:function(){var a=f._data(this.elem,"fxshow"+this.prop);this.options.orig[this.prop]=a||f.style(this.elem,this.prop),this.options.show=!0,a!==b?this.custom(this.cur(),a):this.custom(this.prop==="width"||this.prop==="height"?1:0,this.cur()),f(this.elem).show()},hide:function(){this.options.orig[this.prop]=f._data(this.elem,"fxshow"+this.prop)||f.style(this.elem,this.prop),this.options.hide=!0,this.custom(this.cur(),0)},step:function(a){var b,c,d,e=cq||cr(),g=!0,h=this.elem,i=this.options;if(a||e>=i.duration+this.startTime){this.now=this.end,this.pos=this.state=1,this.update(),i.animatedProperties[this.prop]=!0;for(b in i.animatedProperties)i.animatedProperties[b]!==!0&&(g=!1);if(g){i.overflow!=null&&!f.support.shrinkWrapBlocks&&f.each(["","X","Y"],function(a,b){h.style["overflow"+b]=i.overflow[a]}),i.hide&&f(h).hide();if(i.hide||i.show)for(b in i.animatedProperties)f.style(h,b,i.orig[b]),f.removeData(h,"fxshow"+b,!0),f.removeData(h,"toggle"+b,!0);d=i.complete,d&&(i.complete=!1,d.call(h))}return!1}i.duration==Infinity?this.now=e:(c=e-this.startTime,this.state=c/i.duration,this.pos=f.easing[i.animatedProperties[this.prop]](this.state,c,0,1,i.duration),this.now=this.start+(this.end-this.start)*this.pos),this.update();return!0}},f.extend(f.fx,{tick:function(){var a,b=f.timers,c=0;for(;c<b.length;c++)a=b[c],!a()&&b[c]===a&&b.splice(c--,1);b.length||f.fx.stop()},interval:13,stop:function(){clearInterval(co),co=null},speeds:{slow:600,fast:200,_default:400},step:{opacity:function(a){f.style(a.elem,"opacity",a.now)},_default:function(a){a.elem.style&&a.elem.style[a.prop]!=null?a.elem.style[a.prop]=a.now+a.unit:a.elem[a.prop]=a.now}}}),f.each(cp.concat.apply([],cp),function(a,b){b.indexOf("margin")&&(f.fx.step[b]=function(a){f.style(a.elem,b,Math.max(0,a.now)+a.unit)})}),f.expr&&f.expr.filters&&(f.expr.filters.animated=function(a){return f.grep(f.timers,function(b){return a===b.elem}).length});var cv,cw=/^t(?:able|d|h)$/i,cx=/^(?:body|html)$/i;"getBoundingClientRect"in c.documentElement?cv=function(a,b,c,d){try{d=a.getBoundingClientRect()}catch(e){}if(!d||!f.contains(c,a))return d?{top:d.top,left:d.left}:{top:0,left:0};var g=b.body,h=cy(b),i=c.clientTop||g.clientTop||0,j=c.clientLeft||g.clientLeft||0,k=h.pageYOffset||f.support.boxModel&&c.scrollTop||g.scrollTop,l=h.pageXOffset||f.support.boxModel&&c.scrollLeft||g.scrollLeft,m=d.top+k-i,n=d.left+l-j;return{top:m,left:n}}:cv=function(a,b,c){var d,e=a.offsetParent,g=a,h=b.body,i=b.defaultView,j=i?i.getComputedStyle(a,null):a.currentStyle,k=a.offsetTop,l=a.offsetLeft;while((a=a.parentNode)&&a!==h&&a!==c){if(f.support.fixedPosition&&j.position==="fixed")break;d=i?i.getComputedStyle(a,null):a.currentStyle,k-=a.scrollTop,l-=a.scrollLeft,a===e&&(k+=a.offsetTop,l+=a.offsetLeft,f.support.doesNotAddBorder&&(!f.support.doesAddBorderForTableAndCells||!cw.test(a.nodeName))&&(k+=parseFloat(d.borderTopWidth)||0,l+=parseFloat(d.borderLeftWidth)||0),g=e,e=a.offsetParent),f.support.subtractsBorderForOverflowNotVisible&&d.overflow!=="visible"&&(k+=parseFloat(d.borderTopWidth)||0,l+=parseFloat(d.borderLeftWidth)||0),j=d}if(j.position==="relative"||j.position==="static")k+=h.offsetTop,l+=h.offsetLeft;f.support.fixedPosition&&j.position==="fixed"&&(k+=Math.max(c.scrollTop,h.scrollTop),l+=Math.max(c.scrollLeft,h.scrollLeft));return{top:k,left:l}},f.fn.offset=function(a){if(arguments.length)return a===b?this:this.each(function(b){f.offset.setOffset(this,a,b)});var c=this[0],d=c&&c.ownerDocument;if(!d)return null;if(c===d.body)return f.offset.bodyOffset(c);return cv(c,d,d.documentElement)},f.offset={bodyOffset:function(a){var b=a.offsetTop,c=a.offsetLeft;f.support.doesNotIncludeMarginInBodyOffset&&(b+=parseFloat(f.css(a,"marginTop"))||0,c+=parseFloat(f.css(a,"marginLeft"))||0);return{top:b,left:c}},setOffset:function(a,b,c){var d=f.css(a,"position");d==="static"&&(a.style.position="relative");var e=f(a),g=e.offset(),h=f.css(a,"top"),i=f.css(a,"left"),j=(d==="absolute"||d==="fixed")&&f.inArray("auto",[h,i])>-1,k={},l={},m,n;j?(l=e.position(),m=l.top,n=l.left):(m=parseFloat(h)||0,n=parseFloat(i)||0),f.isFunction(b)&&(b=b.call(a,c,g)),b.top!=null&&(k.top=b.top-g.top+m),b.left!=null&&(k.left=b.left-g.left+n),"using"in b?b.using.call(a,k):e.css(k)}},f.fn.extend({position:function(){if(!this[0])return null;var a=this[0],b=this.offsetParent(),c=this.offset(),d=cx.test(b[0].nodeName)?{top:0,left:0}:b.offset();c.top-=parseFloat(f.css(a,"marginTop"))||0,c.left-=parseFloat(f.css(a,"marginLeft"))||0,d.top+=parseFloat(f.css(b[0],"borderTopWidth"))||0,d.left+=parseFloat(f.css(b[0],"borderLeftWidth"))||0;return{top:c.top-d.top,left:c.left-d.left}},offsetParent:function(){return this.map(function(){var a=this.offsetParent||c.body;while(a&&!cx.test(a.nodeName)&&f.css(a,"position")==="static")a=a.offsetParent;return a})}}),f.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,c){var d=/Y/.test(c);f.fn[a]=function(e){return f.access(this,function(a,e,g){var h=cy(a);if(g===b)return h?c in h?h[c]:f.support.boxModel&&h.document.documentElement[e]||h.document.body[e]:a[e];h?h.scrollTo(d?f(h).scrollLeft():g,d?g:f(h).scrollTop()):a[e]=g},a,e,arguments.length,null)}}),f.each({Height:"height",Width:"width"},function(a,c){var d="client"+a,e="scroll"+a,g="offset"+a;f.fn["inner"+a]=function(){var a=this[0];return a?a.style?parseFloat(f.css(a,c,"padding")):this[c]():null},f.fn["outer"+a]=function(a){var b=this[0];return b?b.style?parseFloat(f.css(b,c,a?"margin":"border")):this[c]():null},f.fn[c]=function(a){return f.access(this,function(a,c,h){var i,j,k,l;if(f.isWindow(a)){i=a.document,j=i.documentElement[d];return f.support.boxModel&&j||i.body&&i.body[d]||j}if(a.nodeType===9){i=a.documentElement;if(i[d]>=i[e])return i[d];return Math.max(a.body[e],i[e],a.body[g],i[g])}if(h===b){k=f.css(a,c),l=parseFloat(k);return f.isNumeric(l)?l:k}f(a).css(c,h)},c,a,arguments.length,null)}}),a.jQuery=a.$=f,typeof define=="function"&&define.amd&&define.amd.jQuery&&define("jquery",[],function(){return f})})(window);
/**
 * jQuery Validation Plugin 1.11.1
 *
 * http://bassistance.de/jquery-plugins/jquery-plugin-validation/
 * http://docs.jquery.com/Plugins/Validation
 *
 * Copyright 2013 Jörn Zaefferer
 * Released under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 */
 
(function($) {

$.extend($.fn, {
	// http://docs.jquery.com/Plugins/Validation/validate
	validate: function( options ) {

		// if nothing is selected, return nothing; can't chain anyway
		if ( !this.length ) {
			if ( options && options.debug && window.console ) {
				console.warn( "Nothing selected, can't validate, returning nothing." );
			}
			return;
		}

		// check if a validator for this form was already created
		var validator = $.data( this[0], "validator" );
		if ( validator ) {
			return validator;
		}

		// Add novalidate tag if HTML5.
		this.attr( "novalidate", "novalidate" );

		validator = new $.validator( options, this[0] );
		$.data( this[0], "validator", validator );

		if ( validator.settings.onsubmit ) {

			this.validateDelegate( ":submit", "click", function( event ) {
				if ( validator.settings.submitHandler ) {
					validator.submitButton = event.target;
				}
				// allow suppressing validation by adding a cancel class to the submit button
				if ( $(event.target).hasClass("cancel") ) {
					validator.cancelSubmit = true;
				}

				// allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
				if ( $(event.target).attr("formnovalidate") !== undefined ) {
					validator.cancelSubmit = true;
				}
			});

			// validate the form on submit
			this.submit( function( event ) {
				if ( validator.settings.debug ) {
					// prevent form submit to be able to see console output
					event.preventDefault();
				}
				function handle() {
					var hidden;
					if ( validator.settings.submitHandler ) {
						if ( validator.submitButton ) {
							// insert a hidden input as a replacement for the missing submit button
							hidden = $("<input type='hidden'/>").attr("name", validator.submitButton.name).val( $(validator.submitButton).val() ).appendTo(validator.currentForm);
						}
						validator.settings.submitHandler.call( validator, validator.currentForm, event );
						if ( validator.submitButton ) {
							// and clean up afterwards; thanks to no-block-scope, hidden can be referenced
							hidden.remove();
						}
						return false;
					}
					return true;
				}

				// prevent submit for invalid forms or custom submit handlers
				if ( validator.cancelSubmit ) {
					validator.cancelSubmit = false;
					return handle();
				}
				if ( validator.form() ) {
					if ( validator.pendingRequest ) {
						validator.formSubmitted = true;
						return false;
					}
					return handle();
				} else {
					validator.focusInvalid();
					return false;
				}
			});
		}

		return validator;
	},
	// http://docs.jquery.com/Plugins/Validation/valid
	valid: function() {
		if ( $(this[0]).is("form")) {
			return this.validate().form();
		} else {
			var valid = true;
			var validator = $(this[0].form).validate();
			this.each(function() {
				valid = valid && validator.element(this);
			});
			return valid;
		}
	},
	// attributes: space seperated list of attributes to retrieve and remove
	removeAttrs: function( attributes ) {
		var result = {},
			$element = this;
		$.each(attributes.split(/\s/), function( index, value ) {
			result[value] = $element.attr(value);
			$element.removeAttr(value);
		});
		return result;
	},
	// http://docs.jquery.com/Plugins/Validation/rules
	rules: function( command, argument ) {
		var element = this[0];

		if ( command ) {
			var settings = $.data(element.form, "validator").settings;
			var staticRules = settings.rules;
			var existingRules = $.validator.staticRules(element);
			switch(command) {
			case "add":
				$.extend(existingRules, $.validator.normalizeRule(argument));
				// remove messages from rules, but allow them to be set separetely
				delete existingRules.messages;
				staticRules[element.name] = existingRules;
				if ( argument.messages ) {
					settings.messages[element.name] = $.extend( settings.messages[element.name], argument.messages );
				}
				break;
			case "remove":
				if ( !argument ) {
					delete staticRules[element.name];
					return existingRules;
				}
				var filtered = {};
				$.each(argument.split(/\s/), function( index, method ) {
					filtered[method] = existingRules[method];
					delete existingRules[method];
				});
				return filtered;
			}
		}

		var data = $.validator.normalizeRules(
		$.extend(
			{},
			$.validator.classRules(element),
			$.validator.attributeRules(element),
			$.validator.dataRules(element),
			$.validator.staticRules(element)
		), element);

		// make sure required is at front
		if ( data.required ) {
			var param = data.required;
			delete data.required;
			data = $.extend({required: param}, data);
		}

		return data;
	}
});

// Custom selectors
$.extend($.expr[":"], {
	// http://docs.jquery.com/Plugins/Validation/blank
	blank: function( a ) { return !$.trim("" + $(a).val()); },
	// http://docs.jquery.com/Plugins/Validation/filled
	filled: function( a ) { return !!$.trim("" + $(a).val()); },
	// http://docs.jquery.com/Plugins/Validation/unchecked
	unchecked: function( a ) { return !$(a).prop("checked"); }
});

// constructor for validator
$.validator = function( options, form ) {
	this.settings = $.extend( true, {}, $.validator.defaults, options );
	this.currentForm = form;
	this.init();
};

$.validator.format = function( source, params ) {
	if ( arguments.length === 1 ) {
		return function() {
			var args = $.makeArray(arguments);
			args.unshift(source);
			return $.validator.format.apply( this, args );
		};
	}
	if ( arguments.length > 2 && params.constructor !== Array  ) {
		params = $.makeArray(arguments).slice(1);
	}
	if ( params.constructor !== Array ) {
		params = [ params ];
	}
	$.each(params, function( i, n ) {
		source = source.replace( new RegExp("\\{" + i + "\\}", "g"), function() {
			return n;
		});
	});
	return source;
};

$.extend($.validator, {

	defaults: {
		messages: {},
		groups: {},
		rules: {},
		errorClass: "error",
		validClass: "valid",
		errorElement: "span",
		focusInvalid: true,
		errorContainer: $([]),
		errorLabelContainer: $([]),
		onsubmit: true,
		ignore: ":hidden",
		ignoreTitle: false,
		onfocusin: function( element, event ) {
			this.lastActive = element;

			// hide error label and remove error class on focus if enabled
			if ( this.settings.focusCleanup && !this.blockFocusCleanup ) {
				if ( this.settings.unhighlight ) {
					this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
				}
				this.addWrapper(this.errorsFor(element)).hide();
			}
		},
		onfocusout: function( element, event ) {
			if ( !this.checkable(element) && (element.name in this.submitted || !this.optional(element)) ) {
				this.element(element);
			}
		},
		onkeyup: function( element, event ) {
			if ( event.which === 9 && this.elementValue(element) === "" ) {
				return;
			} else if ( element.name in this.submitted || element === this.lastElement ) {
				this.element(element);
			}
		},
		onclick: function( element, event ) {
			// click on selects, radiobuttons and checkboxes
			if ( element.name in this.submitted ) {
				this.element(element);
			}
			// or option elements, check parent select in that case
			else if ( element.parentNode.name in this.submitted ) {
				this.element(element.parentNode);
			}
		},
		highlight: function( element, errorClass, validClass ) {
			if ( element.type === "radio" ) {
				this.findByName(element.name).addClass(errorClass).removeClass(validClass);
			} else {
				$(element).addClass(errorClass).removeClass(validClass);
			}
		},
		unhighlight: function( element, errorClass, validClass ) {
			if ( element.type === "radio" ) {
				this.findByName(element.name).removeClass(errorClass).addClass(validClass);
			} else {
				$(element).removeClass(errorClass).addClass(validClass);
			}
		}
	},

	// http://docs.jquery.com/Plugins/Validation/Validator/setDefaults
	setDefaults: function( settings ) {
		$.extend( $.validator.defaults, settings );
	},

	messages: {
		required: "Este campo es obligatorio.",
		remote: "Please fix this field.",
		email: "Please enter a valid email address.",
		date: "Please enter a valid date.",
		mydate: "Please enter a valid date. dd/mm/yyyy",
		alpha: "Only Alphabetic and numbers Characters Allowed.",
		equalTo: "Please enter the same value again.",
		maxlength: $.validator.format("Please enter no more than {0} characters."),
		minlength: $.validator.format("Please enter at least {0} characters."),
		rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
		range: $.validator.format("Please enter a value between {0} and {1}."),
		max: $.validator.format("Please enter a value less than or equal to {0}."),
		min: $.validator.format("Please enter a value greater than or equal to {0}.")
	},

	autoCreateRanges: false,

	prototype: {

		init: function() {
			this.labelContainer = $(this.settings.errorLabelContainer);
			this.errorContext = this.labelContainer.length && this.labelContainer || $(this.currentForm);
			this.containers = $(this.settings.errorContainer).add( this.settings.errorLabelContainer );
			this.submitted = {};
			this.valueCache = {};
			this.pendingRequest = 0;
			this.pending = {};
			this.invalid = {};
			this.reset();

			var groups = (this.groups = {});
			$.each(this.settings.groups, function( key, value ) {
				if ( typeof value === "string" ) {
					value = value.split(/\s/);
				}
				$.each(value, function( index, name ) {
					groups[name] = key;
				});
			});
			var rules = this.settings.rules;
			$.each(rules, function( key, value ) {
				rules[key] = $.validator.normalizeRule(value);
			});

			function delegate(event) {
				var validator = $.data(this[0].form, "validator"),
					eventType = "on" + event.type.replace(/^validate/, "");
				if ( validator.settings[eventType] ) {
					validator.settings[eventType].call(validator, this[0], event);
				}
			}
			$(this.currentForm)
				.validateDelegate(":text, [type='password'], [type='file'], select, textarea, " +
					"[type='number'], [type='search'] ,[type='tel'], [type='url'], " +
					"[type='email'], [type='datetime'], [type='date'], [type='month'], " +
					"[type='week'], [type='time'], [type='datetime-local'], " +
					"[type='range'], [type='color'] ",
					"focusin focusout keyup", delegate)
				.validateDelegate("[type='radio'], [type='checkbox'], select, option", "click", delegate);

			if ( this.settings.invalidHandler ) {
				$(this.currentForm).bind("invalid-form.validate", this.settings.invalidHandler);
			}
		},

		// http://docs.jquery.com/Plugins/Validation/Validator/form
		form: function() {
			this.checkForm();
			$.extend(this.submitted, this.errorMap);
			this.invalid = $.extend({}, this.errorMap);
			if ( !this.valid() ) {
				$(this.currentForm).triggerHandler("invalid-form", [this]);
			}
			this.showErrors();
			return this.valid();
		},

		checkForm: function() {
			this.prepareForm();
			for ( var i = 0, elements = (this.currentElements = this.elements()); elements[i]; i++ ) {
				this.check( elements[i] );
			}
			return this.valid();
		},

		// http://docs.jquery.com/Plugins/Validation/Validator/element
		element: function( element ) {
			element = this.validationTargetFor( this.clean( element ) );
			this.lastElement = element;
			this.prepareElement( element );
			this.currentElements = $(element);
			var result = this.check( element ) !== false;
			if ( result ) {
				delete this.invalid[element.name];
			} else {
				this.invalid[element.name] = true;
			}
			if ( !this.numberOfInvalids() ) {
				// Hide error containers on last error
				this.toHide = this.toHide.add( this.containers );
			}
			this.showErrors();
			return result;
		},

		// http://docs.jquery.com/Plugins/Validation/Validator/showErrors
		showErrors: function( errors ) {
			if ( errors ) {
				// add items to error list and map
				$.extend( this.errorMap, errors );
				this.errorList = [];
				for ( var name in errors ) {
					this.errorList.push({
						message: errors[name],
						element: this.findByName(name)[0]
					});
				}
				// remove items from success list
				this.successList = $.grep( this.successList, function( element ) {
					return !(element.name in errors);
				});
			}
			if ( this.settings.showErrors ) {
				this.settings.showErrors.call( this, this.errorMap, this.errorList );
			} else {
				this.defaultShowErrors();
			}
		},

		// http://docs.jquery.com/Plugins/Validation/Validator/resetForm
		resetForm: function() {
			if ( $.fn.resetForm ) {
				$(this.currentForm).resetForm();
			}
			this.submitted = {};
			this.lastElement = null;
			this.prepareForm();
			this.hideErrors();
			this.elements().removeClass( this.settings.errorClass ).removeData( "previousValue" );
		},

		numberOfInvalids: function() {
			return this.objectLength(this.invalid);
		},

		objectLength: function( obj ) {
			var count = 0;
			for ( var i in obj ) {
				count++;
			}
			return count;
		},

		hideErrors: function() {
			this.addWrapper( this.toHide ).hide();
		},

		valid: function() {
			return this.size() === 0;
		},

		size: function() {
			return this.errorList.length;
		},

		focusInvalid: function() {
			if ( this.settings.focusInvalid ) {
				try {
					$(this.findLastActive() || this.errorList.length && this.errorList[0].element || [])
					.filter(":visible")
					.focus()
					// manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
					.trigger("focusin");
				} catch(e) {
					// ignore IE throwing errors when focusing hidden elements
				}
			}
		},

		findLastActive: function() {
			var lastActive = this.lastActive;
			return lastActive && $.grep(this.errorList, function( n ) {
				return n.element.name === lastActive.name;
			}).length === 1 && lastActive;
		},

		elements: function() {
			var validator = this,
				rulesCache = {};

			// select all valid inputs inside the form (no submit or reset buttons)
			return $(this.currentForm)
			.find("input, select, textarea")
			.not(":submit, :reset, :image, [disabled]")
			.not( this.settings.ignore )
			.filter(function() {
				if ( !this.name && validator.settings.debug && window.console ) {
					console.error( "%o has no name assigned", this);
				}

				// select only the first element for each name, and only those with rules specified
				if ( this.name in rulesCache || !validator.objectLength($(this).rules()) ) {
					return false;
				}

				rulesCache[this.name] = true;
				return true;
			});
		},

		clean: function( selector ) {
			return $(selector)[0];
		},

		errors: function() {
			var errorClass = this.settings.errorClass.replace(" ", ".");
			return $(this.settings.errorElement + "." + errorClass, this.errorContext);
		},

		reset: function() {
			this.successList = [];
			this.errorList = [];
			this.errorMap = {};
			this.toShow = $([]);
			this.toHide = $([]);
			this.currentElements = $([]);
		},

		prepareForm: function() {
			this.reset();
			this.toHide = this.errors().add( this.containers );
		},

		prepareElement: function( element ) {
			this.reset();
			this.toHide = this.errorsFor(element);
		},

		elementValue: function( element ) {
			var type = $(element).attr("type"),
				val = $(element).val();

			if ( type === "radio" || type === "checkbox" ) {
				return $("input[name='" + $(element).attr("name") + "']:checked").val();
			}

			if ( typeof val === "string" ) {
				return val.replace(/\r/g, "");
			}
			return val;
		},

		check: function( element ) {
			element = this.validationTargetFor( this.clean( element ) );

			var rules = $(element).rules();
			var dependencyMismatch = false;
			var val = this.elementValue(element);
			var result;

			for (var method in rules ) {
				var rule = { method: method, parameters: rules[method] };
				try {

					result = $.validator.methods[method].call( this, val, element, rule.parameters );

					// if a method indicates that the field is optional and therefore valid,
					// don't mark it as valid when there are no other rules
					if ( result === "dependency-mismatch" ) {
						dependencyMismatch = true;
						continue;
					}
					dependencyMismatch = false;

					if ( result === "pending" ) {
						this.toHide = this.toHide.not( this.errorsFor(element) );
						return;
					}

					if ( !result ) {
						this.formatAndAdd( element, rule );
						return false;
					}
				} catch(e) {
					if ( this.settings.debug && window.console ) {
						console.log( "Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e );
					}
					throw e;
				}
			}
			if ( dependencyMismatch ) {
				return;
			}
			if ( this.objectLength(rules) ) {
				this.successList.push(element);
			}
			return true;
		},

		// return the custom message for the given element and validation method
		// specified in the element's HTML5 data attribute
		customDataMessage: function( element, method ) {
			return $(element).data("msg-" + method.toLowerCase()) || (element.attributes && $(element).attr("data-msg-" + method.toLowerCase()));
		},

		// return the custom message for the given element name and validation method
		customMessage: function( name, method ) {
			var m = this.settings.messages[name];
			return m && (m.constructor === String ? m : m[method]);
		},

		// return the first defined argument, allowing empty strings
		findDefined: function() {
			for(var i = 0; i < arguments.length; i++) {
				if ( arguments[i] !== undefined ) {
					return arguments[i];
				}
			}
			return undefined;
		},

		defaultMessage: function( element, method ) {
			return this.findDefined(
				this.customMessage( element.name, method ),
				this.customDataMessage( element, method ),
				// title is never undefined, so handle empty string as undefined
				!this.settings.ignoreTitle && element.title || undefined,
				$.validator.messages[method],
				"<strong>Warning: No message defined for " + element.name + "</strong>"
			);
		},

		formatAndAdd: function( element, rule ) {
			var message = this.defaultMessage( element, rule.method ),
				theregex = /\$?\{(\d+)\}/g;
			if ( typeof message === "function" ) {
				message = message.call(this, rule.parameters, element);
			} else if (theregex.test(message)) {
				message = $.validator.format(message.replace(theregex, "{$1}"), rule.parameters);
			}
			this.errorList.push({
				message: message,
				element: element
			});

			this.errorMap[element.name] = message;
			this.submitted[element.name] = message;
		},

		addWrapper: function( toToggle ) {
			if ( this.settings.wrapper ) {
				toToggle = toToggle.add( toToggle.parent( this.settings.wrapper ) );
			}
			return toToggle;
		},

		defaultShowErrors: function() {
			var i, elements;
			for ( i = 0; this.errorList[i]; i++ ) {
				var error = this.errorList[i];
				if ( this.settings.highlight ) {
					this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
				}
				this.showLabel( error.element, error.message );
			}
			if ( this.errorList.length ) {
				this.toShow = this.toShow.add( this.containers );
			}
			if ( this.settings.success ) {
				for ( i = 0; this.successList[i]; i++ ) {
					this.showLabel( this.successList[i] );
				}
			}
			if ( this.settings.unhighlight ) {
				for ( i = 0, elements = this.validElements(); elements[i]; i++ ) {
					this.settings.unhighlight.call( this, elements[i], this.settings.errorClass, this.settings.validClass );
				}
			}
			this.toHide = this.toHide.not( this.toShow );
			this.hideErrors();
			this.addWrapper( this.toShow ).show();
		},

		validElements: function() {
			return this.currentElements.not(this.invalidElements());
		},

		invalidElements: function() {
			return $(this.errorList).map(function() {
				return this.element;
			});
		},

		showLabel: function( element, message ) {
			var label = this.errorsFor( element );
			if ( label.length ) {
				// refresh error/success class
				label.removeClass( this.settings.validClass ).addClass( this.settings.errorClass );
				// replace message on existing label
				label.html(message);
			} else {
				// create label
				label = $("<" + this.settings.errorElement + ">")
					.attr("for", this.idOrName(element))
					.addClass(this.settings.errorClass)
					.html(message || "");
				if ( this.settings.wrapper ) {
					// make sure the element is visible, even in IE
					// actually showing the wrapped element is handled elsewhere
					label = label.hide().show().wrap("<" + this.settings.wrapper + "/>").parent();
				}
				if ( !this.labelContainer.append(label).length ) {
					if ( this.settings.errorPlacement ) {
						this.settings.errorPlacement(label, $(element) );
					} else {
              label.insertAfter($(element));
					}
				}
			}
			if ( !message && this.settings.success ) {
				label.text("");
				if ( typeof this.settings.success === "string" ) {
					label.addClass( this.settings.success );
				} else {
					this.settings.success( label, element );
				}
			}
			this.toShow = this.toShow.add(label);
		},

		errorsFor: function( element ) {
			var name = this.idOrName(element);
			return this.errors().filter(function() {
				return $(this).attr("for") === name;
			});
		},

		idOrName: function( element ) {
			return this.groups[element.name] || (this.checkable(element) ? element.name : element.id || element.name);
		},

		validationTargetFor: function( element ) {
			// if radio/checkbox, validate first element in group instead
			if ( this.checkable(element) ) {
				element = this.findByName( element.name ).not(this.settings.ignore)[0];
			}
			return element;
		},

		checkable: function( element ) {
			return (/radio|checkbox/i).test(element.type);
		},

		findByName: function( name ) {
			return $(this.currentForm).find("[name='" + name + "']");
		},

		getLength: function( value, element ) {
			switch( element.nodeName.toLowerCase() ) {
			case "select":
				return $("option:selected", element).length;
			case "input":
				if ( this.checkable( element) ) {
					return this.findByName(element.name).filter(":checked").length;
				}
			}
			return value.length;
		},

		depend: function( param, element ) {
			return this.dependTypes[typeof param] ? this.dependTypes[typeof param](param, element) : true;
		},

		dependTypes: {
			"boolean": function( param, element ) {
				return param;
			},
			"string": function( param, element ) {
				return !!$(param, element.form).length;
			},
			"function": function( param, element ) {
				return param(element);
			}
		},

		optional: function( element ) {
			var val = this.elementValue(element);
			return !$.validator.methods.required.call(this, val, element) && "dependency-mismatch";
		},

		startRequest: function( element ) {
			if ( !this.pending[element.name] ) {
				this.pendingRequest++;
				this.pending[element.name] = true;
			}
		},

		stopRequest: function( element, valid ) {
			this.pendingRequest--;
			// sometimes synchronization fails, make sure pendingRequest is never < 0
			if ( this.pendingRequest < 0 ) {
				this.pendingRequest = 0;
			}
			delete this.pending[element.name];
			if ( valid && this.pendingRequest === 0 && this.formSubmitted && this.form() ) {
				$(this.currentForm).submit();
				this.formSubmitted = false;
			} else if (!valid && this.pendingRequest === 0 && this.formSubmitted) {
				$(this.currentForm).triggerHandler("invalid-form", [this]);
				this.formSubmitted = false;
			}
		},

		previousValue: function( element ) {
			return $.data(element, "previousValue") || $.data(element, "previousValue", {
				old: null,
				valid: true,
				message: this.defaultMessage( element, "remote" )
			});
		}

	},

	classRuleSettings: {
		required: {required: true},
		email: {email: true},
		date: {date: true},
		mydate: {mydate: true},
		alpha: {alpha: true}
	},

	addClassRules: function( className, rules ) {
		if ( className.constructor === String ) {
			this.classRuleSettings[className] = rules;
		} else {
			$.extend(this.classRuleSettings, className);
		}
	},

	classRules: function( element ) {
		var rules = {};
		var classes = $(element).attr("class");
		if ( classes ) {
			$.each(classes.split(" "), function() {
				if ( this in $.validator.classRuleSettings ) {
					$.extend(rules, $.validator.classRuleSettings[this]);
				}
			});
		}
		return rules;
	},

	attributeRules: function( element ) {
		var rules = {};
		var $element = $(element);
		var type = $element[0].getAttribute("type");

		for (var method in $.validator.methods) {
			var value;

			// support for <input required> in both html5 and older browsers
			if ( method === "required" ) {
				value = $element.get(0).getAttribute(method);
				// Some browsers return an empty string for the required attribute
				// and non-HTML5 browsers might have required="" markup
				if ( value === "" ) {
					value = true;
				}
				// force non-HTML5 browsers to return bool
				value = !!value;
			} else {
				value = $element.attr(method);
			}

			// convert the value to a number for number inputs, and for text for backwards compability
			// allows type="date" and others to be compared as strings
			if ( /min|max/.test( method ) && ( type === null || /number|range|text/.test( type ) ) ) {
				value = Number(value);
			}

			if ( value ) {
				rules[method] = value;
			} else if ( type === method && type !== 'range' ) {
				// exception: the jquery validate 'range' method
				// does not test for the html5 'range' type
				rules[method] = true;
			}
		}

		// maxlength may be returned as -1, 2147483647 (IE) and 524288 (safari) for text inputs
		if ( rules.maxlength && /-1|2147483647|524288/.test(rules.maxlength) ) {
			delete rules.maxlength;
		}

		return rules;
	},

	dataRules: function( element ) {
		var method, value,
			rules = {}, $element = $(element);
		for (method in $.validator.methods) {
			value = $element.data("rule-" + method.toLowerCase());
			if ( value !== undefined ) {
				rules[method] = value;
			}
		}
		return rules;
	},

	staticRules: function( element ) {
		var rules = {};
		var validator = $.data(element.form, "validator");
		if ( validator.settings.rules ) {
			rules = $.validator.normalizeRule(validator.settings.rules[element.name]) || {};
		}
		return rules;
	},

	normalizeRules: function( rules, element ) {
		// handle dependency check
		$.each(rules, function( prop, val ) {
			// ignore rule when param is explicitly false, eg. required:false
			if ( val === false ) {
				delete rules[prop];
				return;
			}
			if ( val.param || val.depends ) {
				var keepRule = true;
				switch (typeof val.depends) {
				case "string":
					keepRule = !!$(val.depends, element.form).length;
					break;
				case "function":
					keepRule = val.depends.call(element, element);
					break;
				}
				if ( keepRule ) {
					rules[prop] = val.param !== undefined ? val.param : true;
				} else {
					delete rules[prop];
				}
			}
		});

		// evaluate parameters
		$.each(rules, function( rule, parameter ) {
			rules[rule] = $.isFunction(parameter) ? parameter(element) : parameter;
		});

		// clean number parameters
		$.each(['minlength', 'maxlength'], function() {
			if ( rules[this] ) {
				rules[this] = Number(rules[this]);
			}
		});
		$.each(['rangelength', 'range'], function() {
			var parts;
			if ( rules[this] ) {
				if ( $.isArray(rules[this]) ) {
					rules[this] = [Number(rules[this][0]), Number(rules[this][1])];
				} else if ( typeof rules[this] === "string" ) {
					parts = rules[this].split(/[\s,]+/);
					rules[this] = [Number(parts[0]), Number(parts[1])];
				}
			}
		});

		if ( $.validator.autoCreateRanges ) {
			// auto-create ranges
			if ( rules.min && rules.max ) {
				rules.range = [rules.min, rules.max];
				delete rules.min;
				delete rules.max;
			}
			if ( rules.minlength && rules.maxlength ) {
				rules.rangelength = [rules.minlength, rules.maxlength];
				delete rules.minlength;
				delete rules.maxlength;
			}
		}

		return rules;
	},

	// Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
	normalizeRule: function( data ) {
		if ( typeof data === "string" ) {
			var transformed = {};
			$.each(data.split(/\s/), function() {
				transformed[this] = true;
			});
			data = transformed;
		}
		return data;
	},

	// http://docs.jquery.com/Plugins/Validation/Validator/addMethod
	addMethod: function( name, method, message ) {
		$.validator.methods[name] = method;
		$.validator.messages[name] = message !== undefined ? message : $.validator.messages[name];
		if ( method.length < 3 ) {
			$.validator.addClassRules(name, $.validator.normalizeRule(name));
		}
	},

	methods: {

		// http://docs.jquery.com/Plugins/Validation/Methods/required
		required: function( value, element, param ) {
			// check if dependency is met
			if ( !this.depend(param, element) ) {
				return "dependency-mismatch";
			}
			if ( element.nodeName.toLowerCase() === "select" ) {
				// could be an array for select-multiple or a string, both are fine this way
				var val = $(element).val();
				return val && val.length > 0;
			}
			if ( this.checkable(element) ) {
				return this.getLength(value, element) > 0;
			}
			return $.trim(value).length > 0;
		},

		// http://docs.jquery.com/Plugins/Validation/Methods/email
		email: function( value, element ) {
			// contributed by Scott Gonzalez: http://projects.scottsplayground.com/email_address_validation/
			return this.optional(element) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(value);
		},
		// http://docs.jquery.com/Plugins/Validation/Methods/date
		date: function( value, element ) {
			return this.optional(element) || !/Invalid|NaN/.test(new Date(value).toString());
		},
		// check format dd/mm/yyyy
		mydate: function( value, element ) {
			return this.optional(element) || /^\d{1,2}[\/-]\d{1,2}[\/-]\d{4}$/.test(value);
		},
		alpha: function (value, element) {
			return this.optional(element) || /^[a-zA-Z0-9_]+$/.test(value);
		},

		// http://docs.jquery.com/Plugins/Validation/Methods/minlength
		minlength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength($.trim(value), element);
			return this.optional(element) || length >= param;
		},

		// http://docs.jquery.com/Plugins/Validation/Methods/maxlength
		maxlength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength($.trim(value), element);
			return this.optional(element) || length <= param;
		},

		// http://docs.jquery.com/Plugins/Validation/Methods/rangelength
		rangelength: function( value, element, param ) {
			var length = $.isArray( value ) ? value.length : this.getLength($.trim(value), element);
			return this.optional(element) || ( length >= param[0] && length <= param[1] );
		},

		// http://docs.jquery.com/Plugins/Validation/Methods/min
		min: function( value, element, param ) {
			return this.optional(element) || value >= param;
		},

		// http://docs.jquery.com/Plugins/Validation/Methods/max
		max: function( value, element, param ) {
			return this.optional(element) || value <= param;
		},

		// http://docs.jquery.com/Plugins/Validation/Methods/range
		range: function( value, element, param ) {
			return this.optional(element) || ( value >= param[0] && value <= param[1] );
		},

		// http://docs.jquery.com/Plugins/Validation/Methods/equalTo
		equalTo: function( value, element, param ) {
			// bind to the blur event of the target in order to revalidate whenever the target field is updated
			// TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
			var target = $(param);
			if ( this.settings.onfocusout ) {
				target.unbind(".validate-equalTo").bind("blur.validate-equalTo", function() {
					$(element).valid();
				});
			}
			return value === target.val();
		},

		// http://docs.jquery.com/Plugins/Validation/Methods/remote
		remote: function( value, element, param ) {
			if ( this.optional(element) ) {
				return "dependency-mismatch";
			}

			var previous = this.previousValue(element);
			if (!this.settings.messages[element.name] ) {
				this.settings.messages[element.name] = {};
			}
			previous.originalMessage = this.settings.messages[element.name].remote;
			this.settings.messages[element.name].remote = previous.message;

			param = typeof param === "string" && {url:param} || param;

			if ( previous.old === value ) {
				return previous.valid;
			}

			previous.old = value;
			var validator = this;
			this.startRequest(element);
			var data = {};
			data[element.name] = value;
			$.ajax($.extend(true, {
				url: param,
				mode: "abort",
				port: "validate" + element.name,
				dataType: "json",
				data: data,
				success: function( response ) {
					validator.settings.messages[element.name].remote = previous.originalMessage;
					var valid = response === true || response === "true";
					if ( valid ) {
						var submitted = validator.formSubmitted;
						validator.prepareElement(element);
						validator.formSubmitted = submitted;
						validator.successList.push(element);
						delete validator.invalid[element.name];
						validator.showErrors();
					} else {
						var errors = {};
						var message = response || validator.defaultMessage( element, "remote" );
						errors[element.name] = previous.message = $.isFunction(message) ? message(value) : message;
						validator.invalid[element.name] = true;
						validator.showErrors(errors);
					}
					previous.valid = valid;
					validator.stopRequest(element, valid);
				}
			}, param));
			return "pending";
		}

	}

});

// deprecated, use $.validator.format instead
$.format = $.validator.format;

}(jQuery));

// ajax mode: abort
// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()
(function($) {
	var pendingRequests = {};
	// Use a prefilter if available (1.5+)
	if ( $.ajaxPrefilter ) {
		$.ajaxPrefilter(function( settings, _, xhr ) {
			var port = settings.port;
			if ( settings.mode === "abort" ) {
				if ( pendingRequests[port] ) {
					pendingRequests[port].abort();
				}
				pendingRequests[port] = xhr;
			}
		});
	} else {
		// Proxy ajax
		var ajax = $.ajax;
		$.ajax = function( settings ) {
			var mode = ( "mode" in settings ? settings : $.ajaxSettings ).mode,
				port = ( "port" in settings ? settings : $.ajaxSettings ).port;
			if ( mode === "abort" ) {
				if ( pendingRequests[port] ) {
					pendingRequests[port].abort();
				}
				pendingRequests[port] = ajax.apply(this, arguments);
				return pendingRequests[port];
			}
			return ajax.apply(this, arguments);
		};
	}
}(jQuery));

// provides delegate(type: String, delegate: Selector, handler: Callback) plugin for easier event delegation
// handler is only called when $(event.target).is(delegate), in the scope of the jquery-object for event.target
(function($) {
	$.extend($.fn, {
		validateDelegate: function( delegate, type, handler ) {
			return this.bind(type, function( event ) {
				var target = $(event.target);
				if ( target.is(delegate) ) {
					return handler.apply(target, arguments);
				}
			});
		}
	});
}(jQuery));

var propiedad_auxiliar = "Es para los ajustes css y js";


/*! jQuery UI - v1.9.2 - 2013-12-20
* http://jqueryui.com
* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.position.js, jquery.ui.autocomplete.js, jquery.ui.menu.js, jquery.ui.effect.js, jquery.ui.effect-highlight.js
* Copyright 2013 jQuery Foundation and other contributors; Licensed MIT */

(function(e,t){function i(t,i){var s,a,o,r=t.nodeName.toLowerCase();return"area"===r?(s=t.parentNode,a=s.name,t.href&&a&&"map"===s.nodeName.toLowerCase()?(o=e("img[usemap=#"+a+"]")[0],!!o&&n(o)):!1):(/input|select|textarea|button|object/.test(r)?!t.disabled:"a"===r?t.href||i:i)&&n(t)}function n(t){return e.expr.filters.visible(t)&&!e(t).parents().andSelf().filter(function(){return"hidden"===e.css(this,"visibility")}).length}var s=0,a=/^ui-id-\d+$/;e.ui=e.ui||{},e.ui.version||(e.extend(e.ui,{version:"1.9.2",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,NUMPAD_ADD:107,NUMPAD_DECIMAL:110,NUMPAD_DIVIDE:111,NUMPAD_ENTER:108,NUMPAD_MULTIPLY:106,NUMPAD_SUBTRACT:109,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),e.fn.extend({_focus:e.fn.focus,focus:function(t,i){return"number"==typeof t?this.each(function(){var n=this;setTimeout(function(){e(n).focus(),i&&i.call(n)},t)}):this._focus.apply(this,arguments)},scrollParent:function(){var t;return t=e.ui.ie&&/(static|relative)/.test(this.css("position"))||/absolute/.test(this.css("position"))?this.parents().filter(function(){return/(relative|absolute|fixed)/.test(e.css(this,"position"))&&/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0):this.parents().filter(function(){return/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0),/fixed/.test(this.css("position"))||!t.length?e(document):t},zIndex:function(i){if(i!==t)return this.css("zIndex",i);if(this.length)for(var n,s,a=e(this[0]);a.length&&a[0]!==document;){if(n=a.css("position"),("absolute"===n||"relative"===n||"fixed"===n)&&(s=parseInt(a.css("zIndex"),10),!isNaN(s)&&0!==s))return s;a=a.parent()}return 0},uniqueId:function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++s)})},removeUniqueId:function(){return this.each(function(){a.test(this.id)&&e(this).removeAttr("id")})}}),e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(i){return!!e.data(i,t)}}):function(t,i,n){return!!e.data(t,n[3])},focusable:function(t){return i(t,!isNaN(e.attr(t,"tabindex")))},tabbable:function(t){var n=e.attr(t,"tabindex"),s=isNaN(n);return(s||n>=0)&&i(t,!s)}}),e(function(){var t=document.body,i=t.appendChild(i=document.createElement("div"));i.offsetHeight,e.extend(i.style,{minHeight:"100px",height:"auto",padding:0,borderWidth:0}),e.support.minHeight=100===i.offsetHeight,e.support.selectstart="onselectstart"in i,t.removeChild(i).style.display="none"}),e("<a>").outerWidth(1).jquery||e.each(["Width","Height"],function(i,n){function s(t,i,n,s){return e.each(a,function(){i-=parseFloat(e.css(t,"padding"+this))||0,n&&(i-=parseFloat(e.css(t,"border"+this+"Width"))||0),s&&(i-=parseFloat(e.css(t,"margin"+this))||0)}),i}var a="Width"===n?["Left","Right"]:["Top","Bottom"],o=n.toLowerCase(),r={innerWidth:e.fn.innerWidth,innerHeight:e.fn.innerHeight,outerWidth:e.fn.outerWidth,outerHeight:e.fn.outerHeight};e.fn["inner"+n]=function(i){return i===t?r["inner"+n].call(this):this.each(function(){e(this).css(o,s(this,i)+"px")})},e.fn["outer"+n]=function(t,i){return"number"!=typeof t?r["outer"+n].call(this,t):this.each(function(){e(this).css(o,s(this,t,!0,i)+"px")})}}),e("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(e.fn.removeData=function(t){return function(i){return arguments.length?t.call(this,e.camelCase(i)):t.call(this)}}(e.fn.removeData)),function(){var t=/msie ([\w.]+)/.exec(navigator.userAgent.toLowerCase())||[];e.ui.ie=t.length?!0:!1,e.ui.ie6=6===parseFloat(t[1],10)}(),e.fn.extend({disableSelection:function(){return this.bind((e.support.selectstart?"selectstart":"mousedown")+".ui-disableSelection",function(e){e.preventDefault()})},enableSelection:function(){return this.unbind(".ui-disableSelection")}}),e.extend(e.ui,{plugin:{add:function(t,i,n){var s,a=e.ui[t].prototype;for(s in n)a.plugins[s]=a.plugins[s]||[],a.plugins[s].push([i,n[s]])},call:function(e,t,i){var n,s=e.plugins[t];if(s&&e.element[0].parentNode&&11!==e.element[0].parentNode.nodeType)for(n=0;s.length>n;n++)e.options[s[n][0]]&&s[n][1].apply(e.element,i)}},contains:e.contains,hasScroll:function(t,i){if("hidden"===e(t).css("overflow"))return!1;var n=i&&"left"===i?"scrollLeft":"scrollTop",s=!1;return t[n]>0?!0:(t[n]=1,s=t[n]>0,t[n]=0,s)},isOverAxis:function(e,t,i){return e>t&&t+i>e},isOver:function(t,i,n,s,a,o){return e.ui.isOverAxis(t,n,a)&&e.ui.isOverAxis(i,s,o)}}))})(jQuery);(function(t,e){var i=0,s=Array.prototype.slice,n=t.cleanData;t.cleanData=function(e){for(var i,s=0;null!=(i=e[s]);s++)try{t(i).triggerHandler("remove")}catch(a){}n(e)},t.widget=function(i,s,n){var a,o,r,h,l=i.split(".")[0];i=i.split(".")[1],a=l+"-"+i,n||(n=s,s=t.Widget),t.expr[":"][a.toLowerCase()]=function(e){return!!t.data(e,a)},t[l]=t[l]||{},o=t[l][i],r=t[l][i]=function(t,i){return this._createWidget?(arguments.length&&this._createWidget(t,i),e):new r(t,i)},t.extend(r,o,{version:n.version,_proto:t.extend({},n),_childConstructors:[]}),h=new s,h.options=t.widget.extend({},h.options),t.each(n,function(e,i){t.isFunction(i)&&(n[e]=function(){var t=function(){return s.prototype[e].apply(this,arguments)},n=function(t){return s.prototype[e].apply(this,t)};return function(){var e,s=this._super,a=this._superApply;return this._super=t,this._superApply=n,e=i.apply(this,arguments),this._super=s,this._superApply=a,e}}())}),r.prototype=t.widget.extend(h,{widgetEventPrefix:o?h.widgetEventPrefix:i},n,{constructor:r,namespace:l,widgetName:i,widgetBaseClass:a,widgetFullName:a}),o?(t.each(o._childConstructors,function(e,i){var s=i.prototype;t.widget(s.namespace+"."+s.widgetName,r,i._proto)}),delete o._childConstructors):s._childConstructors.push(r),t.widget.bridge(i,r)},t.widget.extend=function(i){for(var n,a,o=s.call(arguments,1),r=0,h=o.length;h>r;r++)for(n in o[r])a=o[r][n],o[r].hasOwnProperty(n)&&a!==e&&(i[n]=t.isPlainObject(a)?t.isPlainObject(i[n])?t.widget.extend({},i[n],a):t.widget.extend({},a):a);return i},t.widget.bridge=function(i,n){var a=n.prototype.widgetFullName||i;t.fn[i]=function(o){var r="string"==typeof o,h=s.call(arguments,1),l=this;return o=!r&&h.length?t.widget.extend.apply(null,[o].concat(h)):o,r?this.each(function(){var s,n=t.data(this,a);return n?t.isFunction(n[o])&&"_"!==o.charAt(0)?(s=n[o].apply(n,h),s!==n&&s!==e?(l=s&&s.jquery?l.pushStack(s.get()):s,!1):e):t.error("no such method '"+o+"' for "+i+" widget instance"):t.error("cannot call methods on "+i+" prior to initialization; "+"attempted to call method '"+o+"'")}):this.each(function(){var e=t.data(this,a);e?e.option(o||{})._init():t.data(this,a,new n(o,this))}),l}},t.Widget=function(){},t.Widget._childConstructors=[],t.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{disabled:!1,create:null},_createWidget:function(e,s){s=t(s||this.defaultElement||this)[0],this.element=t(s),this.uuid=i++,this.eventNamespace="."+this.widgetName+this.uuid,this.options=t.widget.extend({},this.options,this._getCreateOptions(),e),this.bindings=t(),this.hoverable=t(),this.focusable=t(),s!==this&&(t.data(s,this.widgetName,this),t.data(s,this.widgetFullName,this),this._on(!0,this.element,{remove:function(t){t.target===s&&this.destroy()}}),this.document=t(s.style?s.ownerDocument:s.document||s),this.window=t(this.document[0].defaultView||this.document[0].parentWindow)),this._create(),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:t.noop,_getCreateEventData:t.noop,_create:t.noop,_init:t.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(t.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName+"-disabled "+"ui-state-disabled"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")},_destroy:t.noop,widget:function(){return this.element},option:function(i,s){var n,a,o,r=i;if(0===arguments.length)return t.widget.extend({},this.options);if("string"==typeof i)if(r={},n=i.split("."),i=n.shift(),n.length){for(a=r[i]=t.widget.extend({},this.options[i]),o=0;n.length-1>o;o++)a[n[o]]=a[n[o]]||{},a=a[n[o]];if(i=n.pop(),s===e)return a[i]===e?null:a[i];a[i]=s}else{if(s===e)return this.options[i]===e?null:this.options[i];r[i]=s}return this._setOptions(r),this},_setOptions:function(t){var e;for(e in t)this._setOption(e,t[e]);return this},_setOption:function(t,e){return this.options[t]=e,"disabled"===t&&(this.widget().toggleClass(this.widgetFullName+"-disabled ui-state-disabled",!!e).attr("aria-disabled",e),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")),this},enable:function(){return this._setOption("disabled",!1)},disable:function(){return this._setOption("disabled",!0)},_on:function(i,s,n){var a,o=this;"boolean"!=typeof i&&(n=s,s=i,i=!1),n?(s=a=t(s),this.bindings=this.bindings.add(s)):(n=s,s=this.element,a=this.widget()),t.each(n,function(n,r){function h(){return i||o.options.disabled!==!0&&!t(this).hasClass("ui-state-disabled")?("string"==typeof r?o[r]:r).apply(o,arguments):e}"string"!=typeof r&&(h.guid=r.guid=r.guid||h.guid||t.guid++);var l=n.match(/^(\w+)\s*(.*)$/),c=l[1]+o.eventNamespace,u=l[2];u?a.delegate(u,c,h):s.bind(c,h)})},_off:function(t,e){e=(e||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,t.unbind(e).undelegate(e)},_delay:function(t,e){function i(){return("string"==typeof t?s[t]:t).apply(s,arguments)}var s=this;return setTimeout(i,e||0)},_hoverable:function(e){this.hoverable=this.hoverable.add(e),this._on(e,{mouseenter:function(e){t(e.currentTarget).addClass("ui-state-hover")},mouseleave:function(e){t(e.currentTarget).removeClass("ui-state-hover")}})},_focusable:function(e){this.focusable=this.focusable.add(e),this._on(e,{focusin:function(e){t(e.currentTarget).addClass("ui-state-focus")},focusout:function(e){t(e.currentTarget).removeClass("ui-state-focus")}})},_trigger:function(e,i,s){var n,a,o=this.options[e];if(s=s||{},i=t.Event(i),i.type=(e===this.widgetEventPrefix?e:this.widgetEventPrefix+e).toLowerCase(),i.target=this.element[0],a=i.originalEvent)for(n in a)n in i||(i[n]=a[n]);return this.element.trigger(i,s),!(t.isFunction(o)&&o.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},t.each({show:"fadeIn",hide:"fadeOut"},function(e,i){t.Widget.prototype["_"+e]=function(s,n,a){"string"==typeof n&&(n={effect:n});var o,r=n?n===!0||"number"==typeof n?i:n.effect||i:e;n=n||{},"number"==typeof n&&(n={duration:n}),o=!t.isEmptyObject(n),n.complete=a,n.delay&&s.delay(n.delay),o&&t.effects&&(t.effects.effect[r]||t.uiBackCompat!==!1&&t.effects[r])?s[e](n):r!==e&&s[r]?s[r](n.duration,n.easing,a):s.queue(function(i){t(this)[e](),a&&a.call(s[0]),i()})}}),t.uiBackCompat!==!1&&(t.Widget.prototype._getCreateOptions=function(){return t.metadata&&t.metadata.get(this.element[0])[this.widgetName]})})(jQuery);(function(t,e){function i(t,e,i){return[parseInt(t[0],10)*(d.test(t[0])?e/100:1),parseInt(t[1],10)*(d.test(t[1])?i/100:1)]}function s(e,i){return parseInt(t.css(e,i),10)||0}t.ui=t.ui||{};var n,a=Math.max,o=Math.abs,r=Math.round,l=/left|center|right/,h=/top|center|bottom/,c=/[\+\-]\d+%?/,u=/^\w+/,d=/%$/,p=t.fn.position;t.position={scrollbarWidth:function(){if(n!==e)return n;var i,s,a=t("<div style='display:block;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),o=a.children()[0];return t("body").append(a),i=o.offsetWidth,a.css("overflow","scroll"),s=o.offsetWidth,i===s&&(s=a[0].clientWidth),a.remove(),n=i-s},getScrollInfo:function(e){var i=e.isWindow?"":e.element.css("overflow-x"),s=e.isWindow?"":e.element.css("overflow-y"),n="scroll"===i||"auto"===i&&e.width<e.element[0].scrollWidth,a="scroll"===s||"auto"===s&&e.height<e.element[0].scrollHeight;return{width:n?t.position.scrollbarWidth():0,height:a?t.position.scrollbarWidth():0}},getWithinInfo:function(e){var i=t(e||window),s=t.isWindow(i[0]);return{element:i,isWindow:s,offset:i.offset()||{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:s?i.width():i.outerWidth(),height:s?i.height():i.outerHeight()}}},t.fn.position=function(e){if(!e||!e.of)return p.apply(this,arguments);e=t.extend({},e);var n,d,f,g,m,v=t(e.of),_=t.position.getWithinInfo(e.within),b=t.position.getScrollInfo(_),y=v[0],w=(e.collision||"flip").split(" "),k={};return 9===y.nodeType?(d=v.width(),f=v.height(),g={top:0,left:0}):t.isWindow(y)?(d=v.width(),f=v.height(),g={top:v.scrollTop(),left:v.scrollLeft()}):y.preventDefault?(e.at="left top",d=f=0,g={top:y.pageY,left:y.pageX}):(d=v.outerWidth(),f=v.outerHeight(),g=v.offset()),m=t.extend({},g),t.each(["my","at"],function(){var t,i,s=(e[this]||"").split(" ");1===s.length&&(s=l.test(s[0])?s.concat(["center"]):h.test(s[0])?["center"].concat(s):["center","center"]),s[0]=l.test(s[0])?s[0]:"center",s[1]=h.test(s[1])?s[1]:"center",t=c.exec(s[0]),i=c.exec(s[1]),k[this]=[t?t[0]:0,i?i[0]:0],e[this]=[u.exec(s[0])[0],u.exec(s[1])[0]]}),1===w.length&&(w[1]=w[0]),"right"===e.at[0]?m.left+=d:"center"===e.at[0]&&(m.left+=d/2),"bottom"===e.at[1]?m.top+=f:"center"===e.at[1]&&(m.top+=f/2),n=i(k.at,d,f),m.left+=n[0],m.top+=n[1],this.each(function(){var l,h,c=t(this),u=c.outerWidth(),p=c.outerHeight(),y=s(this,"marginLeft"),D=s(this,"marginTop"),x=u+y+s(this,"marginRight")+b.width,C=p+D+s(this,"marginBottom")+b.height,M=t.extend({},m),I=i(k.my,c.outerWidth(),c.outerHeight());"right"===e.my[0]?M.left-=u:"center"===e.my[0]&&(M.left-=u/2),"bottom"===e.my[1]?M.top-=p:"center"===e.my[1]&&(M.top-=p/2),M.left+=I[0],M.top+=I[1],t.support.offsetFractions||(M.left=r(M.left),M.top=r(M.top)),l={marginLeft:y,marginTop:D},t.each(["left","top"],function(i,s){t.ui.position[w[i]]&&t.ui.position[w[i]][s](M,{targetWidth:d,targetHeight:f,elemWidth:u,elemHeight:p,collisionPosition:l,collisionWidth:x,collisionHeight:C,offset:[n[0]+I[0],n[1]+I[1]],my:e.my,at:e.at,within:_,elem:c})}),t.fn.bgiframe&&c.bgiframe(),e.using&&(h=function(t){var i=g.left-M.left,s=i+d-u,n=g.top-M.top,r=n+f-p,l={target:{element:v,left:g.left,top:g.top,width:d,height:f},element:{element:c,left:M.left,top:M.top,width:u,height:p},horizontal:0>s?"left":i>0?"right":"center",vertical:0>r?"top":n>0?"bottom":"middle"};u>d&&d>o(i+s)&&(l.horizontal="center"),p>f&&f>o(n+r)&&(l.vertical="middle"),l.important=a(o(i),o(s))>a(o(n),o(r))?"horizontal":"vertical",e.using.call(this,t,l)}),c.offset(t.extend(M,{using:h}))})},t.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,o=s.width,r=t.left-e.collisionPosition.marginLeft,l=n-r,h=r+e.collisionWidth-o-n;e.collisionWidth>o?l>0&&0>=h?(i=t.left+l+e.collisionWidth-o-n,t.left+=l-i):t.left=h>0&&0>=l?n:l>h?n+o-e.collisionWidth:n:l>0?t.left+=l:h>0?t.left-=h:t.left=a(t.left-r,t.left)},top:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollTop:s.offset.top,o=e.within.height,r=t.top-e.collisionPosition.marginTop,l=n-r,h=r+e.collisionHeight-o-n;e.collisionHeight>o?l>0&&0>=h?(i=t.top+l+e.collisionHeight-o-n,t.top+=l-i):t.top=h>0&&0>=l?n:l>h?n+o-e.collisionHeight:n:l>0?t.top+=l:h>0?t.top-=h:t.top=a(t.top-r,t.top)}},flip:{left:function(t,e){var i,s,n=e.within,a=n.offset.left+n.scrollLeft,r=n.width,l=n.isWindow?n.scrollLeft:n.offset.left,h=t.left-e.collisionPosition.marginLeft,c=h-l,u=h+e.collisionWidth-r-l,d="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,p="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,f=-2*e.offset[0];0>c?(i=t.left+d+p+f+e.collisionWidth-r-a,(0>i||o(c)>i)&&(t.left+=d+p+f)):u>0&&(s=t.left-e.collisionPosition.marginLeft+d+p+f-l,(s>0||u>o(s))&&(t.left+=d+p+f))},top:function(t,e){var i,s,n=e.within,a=n.offset.top+n.scrollTop,r=n.height,l=n.isWindow?n.scrollTop:n.offset.top,h=t.top-e.collisionPosition.marginTop,c=h-l,u=h+e.collisionHeight-r-l,d="top"===e.my[1],p=d?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,f="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,g=-2*e.offset[1];0>c?(s=t.top+p+f+g+e.collisionHeight-r-a,t.top+p+f+g>c&&(0>s||o(c)>s)&&(t.top+=p+f+g)):u>0&&(i=t.top-e.collisionPosition.marginTop+p+f+g-l,t.top+p+f+g>u&&(i>0||u>o(i))&&(t.top+=p+f+g))}},flipfit:{left:function(){t.ui.position.flip.left.apply(this,arguments),t.ui.position.fit.left.apply(this,arguments)},top:function(){t.ui.position.flip.top.apply(this,arguments),t.ui.position.fit.top.apply(this,arguments)}}},function(){var e,i,s,n,a,o=document.getElementsByTagName("body")[0],r=document.createElement("div");e=document.createElement(o?"div":"body"),s={visibility:"hidden",width:0,height:0,border:0,margin:0,background:"none"},o&&t.extend(s,{position:"absolute",left:"-1000px",top:"-1000px"});for(a in s)e.style[a]=s[a];e.appendChild(r),i=o||document.documentElement,i.insertBefore(e,i.firstChild),r.style.cssText="position: absolute; left: 10.7432222px;",n=t(r).offset().left,t.support.offsetFractions=n>10&&11>n,e.innerHTML="",i.removeChild(e)}(),t.uiBackCompat!==!1&&function(t){var i=t.fn.position;t.fn.position=function(s){if(!s||!s.offset)return i.call(this,s);var n=s.offset.split(" "),a=s.at.split(" ");return 1===n.length&&(n[1]=n[0]),/^\d/.test(n[0])&&(n[0]="+"+n[0]),/^\d/.test(n[1])&&(n[1]="+"+n[1]),1===a.length&&(/left|center|right/.test(a[0])?a[1]="center":(a[1]=a[0],a[0]="center")),i.call(this,t.extend(s,{at:a[0]+n[0]+" "+a[1]+n[1],offset:e}))}}(jQuery)})(jQuery);(function(e){var t=0;e.widget("ui.autocomplete",{version:"1.9.2",defaultElement:"<input>",options:{appendTo:"body",autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},pending:0,_create:function(){var t,i,n;this.isMultiLine=this._isMultiLine(),this.valueMethod=this.element[this.element.is("input,textarea")?"val":"text"],this.isNewMenu=!0,this.element.addClass("ui-autocomplete-input").attr("autocomplete","off"),this._on(this.element,{keydown:function(s){if(this.element.prop("readOnly"))return t=!0,n=!0,i=!0,undefined;t=!1,n=!1,i=!1;var a=e.ui.keyCode;switch(s.keyCode){case a.PAGE_UP:t=!0,this._move("previousPage",s);break;case a.PAGE_DOWN:t=!0,this._move("nextPage",s);break;case a.UP:t=!0,this._keyEvent("previous",s);break;case a.DOWN:t=!0,this._keyEvent("next",s);break;case a.ENTER:case a.NUMPAD_ENTER:this.menu.active&&(t=!0,s.preventDefault(),this.menu.select(s));break;case a.TAB:this.menu.active&&this.menu.select(s);break;case a.ESCAPE:this.menu.element.is(":visible")&&(this._value(this.term),this.close(s),s.preventDefault());break;default:i=!0,this._searchTimeout(s)}},keypress:function(n){if(t)return t=!1,n.preventDefault(),undefined;if(!i){var s=e.ui.keyCode;switch(n.keyCode){case s.PAGE_UP:this._move("previousPage",n);break;case s.PAGE_DOWN:this._move("nextPage",n);break;case s.UP:this._keyEvent("previous",n);break;case s.DOWN:this._keyEvent("next",n)}}},input:function(e){return n?(n=!1,e.preventDefault(),undefined):(this._searchTimeout(e),undefined)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(e){return this.cancelBlur?(delete this.cancelBlur,undefined):(clearTimeout(this.searching),this.close(e),this._change(e),undefined)}}),this._initSource(),this.menu=e("<ul>").addClass("ui-autocomplete").appendTo(this.document.find(this.options.appendTo||"body")[0]).menu({input:e(),role:null}).zIndex(this.element.zIndex()+1).hide().data("menu"),this._on(this.menu.element,{mousedown:function(t){t.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur});var i=this.menu.element[0];e(t.target).closest(".ui-menu-item").length||this._delay(function(){var t=this;this.document.one("mousedown",function(n){n.target===t.element[0]||n.target===i||e.contains(i,n.target)||t.close()})})},menufocus:function(t,i){if(this.isNewMenu&&(this.isNewMenu=!1,t.originalEvent&&/^mouse/.test(t.originalEvent.type)))return this.menu.blur(),this.document.one("mousemove",function(){e(t.target).trigger(t.originalEvent)}),undefined;var n=i.item.data("ui-autocomplete-item")||i.item.data("item.autocomplete");!1!==this._trigger("focus",t,{item:n})?t.originalEvent&&/^key/.test(t.originalEvent.type)&&this._value(n.value):this.liveRegion.text(n.value)},menuselect:function(e,t){var i=t.item.data("ui-autocomplete-item")||t.item.data("item.autocomplete"),n=this.previous;this.element[0]!==this.document[0].activeElement&&(this.element.focus(),this.previous=n,this._delay(function(){this.previous=n,this.selectedItem=i})),!1!==this._trigger("select",e,{item:i})&&this._value(i.value),this.term=this._value(),this.close(e),this.selectedItem=i}}),this.liveRegion=e("<span>",{role:"status","aria-live":"polite"}).addClass("ui-helper-hidden-accessible").insertAfter(this.element),e.fn.bgiframe&&this.menu.element.bgiframe(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeClass("ui-autocomplete-input").removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(e,t){this._super(e,t),"source"===e&&this._initSource(),"appendTo"===e&&this.menu.element.appendTo(this.document.find(t||"body")[0]),"disabled"===e&&t&&this.xhr&&this.xhr.abort()},_isMultiLine:function(){return this.element.is("textarea")?!0:this.element.is("input")?!1:this.element.prop("isContentEditable")},_initSource:function(){var t,i,n=this;e.isArray(this.options.source)?(t=this.options.source,this.source=function(i,n){n(e.ui.autocomplete.filter(t,i.term))}):"string"==typeof this.options.source?(i=this.options.source,this.source=function(t,s){n.xhr&&n.xhr.abort(),n.xhr=e.ajax({url:i,data:t,dataType:"json",success:function(e){s(e)},error:function(){s([])}})}):this.source=this.options.source},_searchTimeout:function(e){clearTimeout(this.searching),this.searching=this._delay(function(){this.term!==this._value()&&(this.selectedItem=null,this.search(null,e))},this.options.delay)},search:function(e,t){return e=null!=e?e:this._value(),this.term=this._value(),e.length<this.options.minLength?this.close(t):this._trigger("search",t)!==!1?this._search(e):undefined},_search:function(e){this.pending++,this.element.addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:e},this._response())},_response:function(){var e=this,i=++t;return function(n){i===t&&e.__response(n),e.pending--,e.pending||e.element.removeClass("ui-autocomplete-loading")}},__response:function(e){e&&(e=this._normalize(e)),this._trigger("response",null,{content:e}),!this.options.disabled&&e&&e.length&&!this.cancelSearch?(this._suggest(e),this._trigger("open")):this._close()},close:function(e){this.cancelSearch=!0,this._close(e)},_close:function(e){this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",e))},_change:function(e){this.previous!==this._value()&&this._trigger("change",e,{item:this.selectedItem})},_normalize:function(t){return t.length&&t[0].label&&t[0].value?t:e.map(t,function(t){return"string"==typeof t?{label:t,value:t}:e.extend({label:t.label||t.value,value:t.value||t.label},t)})},_suggest:function(t){var i=this.menu.element.empty().zIndex(this.element.zIndex()+1);this._renderMenu(i,t),this.menu.refresh(),i.show(),this._resizeMenu(),i.position(e.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next()},_resizeMenu:function(){var e=this.menu.element;e.outerWidth(Math.max(e.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(t,i){var n=this;e.each(i,function(e,i){n._renderItemData(t,i)})},_renderItemData:function(e,t){return this._renderItem(e,t).data("ui-autocomplete-item",t)},_renderItem:function(t,i){return e("<li>").append(e("<a>").text(i.label)).appendTo(t)},_move:function(e,t){return this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(e)||this.menu.isLastItem()&&/^next/.test(e)?(this._value(this.term),this.menu.blur(),undefined):(this.menu[e](t),undefined):(this.search(null,t),undefined)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(e,t){(!this.isMultiLine||this.menu.element.is(":visible"))&&(this._move(e,t),t.preventDefault())}}),e.extend(e.ui.autocomplete,{escapeRegex:function(e){return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(t,i){var n=RegExp(e.ui.autocomplete.escapeRegex(i),"i");return e.grep(t,function(e){return n.test(e.label||e.value||e)})}}),e.widget("ui.autocomplete",e.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(e){return e+(e>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(e){var t;this._superApply(arguments),this.options.disabled||this.cancelSearch||(t=e&&e.length?this.options.messages.results(e.length):this.options.messages.noResults,this.liveRegion.text(t))}})})(jQuery);(function(e){var t=!1;e.widget("ui.menu",{version:"1.9.2",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-carat-1-e"},menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.element.uniqueId().addClass("ui-menu ui-widget ui-widget-content ui-corner-all").toggleClass("ui-menu-icons",!!this.element.find(".ui-icon").length).attr({role:this.options.role,tabIndex:0}).bind("click"+this.eventNamespace,e.proxy(function(e){this.options.disabled&&e.preventDefault()},this)),this.options.disabled&&this.element.addClass("ui-state-disabled").attr("aria-disabled","true"),this._on({"mousedown .ui-menu-item > a":function(e){e.preventDefault()},"click .ui-state-disabled > a":function(e){e.preventDefault()},"click .ui-menu-item:has(a)":function(i){var s=e(i.target).closest(".ui-menu-item");!t&&s.not(".ui-state-disabled").length&&(t=!0,this.select(i),s.has(".ui-menu").length?this.expand(i):this.element.is(":focus")||(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(t){var i=e(t.currentTarget);i.siblings().children(".ui-state-active").removeClass("ui-state-active"),this.focus(t,i)},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(e,t){var i=this.active||this.element.children(".ui-menu-item").eq(0);t||this.focus(e,i)},blur:function(t){this._delay(function(){e.contains(this.element[0],this.document[0].activeElement)||this.collapseAll(t)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(i){e(i.target).closest(".ui-menu").length||this.collapseAll(i),t=!1}})},_destroy:function(){this.element.removeAttr("aria-activedescendant").find(".ui-menu").andSelf().removeClass("ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons").removeAttr("role").removeAttr("tabIndex").removeAttr("aria-labelledby").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-disabled").removeUniqueId().show(),this.element.find(".ui-menu-item").removeClass("ui-menu-item").removeAttr("role").removeAttr("aria-disabled").children("a").removeUniqueId().removeClass("ui-corner-all ui-state-hover").removeAttr("tabIndex").removeAttr("role").removeAttr("aria-haspopup").children().each(function(){var t=e(this);t.data("ui-menu-submenu-carat")&&t.remove()}),this.element.find(".ui-menu-divider").removeClass("ui-menu-divider ui-widget-content")},_keydown:function(t){function i(e){return e.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}var s,n,a,o,r,l=!0;switch(t.keyCode){case e.ui.keyCode.PAGE_UP:this.previousPage(t);break;case e.ui.keyCode.PAGE_DOWN:this.nextPage(t);break;case e.ui.keyCode.HOME:this._move("first","first",t);break;case e.ui.keyCode.END:this._move("last","last",t);break;case e.ui.keyCode.UP:this.previous(t);break;case e.ui.keyCode.DOWN:this.next(t);break;case e.ui.keyCode.LEFT:this.collapse(t);break;case e.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(t);break;case e.ui.keyCode.ENTER:case e.ui.keyCode.SPACE:this._activate(t);break;case e.ui.keyCode.ESCAPE:this.collapse(t);break;default:l=!1,n=this.previousFilter||"",a=String.fromCharCode(t.keyCode),o=!1,clearTimeout(this.filterTimer),a===n?o=!0:a=n+a,r=RegExp("^"+i(a),"i"),s=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(e(this).children("a").text())}),s=o&&-1!==s.index(this.active.next())?this.active.nextAll(".ui-menu-item"):s,s.length||(a=String.fromCharCode(t.keyCode),r=RegExp("^"+i(a),"i"),s=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(e(this).children("a").text())})),s.length?(this.focus(t,s),s.length>1?(this.previousFilter=a,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter):delete this.previousFilter}l&&t.preventDefault()},_activate:function(e){this.active.is(".ui-state-disabled")||(this.active.children("a[aria-haspopup='true']").length?this.expand(e):this.select(e))},refresh:function(){var t,i=this.options.icons.submenu,s=this.element.find(this.options.menus);s.filter(":not(.ui-menu)").addClass("ui-menu ui-widget ui-widget-content ui-corner-all").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var t=e(this),s=t.prev("a"),n=e("<span>").addClass("ui-menu-icon ui-icon "+i).data("ui-menu-submenu-carat",!0);s.attr("aria-haspopup","true").prepend(n),t.attr("aria-labelledby",s.attr("id"))}),t=s.add(this.element),t.children(":not(.ui-menu-item):has(a)").addClass("ui-menu-item").attr("role","presentation").children("a").uniqueId().addClass("ui-corner-all").attr({tabIndex:-1,role:this._itemRole()}),t.children(":not(.ui-menu-item)").each(function(){var t=e(this);/[^\-—–\s]/.test(t.text())||t.addClass("ui-widget-content ui-menu-divider")}),t.children(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!e.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},focus:function(e,t){var i,s;this.blur(e,e&&"focus"===e.type),this._scrollIntoView(t),this.active=t.first(),s=this.active.children("a").addClass("ui-state-focus"),this.options.role&&this.element.attr("aria-activedescendant",s.attr("id")),this.active.parent().closest(".ui-menu-item").children("a:first").addClass("ui-state-active"),e&&"keydown"===e.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),i=t.children(".ui-menu"),i.length&&/^mouse/.test(e.type)&&this._startOpening(i),this.activeMenu=t.parent(),this._trigger("focus",e,{item:t})},_scrollIntoView:function(t){var i,s,n,a,o,r;this._hasScroll()&&(i=parseFloat(e.css(this.activeMenu[0],"borderTopWidth"))||0,s=parseFloat(e.css(this.activeMenu[0],"paddingTop"))||0,n=t.offset().top-this.activeMenu.offset().top-i-s,a=this.activeMenu.scrollTop(),o=this.activeMenu.height(),r=t.height(),0>n?this.activeMenu.scrollTop(a+n):n+r>o&&this.activeMenu.scrollTop(a+n-o+r))},blur:function(e,t){t||clearTimeout(this.timer),this.active&&(this.active.children("a").removeClass("ui-state-focus"),this.active=null,this._trigger("blur",e,{item:this.active}))},_startOpening:function(e){clearTimeout(this.timer),"true"===e.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(e)},this.delay))},_open:function(t){var i=e.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(t.parents(".ui-menu")).hide().attr("aria-hidden","true"),t.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(i)},collapseAll:function(t,i){clearTimeout(this.timer),this.timer=this._delay(function(){var s=i?this.element:e(t&&t.target).closest(this.element.find(".ui-menu"));s.length||(s=this.element),this._close(s),this.blur(t),this.activeMenu=s},this.delay)},_close:function(e){e||(e=this.active?this.active.parent():this.element),e.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false").end().find("a.ui-state-active").removeClass("ui-state-active")},collapse:function(e){var t=this.active&&this.active.parent().closest(".ui-menu-item",this.element);t&&t.length&&(this._close(),this.focus(e,t))},expand:function(e){var t=this.active&&this.active.children(".ui-menu ").children(".ui-menu-item").first();t&&t.length&&(this._open(t.parent()),this._delay(function(){this.focus(e,t)}))},next:function(e){this._move("next","first",e)},previous:function(e){this._move("prev","last",e)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(e,t,i){var s;this.active&&(s="first"===e||"last"===e?this.active["first"===e?"prevAll":"nextAll"](".ui-menu-item").eq(-1):this.active[e+"All"](".ui-menu-item").eq(0)),s&&s.length&&this.active||(s=this.activeMenu.children(".ui-menu-item")[t]()),this.focus(i,s)},nextPage:function(t){var i,s,n;return this.active?(this.isLastItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return i=e(this),0>i.offset().top-s-n}),this.focus(t,i)):this.focus(t,this.activeMenu.children(".ui-menu-item")[this.active?"last":"first"]())),undefined):(this.next(t),undefined)},previousPage:function(t){var i,s,n;return this.active?(this.isFirstItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return i=e(this),i.offset().top-s+n>0}),this.focus(t,i)):this.focus(t,this.activeMenu.children(".ui-menu-item").first())),undefined):(this.next(t),undefined)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(t){this.active=this.active||e(t.target).closest(".ui-menu-item");var i={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(t,!0),this._trigger("select",t,i)}})})(jQuery);jQuery.effects||function(t,e){var i=t.uiBackCompat!==!1,s="ui-effects-";t.effects={effect:{}},function(e,i){function s(t,e,i){var s=u[e.type]||{};return null==t?i||!e.def?null:e.def:(t=s.floor?~~t:parseFloat(t),isNaN(t)?e.def:s.mod?(t+s.mod)%s.mod:0>t?0:t>s.max?s.max:t)}function n(t){var s=h(),n=s._rgba=[];return t=t.toLowerCase(),g(c,function(e,a){var o,r=a.re.exec(t),l=r&&a.parse(r),c=a.space||"rgba";return l?(o=s[c](l),s[d[c].cache]=o[d[c].cache],n=s._rgba=o._rgba,!1):i}),n.length?("0,0,0,0"===n.join()&&e.extend(n,o.transparent),s):o[t]}function a(t,e,i){return i=(i+1)%1,1>6*i?t+6*(e-t)*i:1>2*i?e:2>3*i?t+6*(e-t)*(2/3-i):t}var o,r="backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor".split(" "),l=/^([\-+])=\s*(\d+\.?\d*)/,c=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,parse:function(t){return[t[1],t[2],t[3],t[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,parse:function(t){return[2.55*t[1],2.55*t[2],2.55*t[3],t[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(t){return[t[1],t[2]/100,t[3]/100,t[4]]}}],h=e.Color=function(t,i,s,n){return new e.Color.fn.parse(t,i,s,n)},d={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},u={"byte":{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},p=h.support={},f=e("<p>")[0],g=e.each;f.style.cssText="background-color:rgba(1,1,1,.5)",p.rgba=f.style.backgroundColor.indexOf("rgba")>-1,g(d,function(t,e){e.cache="_"+t,e.props.alpha={idx:3,type:"percent",def:1}}),h.fn=e.extend(h.prototype,{parse:function(a,r,l,c){if(a===i)return this._rgba=[null,null,null,null],this;(a.jquery||a.nodeType)&&(a=e(a).css(r),r=i);var u=this,p=e.type(a),f=this._rgba=[];return r!==i&&(a=[a,r,l,c],p="array"),"string"===p?this.parse(n(a)||o._default):"array"===p?(g(d.rgba.props,function(t,e){f[e.idx]=s(a[e.idx],e)}),this):"object"===p?(a instanceof h?g(d,function(t,e){a[e.cache]&&(u[e.cache]=a[e.cache].slice())}):g(d,function(e,i){var n=i.cache;g(i.props,function(t,e){if(!u[n]&&i.to){if("alpha"===t||null==a[t])return;u[n]=i.to(u._rgba)}u[n][e.idx]=s(a[t],e,!0)}),u[n]&&0>t.inArray(null,u[n].slice(0,3))&&(u[n][3]=1,i.from&&(u._rgba=i.from(u[n])))}),this):i},is:function(t){var e=h(t),s=!0,n=this;return g(d,function(t,a){var o,r=e[a.cache];return r&&(o=n[a.cache]||a.to&&a.to(n._rgba)||[],g(a.props,function(t,e){return null!=r[e.idx]?s=r[e.idx]===o[e.idx]:i})),s}),s},_space:function(){var t=[],e=this;return g(d,function(i,s){e[s.cache]&&t.push(i)}),t.pop()},transition:function(t,e){var i=h(t),n=i._space(),a=d[n],o=0===this.alpha()?h("transparent"):this,r=o[a.cache]||a.to(o._rgba),l=r.slice();return i=i[a.cache],g(a.props,function(t,n){var a=n.idx,o=r[a],c=i[a],h=u[n.type]||{};null!==c&&(null===o?l[a]=c:(h.mod&&(c-o>h.mod/2?o+=h.mod:o-c>h.mod/2&&(o-=h.mod)),l[a]=s((c-o)*e+o,n)))}),this[n](l)},blend:function(t){if(1===this._rgba[3])return this;var i=this._rgba.slice(),s=i.pop(),n=h(t)._rgba;return h(e.map(i,function(t,e){return(1-s)*n[e]+s*t}))},toRgbaString:function(){var t="rgba(",i=e.map(this._rgba,function(t,e){return null==t?e>2?1:0:t});return 1===i[3]&&(i.pop(),t="rgb("),t+i.join()+")"},toHslaString:function(){var t="hsla(",i=e.map(this.hsla(),function(t,e){return null==t&&(t=e>2?1:0),e&&3>e&&(t=Math.round(100*t)+"%"),t});return 1===i[3]&&(i.pop(),t="hsl("),t+i.join()+")"},toHexString:function(t){var i=this._rgba.slice(),s=i.pop();return t&&i.push(~~(255*s)),"#"+e.map(i,function(t){return t=(t||0).toString(16),1===t.length?"0"+t:t}).join("")},toString:function(){return 0===this._rgba[3]?"transparent":this.toRgbaString()}}),h.fn.parse.prototype=h.fn,d.hsla.to=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e,i,s=t[0]/255,n=t[1]/255,a=t[2]/255,o=t[3],r=Math.max(s,n,a),l=Math.min(s,n,a),c=r-l,h=r+l,d=.5*h;return e=l===r?0:s===r?60*(n-a)/c+360:n===r?60*(a-s)/c+120:60*(s-n)/c+240,i=0===d||1===d?d:.5>=d?c/h:c/(2-h),[Math.round(e)%360,i,d,null==o?1:o]},d.hsla.from=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e=t[0]/360,i=t[1],s=t[2],n=t[3],o=.5>=s?s*(1+i):s+i-s*i,r=2*s-o;return[Math.round(255*a(r,o,e+1/3)),Math.round(255*a(r,o,e)),Math.round(255*a(r,o,e-1/3)),n]},g(d,function(t,n){var a=n.props,o=n.cache,r=n.to,c=n.from;h.fn[t]=function(t){if(r&&!this[o]&&(this[o]=r(this._rgba)),t===i)return this[o].slice();var n,l=e.type(t),d="array"===l||"object"===l?t:arguments,u=this[o].slice();return g(a,function(t,e){var i=d["object"===l?t:e.idx];null==i&&(i=u[e.idx]),u[e.idx]=s(i,e)}),c?(n=h(c(u)),n[o]=u,n):h(u)},g(a,function(i,s){h.fn[i]||(h.fn[i]=function(n){var a,o=e.type(n),r="alpha"===i?this._hsla?"hsla":"rgba":t,c=this[r](),h=c[s.idx];return"undefined"===o?h:("function"===o&&(n=n.call(this,h),o=e.type(n)),null==n&&s.empty?this:("string"===o&&(a=l.exec(n),a&&(n=h+parseFloat(a[2])*("+"===a[1]?1:-1))),c[s.idx]=n,this[r](c)))})})}),g(r,function(t,i){e.cssHooks[i]={set:function(t,s){var a,o,r="";if("string"!==e.type(s)||(a=n(s))){if(s=h(a||s),!p.rgba&&1!==s._rgba[3]){for(o="backgroundColor"===i?t.parentNode:t;(""===r||"transparent"===r)&&o&&o.style;)try{r=e.css(o,"backgroundColor"),o=o.parentNode}catch(l){}s=s.blend(r&&"transparent"!==r?r:"_default")}s=s.toRgbaString()}try{t.style[i]=s}catch(c){}}},e.fx.step[i]=function(t){t.colorInit||(t.start=h(t.elem,i),t.end=h(t.end),t.colorInit=!0),e.cssHooks[i].set(t.elem,t.start.transition(t.end,t.pos))}}),e.cssHooks.borderColor={expand:function(t){var e={};return g(["Top","Right","Bottom","Left"],function(i,s){e["border"+s+"Color"]=t}),e}},o=e.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"}}(jQuery),function(){function i(){var e,i,s=this.ownerDocument.defaultView?this.ownerDocument.defaultView.getComputedStyle(this,null):this.currentStyle,n={};if(s&&s.length&&s[0]&&s[s[0]])for(i=s.length;i--;)e=s[i],"string"==typeof s[e]&&(n[t.camelCase(e)]=s[e]);else for(e in s)"string"==typeof s[e]&&(n[e]=s[e]);return n}function s(e,i){var s,n,o={};for(s in i)n=i[s],e[s]!==n&&(a[s]||(t.fx.step[s]||!isNaN(parseFloat(n)))&&(o[s]=n));return o}var n=["add","remove","toggle"],a={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};t.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(e,i){t.fx.step[i]=function(t){("none"!==t.end&&!t.setAttr||1===t.pos&&!t.setAttr)&&(jQuery.style(t.elem,i,t.end),t.setAttr=!0)}}),t.effects.animateClass=function(e,a,o,r){var l=t.speed(a,o,r);return this.queue(function(){var a,o=t(this),r=o.attr("class")||"",c=l.children?o.find("*").andSelf():o;c=c.map(function(){var e=t(this);return{el:e,start:i.call(this)}}),a=function(){t.each(n,function(t,i){e[i]&&o[i+"Class"](e[i])})},a(),c=c.map(function(){return this.end=i.call(this.el[0]),this.diff=s(this.start,this.end),this}),o.attr("class",r),c=c.map(function(){var e=this,i=t.Deferred(),s=jQuery.extend({},l,{queue:!1,complete:function(){i.resolve(e)}});return this.el.animate(this.diff,s),i.promise()}),t.when.apply(t,c.get()).done(function(){a(),t.each(arguments,function(){var e=this.el;t.each(this.diff,function(t){e.css(t,"")})}),l.complete.call(o[0])})})},t.fn.extend({_addClass:t.fn.addClass,addClass:function(e,i,s,n){return i?t.effects.animateClass.call(this,{add:e},i,s,n):this._addClass(e)},_removeClass:t.fn.removeClass,removeClass:function(e,i,s,n){return i?t.effects.animateClass.call(this,{remove:e},i,s,n):this._removeClass(e)},_toggleClass:t.fn.toggleClass,toggleClass:function(i,s,n,a,o){return"boolean"==typeof s||s===e?n?t.effects.animateClass.call(this,s?{add:i}:{remove:i},n,a,o):this._toggleClass(i,s):t.effects.animateClass.call(this,{toggle:i},s,n,a)},switchClass:function(e,i,s,n,a){return t.effects.animateClass.call(this,{add:i,remove:e},s,n,a)}})}(),function(){function n(e,i,s,n){return t.isPlainObject(e)&&(i=e,e=e.effect),e={effect:e},null==i&&(i={}),t.isFunction(i)&&(n=i,s=null,i={}),("number"==typeof i||t.fx.speeds[i])&&(n=s,s=i,i={}),t.isFunction(s)&&(n=s,s=null),i&&t.extend(e,i),s=s||i.duration,e.duration=t.fx.off?0:"number"==typeof s?s:s in t.fx.speeds?t.fx.speeds[s]:t.fx.speeds._default,e.complete=n||i.complete,e}function a(e){return!e||"number"==typeof e||t.fx.speeds[e]?!0:"string"!=typeof e||t.effects.effect[e]?!1:i&&t.effects[e]?!1:!0}t.extend(t.effects,{version:"1.9.2",save:function(t,e){for(var i=0;e.length>i;i++)null!==e[i]&&t.data(s+e[i],t[0].style[e[i]])},restore:function(t,i){var n,a;for(a=0;i.length>a;a++)null!==i[a]&&(n=t.data(s+i[a]),n===e&&(n=""),t.css(i[a],n))},setMode:function(t,e){return"toggle"===e&&(e=t.is(":hidden")?"show":"hide"),e},getBaseline:function(t,e){var i,s;switch(t[0]){case"top":i=0;break;case"middle":i=.5;break;case"bottom":i=1;break;default:i=t[0]/e.height}switch(t[1]){case"left":s=0;break;case"center":s=.5;break;case"right":s=1;break;default:s=t[1]/e.width}return{x:s,y:i}},createWrapper:function(e){if(e.parent().is(".ui-effects-wrapper"))return e.parent();var i={width:e.outerWidth(!0),height:e.outerHeight(!0),"float":e.css("float")},s=t("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),n={width:e.width(),height:e.height()},a=document.activeElement;try{a.id}catch(o){a=document.body}return e.wrap(s),(e[0]===a||t.contains(e[0],a))&&t(a).focus(),s=e.parent(),"static"===e.css("position")?(s.css({position:"relative"}),e.css({position:"relative"})):(t.extend(i,{position:e.css("position"),zIndex:e.css("z-index")}),t.each(["top","left","bottom","right"],function(t,s){i[s]=e.css(s),isNaN(parseInt(i[s],10))&&(i[s]="auto")}),e.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),e.css(n),s.css(i).show()},removeWrapper:function(e){var i=document.activeElement;return e.parent().is(".ui-effects-wrapper")&&(e.parent().replaceWith(e),(e[0]===i||t.contains(e[0],i))&&t(i).focus()),e},setTransition:function(e,i,s,n){return n=n||{},t.each(i,function(t,i){var a=e.cssUnit(i);a[0]>0&&(n[i]=a[0]*s+a[1])}),n}}),t.fn.extend({effect:function(){function e(e){function i(){t.isFunction(a)&&a.call(n[0]),t.isFunction(e)&&e()}var n=t(this),a=s.complete,o=s.mode;(n.is(":hidden")?"hide"===o:"show"===o)?i():r.call(n[0],s,i)}var s=n.apply(this,arguments),a=s.mode,o=s.queue,r=t.effects.effect[s.effect],l=!r&&i&&t.effects[s.effect];return t.fx.off||!r&&!l?a?this[a](s.duration,s.complete):this.each(function(){s.complete&&s.complete.call(this)}):r?o===!1?this.each(e):this.queue(o||"fx",e):l.call(this,{options:s,duration:s.duration,callback:s.complete,mode:s.mode})},_show:t.fn.show,show:function(t){if(a(t))return this._show.apply(this,arguments);var e=n.apply(this,arguments);return e.mode="show",this.effect.call(this,e)},_hide:t.fn.hide,hide:function(t){if(a(t))return this._hide.apply(this,arguments);var e=n.apply(this,arguments);return e.mode="hide",this.effect.call(this,e)},__toggle:t.fn.toggle,toggle:function(e){if(a(e)||"boolean"==typeof e||t.isFunction(e))return this.__toggle.apply(this,arguments);var i=n.apply(this,arguments);return i.mode="toggle",this.effect.call(this,i)},cssUnit:function(e){var i=this.css(e),s=[];return t.each(["em","px","%","pt"],function(t,e){i.indexOf(e)>0&&(s=[parseFloat(i),e])}),s}})}(),function(){var e={};t.each(["Quad","Cubic","Quart","Quint","Expo"],function(t,i){e[i]=function(e){return Math.pow(e,t+2)}}),t.extend(e,{Sine:function(t){return 1-Math.cos(t*Math.PI/2)},Circ:function(t){return 1-Math.sqrt(1-t*t)},Elastic:function(t){return 0===t||1===t?t:-Math.pow(2,8*(t-1))*Math.sin((80*(t-1)-7.5)*Math.PI/15)},Back:function(t){return t*t*(3*t-2)},Bounce:function(t){for(var e,i=4;((e=Math.pow(2,--i))-1)/11>t;);return 1/Math.pow(4,3-i)-7.5625*Math.pow((3*e-2)/22-t,2)}}),t.each(e,function(e,i){t.easing["easeIn"+e]=i,t.easing["easeOut"+e]=function(t){return 1-i(1-t)},t.easing["easeInOut"+e]=function(t){return.5>t?i(2*t)/2:1-i(-2*t+2)/2}})}()}(jQuery);(function(e){e.effects.effect.highlight=function(t,i){var s=e(this),n=["backgroundImage","backgroundColor","opacity"],a=e.effects.setMode(s,t.mode||"show"),o={backgroundColor:s.css("backgroundColor")};"hide"===a&&(o.opacity=0),e.effects.save(s,n),s.show().css({backgroundImage:"none",backgroundColor:t.color||"#ffff99"}).animate(o,{queue:!1,duration:t.duration,easing:t.easing,complete:function(){"hide"===a&&s.hide(),e.effects.restore(s,n),i()}})}})(jQuery);
//********************************************
//
//	Copyright Mobifriends S.L. 2007
//	
//	programador: Javier Velasco Gonzalez	
//
//********************************************


var interval=0;

function onLenguajeMouseOn() {
	Show('ch_idioma_options',true);
	if (interval) clearInterval(interval);
	interval = 0;
}

function onLenguajeClickOn() {
	SwapShow('ch_idioma_options');
	if (interval) clearInterval(interval);
	interval = 0;
}

function hideLenguajeBox() {
	Show('ch_idioma_options',false);
	if (interval) clearInterval(interval);
	interval = 0;
}

function onLenguajeBoxMouseOut() {
	if (interval>0) return;
	interval = setInterval("hideLenguajeBox()",500);
}

function setPreferencia(link){
	var newLink = link.href + '?setLang=1';
	link.href = newLink;
	
	return true;
}

// Clear user and password fields, password type is changed to password.
// This function supports Mozilla Firefox and Explorer 6 and 7.
function prepare_login_form() {
	uc = document.getElementById("user");
	uc.value = "";
	pc = document.getElementById("password");
    pc.value = "1"; //fix chrome autofill password but dom value  ""
	pc.value = "";
}

function changeCountry(countryName){
	document.getElementById('countryName').value = countryName;
}

function cambiaQueEste() {
	qediv = document.getElementById("queeste_div");
	provdiv = document.getElementById("provincia_div");
	qediv.style.visibility = 'hidden';
	qediv.style.height = '0px';
	provdiv.style.visibility = 'visible';
	provdiv.style.height = '100%';
}

function volverQueEste(locationlevel) {
    // Intente pasar un string pero al generarse en index_form no pude pasarlo ni con \" o \'
    // 1 = pais; 2 = provincia; 3 = poblacion
    document.getElementById('renderRegions').value = 0;
    if(locationlevel != 3){
        // No actualizar si es poblacion
        provincia = document.getElementById("provincia");
        provincia.selectedIndex = 0;
    }
    country = document.getElementById("country");
    country.selectedIndex = 0;
    busquedaPresentacion0();
    document.getElementById('renderRegions').value = 1;

    qediv = document.getElementById("queeste_div");
    provdiv = document.getElementById("provincia_div");
    qediv.style.visibility = 'visible';
    qediv.style.height = '100%';
    provdiv.style.visibility = 'hidden';
    provdiv.style.height = '0px';
}

function cancelRegister() {
}
	

function continuarSubirFoto() {
}



//********************************************
//
//	Copyright Mobifriends S.L. 2007
//	
//	programador: Javier Velasco Gonzalez	
//
//********************************************

//********************************************
// devuelve la version de explorer o 0.
//--------------------------------------------
 
function isExplorer() {
	if (navigator.appName=="Microsoft Internet Explorer") {
		var iversion = navigator.appVersion.indexOf("MSIE ");
		if (iversion>0) {
			iversion+=5;
			var eversion = navigator.appVersion.indexOf(";",iversion);
			var version = navigator.appVersion.substring(iversion,eversion);
			return parseInt(version);
		}
	} else return 0;
}

//********************************************
// devuelve la version de firefox o 0.
//--------------------------------------------
function isFirefox() {
	if (navigator.appName.indexOf("Netscape")!=-1 && parseInt(navigator.appVersion)>=5) {
		var iversion = navigator.userAgent.indexOf("Firefox/");
		if (iversion>0) {
			iversion+=8;
			var eversion = navigator.userAgent.indexOf(" ",iversion);
			if (eversion<navigator.userAgent.length) eversion = navigator.userAgent.length;
			var version = navigator.userAgent.substring(iversion,iversion + 1000);
			return parseInt(version);
		} else return 0;
	}
	else return 0;
}


function getWindowWidth() {
  var width = 0;
  if( typeof( window.innerWidth ) == 'number' ) {
    //Non-IE
    if( document.body && document.body.clientWidth) width = document.body.clientWidth;
    else width = window.innerWidth;
  } else if( document.documentElement && document.documentElement.clientWidth) {
    //IE 6+ in 'standards compliant mode'
    width = document.documentElement.clientWidth;
  } else if( document.body && document.body.clientWidth) {
    //IE 4 compatible
    width = document.body.clientWidth;
  }
  return width;
}

function getWindowHeight() {
  var height = 0;
  if( typeof( window.innerWidth ) == 'number' ) {
    //Non-IE
    if( document.body && document.body.clientHeighth) height = document.body.clientHeight;
    else height = window.innerHeight;
  } else if( document.documentElement && document.documentElement.clientHeight ) {
    //IE 6+ in 'standards compliant mode'
    height = document.documentElement.clientHeight;
  } else if( document.body && document.body.clientHeight ) {
    //IE 4 compatible
    height = document.body.clientHeight;
  }
  return height;
}


function getDocumentHeight() {
	var height = document.height;
	//if (!height) height = document.docubody.clientHeight;
	if (!height) height = document.documentElement.scrollHeight;

	if (height<getWindowHeight()) height = getWindowHeight();

	return height;
}


function getDocumentWidth() {
	var width = document.width;
//	if (!width) width = document.body.clientWidth;
	if (!width) width = document.documentElement.scrollWidth;
	if (width<getWindowWidth()) width = getWindowWidth();
	return width;
}

function getHScrollPos() {
	var vExplorer = isExplorer();
	var pos;
	if (vExplorer) {
		pos = document.documentElement.scrollLeft;
		if (!pos) pos = document.body.scrollLeft;
	} else {
		pos=window.pageXOffset;		
	}
	return pos;	
}

function getVScrollPos() {
	var vExplorer = isExplorer();
	var pos;
	if (vExplorer) {
		pos = document.documentElement.scrollTop;
		if (!pos) pos = document.body.scrollTop;
	} else {
		pos=window.pageYOffset;		
	}
	return pos;	
}

function getVScrollAdjustments() {
	var screenHeight = getWindowHeight();
	var vScrollPos =  getVScrollPos();
	return screenHeight +"," +vScrollPos;
}


//********************************************
// envia el formulario con el id = formid.
//--------------------------------------------
//
// @params:
//	formid: attributo id del form.
//
// @return: 
//
//********************************************
function submitFormById(formid,enabledloader) {
	if (enabledloader) {
		var wwidth = getWindowWidth();
		var wheight = getWindowHeight();
		CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","",null,"30");
		CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",sLoadingMessage,null,sLoadingOpacity,"loading-window");		
	}

	f = document.getElementById(formid)
	f.submit();
}

//********************************************
// devuelve el valor de un campo.
//--------------------------------------------
//
// @params:
//	id: id del campo.
//
// @return: 
//	devuelve el valor de un campo en funcion de el id.
//
//********************************************
function getValue(id) {
	f = document.getElementById(id);
	return f.value;
}

//********************************************
// establece el valor de un campo.
//--------------------------------------------
//
// @params:
//	id: id del campo.
//
// @return: 
//
//********************************************
function setValue(id,value) {
	f = document.getElementById(id);
	if (f==null) return;
	switch (f.tagName.toLowerCase()) {
		case "select":
			f.value = value;
		break;
		case "input":
			f.value = value;
			if (f.type=="checkbox") {
				if (value==0) f.checked = null;
				else f.checked= true;
			}
		break;
		case "div":
			otype = document.getElementById(id+"__type");
			olenght = document.getElementById(id+"__length");
			if (otype==null) return;
			switch (otype.value) {
				case "mcheckbox":
					for (i=0;i<olenght.value;i++) {
						o = document.getElementById(id+String(i));
						if (o.value==value) {
							o.checked = true;
							return;
						}
					}
				break;				
			}
		break;
	}
}


//********************************************
// limpia los checkboxes 
//--------------------------------------------
//
// @params:
//	id: id del multiple checkbox.
//
// @return: 
//
//********************************************
function clearMCheckbox(id) {
	f = document.getElementById(id);
	if (f==null) return;
	otype = document.getElementById(id+"__type");
	olenght = document.getElementById(id+"__length");
	if (otype==null || otype.value!="mcheckbox") return;
	for (i=0;i<olenght.value;i++) {
		o = document.getElementById(id+String(i));
		o.checked=null;
	}
}

//********************************************
// borra todas las referencias dentro de un objeto
// de forma recursiva.
// Se usa para prevenir el memory leak de explorer,
// tiene que ser llamada antes de un setInnerHTML
// y antes de un removeChild.
//--------------------------------------------
function purge(d) {
    var a = d.attributes, i, l, n;
    if (a) {
        l = a.length;
        for (i = 0; i < l; i += 1) {
        	try{
            	n = a[i].name;
            }catch(e){
            	return;
            }
            if (typeof d[n] === 'function') {
                d[n] = null;
            }
        }
    }
    a = d.childNodes;
    if (a) {
        l = a.length;
        for (i = 0; i < l; i += 1) {
            purge(d.childNodes[i]);
        }
    }
}
//********************************************
// establece el html dentro de una etiqueta.
//--------------------------------------------
//
// @params:
//	id: id del campo.
//
// @return: 
//
//********************************************
function setInnerHTML(id,text) {
	f = document.getElementById(id);
	if (f==null) return;//alert("No encuentra" + id);
	else {
		if (isExplorer()) purge(f);
		f.innerHTML = text;
	}
}


function urldecode( str ) {
    var histogram = {}, histogram_r = {}, code = 0, str_tmp = [];
    var ret = str.toString();
    
    var replacer = function(search, replace, str) {
        var tmp_arr = [];
        tmp_arr = str.split(search);
        return tmp_arr.join(replace);
    };
    
    histogram['!']   = '%21';
    histogram['%20'] = '+';
    
    for (replace in histogram) {
        search = histogram[replace]; // Switch order when decoding
        ret = replacer(search, replace, ret) // Custom replace. No regexing   
    }
    
    ret = decodeURIComponent(ret);
    return ret;
}

function striptags(str) {
	var flip = false;
	var result="";
	for (c in str) {
		if (str[c]=='<') flip=true;
		else if (str[c]=='>') flip=false;
		else if (!flip) result+=str[c];
	}
	return result;
}


function setInnerEHTML(id,text) {
	f = document.getElementById(id);
	if (f==null) return; //alert("No encuentra" + id);
	else {
		purge(f);
		f.innerHTML = urldecode(text);
	}
}


//Rellena un campo select con valores numericos.
function fillNumbersCombo(id,nini,nfin,value,rellenarconceros) {
	options = "";
	snfin = nfin.toString();
	snini = nini.toString();
	maxlen = snfin.length;
	if (snini.length>maxlen) maxlen = snini.length ;
	/*
	for (i=nini;;) {
		stri = i.toString();
		if (rellenarconceros) {
			len = stri.length;
			for (j=0;j<maxlen-len;j++) stri = "0"+stri;
		}
		if (value!=i) options += "<option value='" + i.toString()+"'>" + stri + "</option>";
		else options += "<option selected='true' value='" + i.toString()+"'>" + stri + "</option>";
		//test del loop.		
		if (nini<nfin) {
			if (i>=nfin) break;
			i++
		} else {
			if (i<=nfin) break;
			i--;
		}
	}*/
	setInnerHTML(id,options);
}

//********************************************
// devuelve el valor de un elemento del tipo INPUT.
//--------------------------------------------
//
// @params:
//	fieldid: id del elemento INPUT.
//
// @return: 
//	devuelve una cadena con el valor del INPUT
//
//********************************************
function getInputValueById(fieldid) {
	f = document.getElementById(fieldid)
	return f.value;
}

//********************************************
// cambia el elemento seleccionado en un SELECT.
//--------------------------------------------
//
// @params:
//	formid: attributo id del form.
//	comboname: nombre del campo SELECT.
//	value: attributo value del OPTION a seleccionar.
//
// @return: 
//	devuelve una cadena con el valor del INPUT
//
//********************************************
function setComboByValue(formid,comboname,value) {
	f = document.getElementById(formid)
	if(typeof XMLHttpRequest!='undefined') {
		element = f.elements[comboname];
	} else {
		element = f.all[comboname];
	}
	var attrs="";
	for (i=0;i<element.length;i++) {
		var option = element[i];
		if (option.tagName=="OPTION" && 
			option.value==value) {
			element.selectedIndex=i;
		} 
	}
}

//********************************************
// cambia el elemento seleccionado en un SELECT.
//--------------------------------------------
//
// @params:
//	formid: attributo id del form.
//	comboname: nombre del campo SELECT.
//	text: texto de la opcion a seleccionar.
//
// @return: 
//
//********************************************
function setComboByText(formid,comboname,text) {
	f = document.getElementById(formid)
	if(typeof XMLHttpRequest!='undefined') {
		element = f.elements[comboname];
	} else {
		element = f.all[comboname];
	}
	var attrs="";
	for (i=0;i<element.length;i++) {
		var option = element[i];
		if (option.tagName=="OPTION" && 
			option.innerText==text) {
			element.selectedIndex=i;
		} 
	}
}

//********************************************
// establece el valor de un campo INPUT.
//--------------------------------------------
//
// @params:
//	formid: attributo id del form.
//	fieldname: nombre del campo INPUT.
//	value: valor para el campo INPUT.
//
// @return: 
//
//********************************************
function setInput(formid,fieldname,value) {
	f = document.getElementById(formid)
	if(typeof XMLHttpRequest!='undefined') {
		element = f.elements[fieldname];
	} else {
		element = f.all[fieldname];
	}
	element.value = value;
}

//********************************************
// devuelve el estilo de un elemento.
//--------------------------------------------
//
// @params:
//	id: attributo id del elemento.
//
// @return: 
//
//********************************************
function getStyleById(id) {
	element = document.getElementById(id)
	return element.style;
}


//Funciones de validacion

//********************************************
// valida que sea una direccion de correo valida.
//--------------------------------------------
//
// @params:
//	email: cadena de texto que contiene el email.
//
// @return: 
//	true si es correcta o false si es incorrecta.
//
//********************************************
function validateEmail(email) {
	var parts = email.split('@');
	if (parts.length!=2) return false;
	var user = parts[0];
	var server = parts[1];
	parts = server.split('.');
	if (parts.length<1) return false;
	else return true;
}

//********************************************
// valida que sea un numero.
//--------------------------------------------
//
// @params:
//	number: cadena de texto que contiene el numero.
//
// @return: 
//	true si es correcta o false si es incorrecta.
//
//********************************************
function validateIsNumber(number) {
	for (i=0;i<number.length;i++) {
		var ch = number.charAt(i);
		if (ch!='0' && ch!='1' && ch!='2' && ch!='3' && ch!='4' && ch!='5' && ch!='6' && ch!='7' && ch!='8' && ch!='9')
		return false;
	}
	return true;
}

//********************************************
// valida que sea un numero de telefono valido.
//--------------------------------------------
//
// @params:
//	number: cadena de texto que contiene el numero.
//
// @return: 
//	true si es correcta o false si es incorrecta.
//
//********************************************
function validateIsPhoneNumber(number) {
	for (i=0;i<number.length;i++) {
		var ch = number.charAt(i);
		if (ch!='0' && ch!='1' && ch!='2' && ch!='3' && ch!='4' && ch!='5' && ch!='6' && ch!='7' && ch!='8' && ch!='9')
		return false;
	}
	return true;
}


var WINDOW_TYPE_MODAL=1;
var WINDOW_HCENTERED=2;
var WINDOW_VCENTERED=4;

var __windows = new Array();
var __zIndex = 1000;

function CreateIFrame(id,x,y,width,height,color,opac) {
        var windowdiv = document.createElement('iframe');
        windowdiv.setAttribute('id',id);
        windowdiv.setAttribute('class',"windowiframe");
        windowdiv.src='javascript:false;';
        zi = __zIndex++;
        var div = document.getElementsByTagName("body")[0];
        if (opac!=null) windowdiv.style.filter = "alpha(opacity=" + opac + ")";
        windowdiv.style.position="absolute";
        windowdiv.style.zIndex=zi;
        windowdiv.style.top=y;
        windowdiv.style.left=x;
        if (width!=null)  windowdiv.style.width=width;
        if (height!=null) windowdiv.style.height=height;
        if (color!=null) windowdiv.style.background = color;
        div.appendChild(windowdiv);
        __windows.push(windowdiv);
}


var allSelects = new Array(); //fix Explorer 6, array con los selects.
var activeWindows = 0; // for fix window mode on flash objects in IE
//********************************************
// Crea una div dinamicamente
//--------------------------------------------
//
// @params:
//	id: atributo id de la div.
//	x: posicion x dentro de la ventana, debe ser expresada como cadena indicando la unidad %,px etc.
//	y: posicion y dentro de la ventana, debe ser expresada como cadena indicando la unidad %,px etc
//	width: ancho de la ventana, debe ser expresada como cadena indicando la unidad %,px etc
//	height: alto de la ventana, debe ser expresada como cadena indicando la unidad %,px etc
//	html: contenido xhtml de la div.
//	color: color de fondo si lo tuviera sino el atributo es omitido (transparente).
//	opac: opacidad de la capa indicado en %.
//
// @return: 
//
//********************************************
function CreateWindow(id,x,y,width,height,html,color,opac,sClassName) {
	
	var windowdiv = document.createElement('div');
	var vExplorer = isExplorer();
	var windowClass = "string" === typeof sClassName ? sClassName:"window";
	
	windowdiv.setAttribute('id',id);
	windowdiv.setAttribute('class',windowClass);
	__zIndex+=500;
	zi = __zIndex;
	var div = document.getElementsByTagName("body")[0];

	windowdiv.innerHTML = html;
	if (vExplorer==7 || vExplorer==6) {windowdiv.innerHTML="<div class='"+windowClass+"'>"+html+"</div>";}
	if (isFirefox()) {
	    if (opac!=null) {
	    	fopac = opac/100;
	    	windowdiv.style.MozOpacity=fopac;
	    }
	} 
	if (vExplorer>6) {
		if (opac!=null) windowdiv.style.filter = "alpha(opacity=" + opac + ")";
		windowdiv.style.position="absolute";
		
	} else if (vExplorer<=6 && vExplorer>3) {
		if (opac!=null) {windowdiv.style.filter = "alpha(opacity=" + opac + ")";}
		windowdiv.style.background="#FFF";
		windowdiv.style.position="absolute";
	} else {
		windowdiv.style.position="fixed";
	}
	//añadidos para cambiar la opacity de Opera y Safari
	//como no hay funcion para detectar estos navegadores y no afecta a los otros lo he puesto directamente aqui.
	if (opac!=null) {
	  	fopac = opac/100;
	   	windowdiv.style.opacity=fopac;
	}

	windowdiv.style.display="block";
	windowdiv.style.top=y;
	windowdiv.style.left=x;
	
	if (vExplorer>=8) {
		div.style.zIndex=10;
		windowdiv.style.zIndex=zi;
	} else {
		windowdiv.style.zIndex=zi;
	}
	if (width!=null)  windowdiv.style.width=width;
	if (height!=null) windowdiv.style.height=height;
	if (color!=null) windowdiv.style.background = color;
		
	div.appendChild(windowdiv);
}

function updateFlashHeaderDetails() {
  // Probando en Chrome 33, Firefox 27, IE8, Opera y funciona con FlashHead en todos los navegadores
  /*
	var isIE  = (navigator.appVersion.indexOf("MSIE") !== -1) ? true : false;
	var isWin = (navigator.appVersion.toLowerCase().indexOf("win") !== -1) ? true : false;
	var isOpera = (navigator.userAgent.indexOf("Opera") !== -1) ? true : false;
	var fo = document.getElementById("FlashHead");
	if (isIE && isWin && !isOpera) {
		fo = document.getElementById("FlashHead");
	} else {
		fo = document.getElementById("mzFlashHead");
	}
	*/
  fo = document.getElementById("FlashHead");
	try {
		fo.headRefreshData();
	} catch (ex) {}	

}

function updateFlashHeaderWindowMode(wmode){
}

function CreateIEWindow(id,x,y,width,height,html,color,opac) {
	var windowdiv = document.createElement('div');
	var vExplorer = isExplorer();
	windowdiv.setAttribute('id',id + "_parent");
	//windowdiv.setAttribute('class',"window");
	
	var div = document.getElementsByTagName("body")[0];
	if (opac!=null) windowdiv.style.filter = "alpha(opacity=" + opac + ")";
	windowdiv.style.position="absolute";
	//a�adidos para cambiar la opacity de Opera y Safari
	//como no hay funcion para detectar estos navegadores y no afecta a los otros lo he puesto directamente aqui.
	if (opac!=null) {
	  	fopac = opac/100;
	   	windowdiv.style.opacity=fopac;
	}
	divzi = __zIndex++;
	zi = __zIndex++;
	html = "<iframe style='position:absolute; "+
			" src='javascript:false;'" + 
			" top:0px;" + 
			" left:0px;" + 
			" width: 1px;" + 
			" height: 1px;" +
			" z-index: " + zi + ";'" + 
			" id='" + id + "_iframe' >'</iframe>";
	zi = __zIndex++;
	html = html + "<div style='position:absolute; top:0px; left:0px; " + 
			"z-index:" + zi +";' id='" + id + "' ></div>";	
	windowdiv.innerHTML = html;
	windowdiv.style.display="block";
	windowdiv.style.zIndex=divzi;
	windowdiv.style.top=y;
	windowdiv.style.left=x;
	if (width!=null)  windowdiv.style.width=width;
	if (height!=null) windowdiv.style.height=height;
	if (color!=null) windowdiv.style.background = color;
	div.appendChild(windowdiv);
	__windows.push(windowdiv);
	iframe = document.getElementById(id+"_iframe");
	newdiv = document.getElementById(id);
	iframe.style.width = newdiv.clientWidth;
	iframe.style.height = newdiv.clientHeight;
}


var __window_selected=null;


// Global variables
xMousePos = 0; // Horizontal position of the mouse on the screen
yMousePos = 0; // Vertical position of the mouse on the screen
xStartPos = null; // Horizontal position of the mouse on the screen
yStartPos = null; // Vertical position of the mouse on the screen

function captureMousePosition(e) {
	var vExplorer = isExplorer();
	if (!e) e = window.event;
	if (!e.pageX) {
    	xMousePos = e.clientX;
    	yMousePos = e.clientY;
    	
	} else {
    	xMousePos = e.pageX;
    	yMousePos = e.pageY;
	}
	window.status="x:" + xMousePos + " y:" + yMousePos;
	//setInnerHTML('debug',xMousePos + "," + yMousePos)
}

function MoveWindow(e) {
	captureMousePosition(e);	
	if (!xStartPos) {
		xStartPos = xMousePos;
		yStartPos = yMousePos;
	}
    if (__window_selected!=null) {
    	x = parseInt(__window_selected.style.left) + xMousePos - xStartPos;
    	y = parseInt(__window_selected.style.top) + yMousePos - yStartPos;
   		__window_selected.style.left = x + "px";
		__window_selected.style.top = y + "px";
    }
	xStartPos = xMousePos;
	yStartPos = yMousePos;
}


function StartMoveWindow(id) {
	var vExplorer = isExplorer();
	if (vExplorer==6) id=id+"_parent";
	
	//RaiseWindow(id);
	xStartPos = null;
	__window_selected = document.getElementById(id);
	if (document.layers) { // Netscape
	    document.onmousemove = MoveWindow;
    	document.onmouseup = StopMoveWindow;
	} else if (document.all) { // Internet Explorer
	    document.onmousemove = MoveWindow;
    	document.onmouseup = StopMoveWindow;
	} else if (document.getElementById) { // Netcsape 6
    	document.onmousemove = MoveWindow;
    	document.onmouseup = StopMoveWindow;
	}
}

var ic=0;
function testScroll(e) {
	setInnerHTML('debug',ic + ":=" + getHScrollPos() + "," + getVScrollPos() + "  " + getDocumentWidth() + "x" + getDocumentHeight());
	ic++;
}

function StopMoveWindow(id) {
    document.onmousemove = null;
    document.onmouseup = null;
	__window_selected = null;
}



function CreateURLWindow(id,x,y,url) {
	activeWindows=1;

	if(isExplorer()>0){
		y += getVScrollPos();
	}
	
	var wwidth = getDocumentWidth();
	var wheight = getDocumentHeight();
	
	var vExplorer = isExplorer();
	var cx = 0;
	var cy = 0;
	// This window will never be destroyed so decrement activeWindows
	CreateWindow(id + "bg","0px","0px",wwidth + "px",wheight + "px","","#000000","30");
	//if (vExplorer==6) CreateIFrame(id + "bg","0px","0px",wwidth + "px",wheight + "px","#000000","30");
	//else CreateWindow(id + "bg","0px","0px",wwidth + "px",wheight + "px","","#000000","30");
	if (vExplorer==6) {
		//CreateIEWindow(id,x + 'px',y + 'px',null,null,"",null,null);
		CreateWindow(id,x + 'px',y + 'px',null,null,"",null,null);
		//Vamos a ocultar todos los select visibles y ponerlos en un array.
		allSelects[id] = new Array();
		selects = document.getElementsByTagName('select');
		for (i=0;i<selects.length;i++) {
			if (selects[i].style.visibility!='hidden') {
				allSelects[id].push(selects[i]);
				selects[i].style.visibility='hidden';
			}
		}
	}
	else {
		CreateWindow(id,x + 'px',y + 'px',null,null,"",null,null);
	}
	ajax_call(id,url,null);
}


function CreateStaticWindow(id,x,y, title, msg, closeButtonText) {
    activeWindows=1;

    if(isExplorer()>0){
        y += getVScrollPos();
    }

    var wwidth = getDocumentWidth();
    var wheight = getDocumentHeight();

    var vExplorer = isExplorer();
    var cx = 0;
    var cy = 0;
    // This window will never be destroyed so decrement activeWindows
    CreateWindow(id + "bg","0px","0px",wwidth + "px",wheight + "px","","#000000","30");
    //if (vExplorer==6) CreateIFrame(id + "bg","0px","0px",wwidth + "px",wheight + "px","#000000","30");
    //else CreateWindow(id + "bg","0px","0px",wwidth + "px",wheight + "px","","#000000","30");

    var content = '<div id="infopopup">' +
        '<div id="cerrar"><a id="boton_cerrar_popup" href="javascript:DestroyWindow(\''+id+'\');"><img src="/images/1/popups/cerrar.gif" /></a></div><div id="titulo_crear_carpeta" class="titulo" onmousedown="StartMoveWindow(\''+id+'\');" onmouseup="StopMoveWindow(\''+id+'\');" >' +title+ '</div>	<div class="texto">' +
        msg +'</div>' +
        '<div id="botones">' +
        '<a id="boton" href="javascript:DestroyWindow(\''+id+'\');" class="botpopups">'+closeButtonText+'</a>' +
        '</div>' +
        '</div>';

    if (vExplorer==6) {
        //CreateIEWindow(id,x + 'px',y + 'px',null,null,"",null,null);
        CreateWindow(id,x + 'px',y + 'px',null,null,content,null,null);
        //Vamos a ocultar todos los select visibles y ponerlos en un array.
        allSelects[id] = new Array();
        selects = document.getElementsByTagName('select');
        for (i=0;i<selects.length;i++) {
            if (selects[i].style.visibility!='hidden') {
                allSelects[id].push(selects[i]);
                selects[i].style.visibility='hidden';
            }
        }
    }
    else {
        CreateWindow(id,x + 'px',y + 'px',null,null,content,null,null);
    }
}


//********************************************
// pone una ventana en primer plano.
//--------------------------------------------
//
// @params:
//	id: id del elemento.
//
// @return: 
//
//********************************************
function RaiseWindow(id) {
	var windowdiv = document.getElementById(id);
	zi = __zIndex++;
	windowdiv.style.zIndex=zi;
}



//********************************************
// destruye una ventana creada con CreateWindow.
//--------------------------------------------
//
// @params:
//	id: id de la div contenedora de la ventana.
//
// @return: 
//
//********************************************
function DestroyWindow(id) {
	var abody = document.getElementsByTagName("body");
	var vExplorer = isExplorer();
	
	var div = null;
	if (abody.length>=1) div = abody[0];
	if (div!=null) {
		var windowdiv;
		
		windowdiv = document.getElementById(id+"_parent");
		
		if (windowdiv!=null) {
			purge(windowdiv);
			div.removeChild(windowdiv);
		}
		
		windowdiv = document.getElementById(id);
		if (windowdiv!=null) {
			purge(windowdiv);
			div.removeChild(windowdiv);
		}
		
		var windowbg = document.getElementById(id + "bg");
		if (windowbg!=null) {
			if(activeWindows==1 && navigator.appName == 'Microsoft Internet Explorer'){
				activeWindows=0;
			}
			purge(windowbg);
			div.removeChild(windowbg);
		}
		
		var windowiframe = document.getElementById(id + "_parent");
		if (windowiframe!=null) {
			purge(windowiframe);
			div.removeChild(windowiframe);
		}
		
	}
	//Manda el foco al ultimo foco conocido.
	setFocusOn(lastFocus);
	//Vuelve a mostrar los select que ocultamos en CreateWindow.
	if (vExplorer<=6 && vExplorer>3) {
		if (allSelects[id]) {
			len = allSelects[id].length;
			for (i=0;i<len;i++) {
				select = allSelects[id].pop();
				select.style.visibility='visible';
			}
			allSelects[id] = null;
		}
	}
}


//********************************************
// establece el estado de visibilidad de un elemento
// usando el id.
//--------------------------------------------
//
// @params:
//	id: id del elemento.
//	visible: true | false.
//
// @return: 
//
//********************************************
function Show(id,visible) {
	obj = document.getElementById(id);
	if (obj==null) return;
	if (visible) {
		obj.style.visibility = "visible";
	} else {
		obj.style.visibility = "hidden";
	}
	//Les pone la misma visibilidad que la capa que los contiene.
	vExplorer = isExplorer();
	if (vExplorer<=6 && vExplorer>3) {
		selects = obj.getElementsByTagName('select');
		for (i=0;i<selects.length;i++) selects[i].style.visibility =obj.style.visibility;
	}
}

function Display(id, visible){
  obj = document.getElementById(id);
  if (obj==null) return;
  if (visible) {
    obj.style.display = "";
  } else {
    obj.style.display = "none";
  }
}

function Resize(id,w,h) {
	obj = document.getElementById(id);
	if (obj==null) return;
	if (w>0) obj.style.width=w+ "px";
	if (h>0) obj.style.height=h+ "px";
}

function ShowAndResize(id,visible,w,h) {
	Show(id,visible);
	Resize(id,w,h);
}

function SwapShow(id) {
	obj = document.getElementById(id);
	if (obj==null) return;
	if (obj.style.visibility=="visible") {
		Show(id,false);
	} else {
		Show(id,true);
	}
}

//Pequeño workaround para devolver el foco despues de un popup 
//al ultimo objeto sobre el que hicimos un setFocus.
var lastFocus;

function setFocusOn(id) {
	obj = document.getElementById(id);
	if (obj==null) return;
  try { obj.focus(); } catch (e) {}
	lastFocus = id;
}





//********************************************
// limpia espacios al principio y al final
// de una cadena.
//--------------------------------------------
//
// @params:
//	str: la cadena a limpiar.
//
// @return: 
//	la cadena modificada.
//
//********************************************
function cleanSpaces(str) {
	//pendiente
}


function setFlashVar(flashid,varname,varvalue) {
	fl = document.getElementById("mz" + flashid);
	if (!fl) fl = document.getElementById(flashid);
 	if (fl!=null) fl.SetVariable(varname,varvalue);
}

function hasMiniumSize(minH){
    var height = screen.height, ratio = 1;
  // compute scaling between inner size and outer size in chrome 43
    if (typeof window.innerWidth == 'number') {
      var ratioW = window.outerWidth / window.innerWidth;
      var ratioH = window.outerHeight / window.innerHeight;
      ratio = Math.ceil(Math.min(ratioW, ratioH) * 10) / 10;
      height = height / ratio;
    }
    if (height < minH) {
      return "false";
    }
    return "true";
}

//var chatWindowStatus = 0;
//function setChatWindowStatus(status) {
//	chatWindowStatus = status;
////}

//var chatWindow = null;
//function openChat(para,roomid,solicitud) {
//	if (!chatWindow || chatWindow.closed) {
//		var chatparams = '';
//        var width = 712;
//        var height = 562;
//        var widtha = 728;
//        var heighta = 652;
//
//		if(para != '' ){
//			chatparams = '?para=' + para + '&roomid=' + roomid + '&solicitud=' + solicitud + '&hasminsize=' + hasMiniumSize(heighta);
//		} else {
//           chatparams = '?hasminsize=' + hasMiniumSize(heighta);
//        }
//		var url = "wmiscomchat.php" + chatparams;
//		//var url = "testresize.php" + chatparams;
//        if (hasMiniumSize(heighta) == "true")  {
//            chatWindow = window.open(url, 'chat', 'height='+heighta+',width='+widtha+',scrollbars=0,resizable=1,toolbar=yes');
//        } else {
//            chatWindow = window.open(url, 'chat', 'height='+height+',width='+width+',scrollbars=0,resizable=1,toolbar=no');
//        }
//		if(!chatWindow.opener) chatWindow.opener=self;
//		if(window.focus){
//			chatWindow.focus();
//		}
//	} else {
//		ajax_call("__","php/lanzachatprivado.php?para=" + para + "&solicitud=" + solicitud + "&roomid=" + roomid,null);
//        //if (isFirefox()) {
//        //    fh = document.getElementById('mzFlashHead');
//        //} else fh = document.getElementById('FlashHead');
//		//fh.openPrivateChat(para,roomid,solicitud);
//		//url = "php/lanzachatprivado.php?para=" + para + "&solicitud=" + solicitud + "&roomid=" + roomid;
//		//alert(url);
//		//ajax_call("__","php/lanzachatprivado.php?para=" + para + "&solicitud=" + solicitud + "&roomid=" + roomid,null);
//	}
//}
window.openChat = function(useridId) {
  window.mf = window.mf || [];
  window.mf.push({action:'OpenChatAction', userid: useridId});
};

function openChatFromFlash(para,roomid,solicitud) {
	window.opener.ajax_call("__","php/lanzachatprivado.php?para=" + para + "&solicitud=" + solicitud + "&roomid=" + roomid,null);
}


function reloadChat() {
	window.location.reload();
}

function showPopUp(windowname,url) {
	CreateURLWindow(windowname,
					0,
					0,
					url);
}

function setWindowToFullScreen(windowname) {
	wn = document.getElementById(windowname);
	wn.style.position='absolute';
	wn.style.left='0px';
	wn.style.top='0px';
	wn.style.width = getDocumentWidth() + "px";
	wn.style.height = getDocumentHeight() + "px";
	wn.style.width="100%";
	wn.style.height="100%";
}

function showInfoPopUp(title,msg) {
	CreateURLWindow("infowindow",
					getWindowWidth()/2-100,
					getWindowHeight()/2-100,
					"/php/mostrarpopupinfo.php?ttl=" + encodeURI(title) +
					"&msg=" + encodeURI(msg));
}

function showStaticInfoPopUp(title,msg, closeButtonText) {
    CreateStaticWindow("infowindow",
        getWindowWidth()/2-100,
        getWindowHeight()/2-100,
        title, msg, closeButtonText);
}

function showConfirmationPopUp(title,msg,yeslink,nolink) {
	CreateURLWindow("confirmationwindow",
					getWindowWidth()/2-100,
					getWindowHeight()/2-100,
					"php/mostrarpopupconfirmation.php?ttl=" + encodeURI(title) + 
					"&msg=" + encodeURI(msg) + "&ylink="+yeslink+"&nlink=" + nolink);
}

function showWarningPopUp(title,msg,onclose){
	CreateURLWindow("warningwindow",
					getWindowWidth()/2-175,
					getWindowHeight()/2-150,
					"php/mostrarpopupaviso.php?ttl=" + encodeURI(title) + 
					"&msg=" + encodeURI(msg) + "&onclose=" + onclose);
}

//********************************************
// Funcion para en los submenus verticales.
// Resalta el fondo del submenu donde este el cursor.
//--------------------------------------------
//
// @params:
//	H: elemento donde se ha situado el cursor.
//
//********************************************
function fhover(H){
if(H.className.indexOf("HoverBGColor")>=0)
H.className=H.className.replace("HoverBGColor ","");
else H.className="HoverBGColor "+H.className;
}

//********************************************
// Funciones de la primera version del portal.
// Funciones utilizadas para mostrar y ocultar textos con los links de "comprimir todo" y "expandir todo".
function activa(tipo)
{
	if (activado!="") document.getElementById(activado).style.display="none";
	if (activado!=tipo)
	{
		document.getElementById(tipo).style.display="";
		activado=tipo;
	}
	else activado="";
}

function activa_sub(tipo,enlace)
{
	if (document.getElementById(tipo).style.display=='none')
	{ 
		document.getElementById(tipo).style.display="";
		// muestra en la subseccion el link comprimir todo
		
		var splittedId = tipo.split("_");
		subid = splittedId[0] + "_" + splittedId[1] + "_" + splittedId[2];
		
		document.getElementById(subid).style.display="";
	}
	else 
	{
		document.getElementById(tipo).style.display="none";
		
		var splittedId = tipo.split("_");
		subid = splittedId[0] + "_" + splittedId[1] + "_" + splittedId[2];
		
		document.getElementById(subid).style.display="";
		subspans=document.getElementsByName(subid);
		subdisplay="none";
		for(i=0;i<subspans.length;i++)
		{
			if (subspans[i].style.display=="") subdisplay="";
		}
		document.getElementById(subid).style.display=subdisplay;
	}
	if (document.getElementById(enlace).className=='expandirbw') document.getElementById(enlace).className="comprimirbw";
		else document.getElementById(enlace).className="expandirbw";
}

function comprimir_todo(tipo,enlace)
{
	v_doc=document.getElementsByTagName('*');
	for(i=0;i<v_doc.length;i++)
	{
		tam=tipo.length;
		valor=v_doc[i].id.substring(0,tam);
		tam2=enlace.length;
		valor2=v_doc[i].id.substring(0,tam2);
		if (valor==tipo) v_doc[i].style.display="none";
		if (valor2==enlace) v_doc[i].className="expandirbw";
	}
}

function expandir_todo(tipo,enlace)
{
	v_doc=document.getElementsByTagName('*');
	for(i=0;i<v_doc.length;i++)
	{
		tam=tipo.length;
		valor=v_doc[i].id.substring(0,tam);
		tam2=enlace.length;
		valor2=v_doc[i].id.substring(0,tam2);
		if (valor==tipo) v_doc[i].style.display="";
		if (valor2==enlace) v_doc[i].className="comprimirbw";
	}
}

function ocultar(tipo)
{
	document.getElementById(tipo).style.display="none";
	activado="";
}

//Comprueba el formato del correo
function verifica_mail(t_mail)
{
	if ((t_mail.lastIndexOf(" ")!=-1) || (t_mail.lastIndexOf("@")==-1) || (t_mail.lastIndexOf(".")<=(t_mail.lastIndexOf("@")+1)) || (t_mail.lastIndexOf(".")==(t_mail.length-1))) return false;
		else return true;
}

var javascriptNewMessage = "";
function OnNewMessage() {
	eval(javascriptNewMessage);
}

var javascriptNewMobi = "";
function OnNewMobi() {
	eval(javascriptNewMobi);
}

function show_div(tipo)
{	
	if(document.getElementById(tipo)) document.getElementById(tipo).style.display="block";
}

function hide_div(tipo)
{
	if(document.getElementById(tipo)) document.getElementById(tipo).style.display="none";
}

function ifsetdisplay(divtipo,divboton)
{
	if (document.getElementById(divtipo).style.display=='none')
	{ 
		document.getElementById(divboton).style.display="block";
	}
	else 
	{	
		document.getElementById(divboton).style.display="none";
	}
}


function compareOptionText(a,b) {

	// textual comparison
	return a.text!=b.text ? a.text<b.text ? -1 : 1 : 0;

}

function sortOptions(list) {

	var items = list.options.length;

	// create array and make copies of options in list
	var tmpArray = new Array(items);

	for ( i=0; i<items; i++ )
		tmpArray[i] = new Option(list.options[i].text,list.options[i].value);

	// sort options using given function
	tmpArray.sort(compareOptionText);
	
	// make copies of sorted options back to list
	for ( i=0; i<items; i++ )
		list.options[i] = new Option(tmpArray[i].text,tmpArray[i].value);

}

function onCloseSession() {
	document.location='login.php';	
}

function sendVerificationEmail(email, userId){
	var response_container = document.getElementById('verification-email-sent');
	response_container.innerHTML = "<img src='https://sti.mfstat.net/common/popups/h-ajax-loading.gif' border='0' />";

  ajax_place_response("php/email_verify_email_address.php?email=" + email + "&userId=" + userId, null, response_container);
}

function externalLinks() {
	if (!document.getElementsByTagName) {
		return;
	}
	var anchors = document.getElementsByTagName("a");
	for (var i = 0; i < anchors.length; i++) {
		var anchor = anchors[i];
		if (anchor.getAttribute("rel")) {
			var rel = anchor.getAttribute("rel");
			var external = false;
			if (rel.indexOf(" ") > 0) {
				while (rel.indexOf(" ") > 0 && external == false) {
					if (rel.substr(0, rel.indexOf(" ")) == "external") {
						external = true;
					}
					rel = rel.substr(rel.indexOf(" ") + 1, rel.length - rel.indexOf(" ") + 1);
				}
			}
			if (rel == "external") {
				external = true;
			}
			if (anchor.getAttribute("href") && external == true) {
				anchor.target = "_blank";
			}
		}
	}
	return;
}

function textareaCharCounter2(sourceId, targetId, minChars){
	var source = document.getElementById(sourceId);
	var target = document.getElementById(targetId);
	
	target.innerHTML = source.value.length;
	
}
function iframeLoaded() {
  $(".close").trigger("click");
  location.reload();
}
window.openOfferwallCredits = function() {
  window.mf = window.mf || [];
  window.mf.push({
    action: 'OpenOfferwallCreditsModalAction',
  });
};

var propiedad_auxiliar = "Es para los ajustes css y js";


//********************************************
//
//	Copyright Mobifriends S.L. 2007
//	
//	programador: Javier Velasco Gonzalez	
//
//********************************************

var error_page;
var errors;
var errorPages;

errors = new Array();
errorPages = new Array();

var sLoadingMessage = "string" === typeof sLoadingMessageTranslated ? sLoadingMessageTranslated:"Loading...";
var bLoading = false;
var sLoadingOpacity = "80";

function  html_cargador() {
	/*
	var protocol = (("https:" == document.location.protocol) ? "https://" : "http://");
	return "<object classid='clsid:d27cdb6e-ae6d-11cf-96b8-444553540000' codebase='"+protocol+"fpdownload.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=			8,0,0,0' width='100%' height='32' align='middle'>" + 
			"<param name='allowScriptAccess' value='sameDomain' />"+
			"<param name='wmode' value='transparent' /><param name='movie' value='" + ajaxLoaderClip + "' />"+
			"<param name='quality' value='high' /><param name='scale' value='noscale' />"+
			"<embed src='" + ajaxLoaderClip + "' scale='noscale' quality='high' width='100%' height='32' " + 
			"align='middle' wmode='transparent' allowScriptAccess='sameDomain' " + 
   			"type='application/x-shockwave-flash' pluginspage='"+protocol+"www.adobe.com/go/getflashplayer' />" + 
			"</object>";
	*/
}

//********************************************
// hace una llamada remota a un script copiando 
// la respueta dentro del elemento id.
//--------------------------------------------
//
// @params:
//	id: attributo id del elemento que recibe la respueta.
//	url: url del script en el servidor.
//	func: funcion que recibe los errores, si se omite 
//		se hace una llamada a las funciones generales
//		para el tratamiento de errores (ver ajax_on_error).
//
// @return: 
//
//********************************************
function ajax_call(id,url, func,disableloader) {
	var request;
	var error_func = func;
	
	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
	} else {
		if (Number(navigator.appVersion.substr(0,3))>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');
	}

	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (request.status == 200) {
					if (!disableloader) {
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}
					element = document.getElementById(id);
					if (element!=null) element.innerHTML = request.responseText;
					/* ejecuta los scripts dentro del html */
					var startPos=0;
					var endPos=0;
					var script;
					var uchtml = request.responseText;
					startPos = 0;	
					do {
						startPos = uchtml.indexOf("<script",startPos);
						if (startPos<0) break;
						startPos = 1 + uchtml.indexOf(">",startPos);
						endPos = uchtml.indexOf("</script>",startPos);
						script =request.responseText.substr(startPos,endPos-startPos);

						if (window.execScript){
							window.execScript(script);
						}else{
							eval(script);
						}

						startPos = endPos+1;
					} while(true);
				} else {
				   if (error_func) {
				   		error_func(request.status);			   	
				   } else {
				   		for (var i in errors) {
        					if (errors[i]==request.status) {
        						//alert(errorPages[i]);
        						document.location = errorPages[i];
        					}
			   			}
				   }
				}
			} else { 
				DestroyWindow("backgroundloader");
				DestroyWindow("ajaxloader");
			}
		}
		if (!disableloader) {
			var wwidth = getWindowWidth();
			var wheight = getWindowHeight();
			CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","<br><br><br>",null,"30","loading-window2");
			CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",'Loading	',null,'80',"loading-window");		
		}
		request.open("GET",url,true)
		request.send(null);
	}
}


//********************************************
// envia el contenido de un form copiando 
// la respueta dentro del elemento id.
//--------------------------------------------
//
// @params:
//	id: attributo id del elemento que recibe la respuesta.
//	url: url del script en el servidor.
//	func: funcion que recibe los errores, si se omite 
//		se hace una llamada a las funciones generales
//		para el tratamiento de errores (ver ajax_on_error).
//
// @return: 
//
//********************************************
function ajax_submit_form(id,formName,url, func) {
	var request;
	var form;
	var formdata="";
	var fields;
	var error_func = func;
	
	form = document.getElementById(formName);
	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
		fields = form.elements;
	} else {
		version = isExplorer();
		if (version>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');
		if (version>=5 && version<7) fields = form.all;

	}
	
	for (i in fields)
	{
		var element = fields[i];
		if (element!=null && element.tagName!=null) {
			if (element.tagName=="SELECT" || element.tagName=="INPUT" || element.tagName=="TEXTAREA") {
				if (element.type=="checkbox" || element.type=="radio") {
					if (element.checked==true) {
						formdata+=element.name + "=" + element.value + "&";
					}
				} else {
					formdata+=element.name + "=" + encodeURIComponent(element.value) + "&";
				}
			}
		}
	}
	
	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (request.status == 200) {
					
					if(bLoading){
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}
					
					element = document.getElementById(id);
					//Si pusieramos cuidado en no borrar divs no tendria que hacer esto.
					if (element) element.innerHTML = request.responseText;
					/* ejecuta los scripts dentro del html */
					var startPos=0;
					var endPos=0;
					var script;
					var uchtml = request.responseText.toUpperCase();
					startPos = 0;	



					/*
					do {
						startPos = uchtml.indexOf("<SCRIPT",startPos);
						if (startPos<0) break;
						startPos = 1 + uchtml.indexOf(">",startPos);
						endPos = uchtml.indexOf("</SCRIPT>",startPos);
						script =request.responseText.substr(startPos,endPos-startPos);
						if (window.execScript){
							window.execScript(script);
						}else{
							eval(script);
						}
						startPos = endPos+1;
					} while(true);
					*/

					do {

				    startPos = uchtml.indexOf("<SCRIPT", startPos);
				    if (startPos < 0) break; // Sale del bucle si no encuentra más etiquetas <script>

				    startPos = 1 + uchtml.indexOf(">", startPos);
				    endPos = uchtml.indexOf("</SCRIPT>", startPos);

				    if (endPos < 0) {
				        // Si no encuentra una etiqueta de cierre </script>, sale del bucle
				        break;
				    }

				    script = request.responseText.substring(startPos, endPos);
				    
				    $('body').prepend("<script>"+script+"</script>");
				    
				    //if (window.execScript) {
				        //window.execScript(script);
				    //} else {
				        //eval(script);
				    //}

				    startPos = endPos + 9; // Actualiza startPos al final de la etiqueta </script>
				} while (true);

				} else {
				   if (error_func) {
				   		error_func(request.status);			   	
				   } else {
				   		for (var i in errors) {
        					if (errors[i]==request.status) {
        						//alert(errorPages[i]);
        						document.location = errorPages[i];
        					}
			   			}
				   }
				}
			}
		}

		if(bLoading){
			var wwidth = getWindowWidth();
			var wheight = getWindowHeight();
			CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","",null,"30");
			CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",sLoadingMessage,null,sLoadingOpacity,"loading-window");
		}
			
		request.open("POST",url,true)
		request.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
		request.send(formdata);
	}
}


// ********************************************
// exactly the same as ajax_submit_form, but it expects a JSON response
function ajax_submit_form_json(id,formName,url, func) {
	var form;
	var formdata="";
	var error_func = func;

	form = document.getElementById(formName);
	var request = new XMLHttpRequest();
	var fields = form.elements;

	for (i in fields)
	{
		var element = fields[i];
		if (element!=null && element.tagName!=null) {
			if (element.tagName=="SELECT" || element.tagName=="INPUT" || element.tagName=="TEXTAREA") {
				if (element.type=="checkbox" || element.type=="radio") {
					if (element.checked==true) {
						formdata+=element.name + "=" + element.value + "&";
					}
				} else {
					formdata+=element.name + "=" + encodeURIComponent(element.value) + "&";
				}
			}
		}
	}

	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (request.status == 200) {

					if(bLoading){
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}

					try {
						const data = JSON.parse(request.responseText);
						console.log("JSON response", data);
						if(data.redirect) {
							window.location.href = data.redirect + '?' + new Date().getTime();
						}
					} catch (e) {
						console.log("Error parsing JSON response", e);
					}
				} else {
					if (error_func) {
						error_func(request.status);
					} else {
						for (var i in errors) {
							if (errors[i]==request.status) {
								document.location = errorPages[i];
							}
						}
					}
				}
			}
		}

		if(bLoading){
			var wwidth = getWindowWidth();
			var wheight = getWindowHeight();
			CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","",null,"30");
			CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",sLoadingMessage,null,sLoadingOpacity,"loading-window");
		}

		request.open("POST",url,true)
		request.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
		request.send(formdata);
	}
}


//********************************************
// llama al ajax_submit_form, cuando el usuario 
// aprieta el Enter
//--------------------------------------------
//
// @params: (el evento y los parametros de ajax_submit_form)
//
// @return: 
//
//********************************************
function ienter_submit_form(evento, id,formName,url, func) {
	var iAscii;
	if (evento.keyCode) iAscii = evento.keyCode; 
		else if (evento.which) iAscii = evento.which; 
			else return false; 
	if (iAscii == 13) ajax_submit_form(id,formName,url, func); 
	return true; 
}


//********************************************
// envia el contenido de un form copiando 
// ejecutando la respueta como un script.
//--------------------------------------------
//
// @params:
//	formName: id del formulario.
//	url: url del script en el servidor.
//	func: funcion que recibe los errores, si se omite 
//		se hace una llamada a las funciones generales
//		para el tratamiento de errores (ver ajax_on_error).
//
// @return: 
//
//********************************************
function ajax_eval_form(formName,url, func,disableloader) {
	var request;
	var form;
	var formdata="";
	var fields;
	var error_func = func;
	var scrWidth,scrHeight;
	
	form = document.getElementById(formName);
	if (form==null) return;
	fields = form.elements;
	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
	} else {
		version = isExplorer();
		if (version>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');
		if (version>=5 && version<7) fields = form.all;
		
	}

	for (i in fields)
	{
		var element = fields[i];
		if (element!=null && element.tagName!=null) {
			if (element.tagName=="SELECT" || element.tagName=="INPUT" || element.tagName=="TEXTAREA") {
				if (element.type=="checkbox" || element.type=="radio" ) {
					if (element.checked==true) {
						formdata+=element.name + "=" + element.value + "&";
					}
				} else {
					formdata+=element.name + "=" + encodeURIComponent(element.value) + "&";
				}
			}
		}
	}
	
	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (request.status == 200) {
					if (window.execScript){
						window.execScript(request.responseText);
					}else{
						eval(request.responseText);
					}
				} else {
				   if (error_func) {
				   		error_func(request.status);			   	
				   } else {
				   		for (var i in errors) {
        					if (errors[i]==request.status) {
        						//alert(errorPages[i]);
        						document.location = errorPages[i];
        					}
			   			}
				   }
				}
			}
		}
		request.open("POST",url,true);
		request.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=utf-8");
		request.send(formdata);
	}
}

function jq_ajax_eval_form(formName,url, func,disableloader) {
  var request;
  var form;
  var formdata="";
  var fields;
  var error_func = func;

  form = document.getElementById(formName);
  if (form==null) return;
  fields = form.elements;
  if(typeof XMLHttpRequest!='undefined') {
    request = new XMLHttpRequest();
  } else {
    version = isExplorer();
    if (version>=5)
      request = new ActiveXObject('Msxml2.XMLHTTP');
    else
      request = new ActiveXObject('Microsoft.XMLHTTP');
    if (version>=5 && version<7) fields = form.all;

  }
  formdata = $("#" + formName).serialize();
  if (request) {
    request.onreadystatechange = function () {
      if(request.readyState == 4)
      {
        if (request.status == 200) {
          if (!disableloader) {
            var userAgent = navigator.userAgent;
            if (userAgent.indexOf("MSIE 9") !== -1) {}
          }
          if (window.execScript){
            window.execScript(request.responseText);
          }else{
            eval(request.responseText);
          }
        } else {
          if (error_func) {
            error_func(request.status);
          } else {
            for (var i in errors) {
              if (errors[i]==request.status) {
                //alert(errorPages[i]);
                document.location = errorPages[i];
              }
            }
          }
        }
      }
    }

    if (!disableloader) {
      var userAgent = navigator.userAgent;
      if (userAgent.indexOf("MSIE 9") !== -1) {}
      else {
      }
    }
    request.open("POST",url,true);
    request.setRequestHeader("Content-Type","application/x-www-form-urlencoded; charset=utf-8");
    request.send(formdata);
  }
}

//********************************************
// añade una funcion envia el contenido de un form copiando 
// la respueta dentro del elemento id.
//--------------------------------------------
//
// @params:
//	id: attributo id del elemento que recibe la respuesta.
//	url: url del script en el servidor.
//	func: funcion que recibe los errores, si se omite 
//		se hace una llamada a las funciones generales
//		para el tratamiento de errores (ver ajax_on_error).
//
// @return: 
//
//********************************************
function ajax_on_error(status,url) {
	errors.push(status);
	errorPages.push(url);
}

//********************************************
// registra una pelicula para ser mostrada 
// mientras se esperan datos en una peticion AJAX.
//--------------------------------------------
//
// @params:
//	clipname: nombre del movieclip de flash.
//
// @return: 
//
//********************************************
function ajax_register_loader(clipname) {
	// ajaxLoaderClip = clipname;
	bLoading = true;
}

function ajax_eval_response(url, params) {
	var request;
	var version;

	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
	} else {
		version = isExplorer();
		if (version>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');		
	}
	
	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4){
				if (request.status == 200) {
					if (window.execScript){
						window.execScript(request.responseText);
					}else{
						eval(request.responseText);
					}
				}
			}
		}
		
		request.open("POST",url,true);
		request.send(params);
	}
}

function ajax_place_response(url, params, place) {
  var request;
  var version;

  if(typeof XMLHttpRequest!='undefined') {
    request = new XMLHttpRequest();
  } else {
    version = isExplorer();
    if (version>=5)
      request = new ActiveXObject('Msxml2.XMLHTTP');
    else
      request = new ActiveXObject('Microsoft.XMLHTTP');
  }

  if (request) {
    request.onreadystatechange = function () {
      if(request.readyState == 4){
        if (request.status == 200) {
          if (window.execScript){
            window.execScript(request.responseText);
          }else{
            place.innerHTML = request.responseText;
          }
        }
      }
    }

    request.open("GET",url,true);
    request.send(params);
  }
}


//********************************************
// Versión 2 de la funcion ajax_submit_form
// envia el contenido de un form copiando 
// la respueta dentro del elemento id.
// en el caso de que de error, la respuesta será enviada a 
// una capa llamada error_box.
//********************************************
function messages_ajax_submit_form2(id,formName,url, func) {
	const paraInput = document.getElementById('para');
	if (paraInput && paraInput.value.trim() === '') {
		dialogConfirm('Atención','Tienes que poner un destinatario al mensaje');
		return;
	}
	const asuntinput = document.getElementById('asuntinput');
	if (asuntinput && asuntinput.value.trim() === '') {
		dialogConfirm('Atención','Tienes que poner el asunto del mensaje');
		return;
	}
	const mens_txta = document.getElementById('mens_txta');
	if (mens_txta && mens_txta.value.trim() === '') {
		dialogConfirm('Atención','Tienes que poner algo en el mensaje');
		return;
	}
	ajax_submit_form2(id,formName,url, func);
}
function ajax_submit_form2(id,formName,url, func) {
	var request;
	var form;
	var formdata="";
	var fields;
	var error_func = func;
	
	form = document.getElementById(formName);
	if(typeof XMLHttpRequest!='undefined') {
		request = new XMLHttpRequest();
		fields = form.elements;
	} else {
		version = isExplorer();
		if (version>=5) 
			request = new ActiveXObject('Msxml2.XMLHTTP');
		else
			request = new ActiveXObject('Microsoft.XMLHTTP');
		if (version>=5 && version<7) fields = form.all;

	}
	
	for (i in fields)
	{
		var element = fields[i];
		if (element!=null && element.tagName!=null) {
			if (element.tagName=="SELECT" || element.tagName=="INPUT" || element.tagName=="TEXTAREA") {
				if (element.type=="checkbox" || element.type=="radio") {
					if (element.checked==true) {
						formdata+=element.name + "=" + element.value + "&";
					}
				} else {
					formdata+=element.name + "=" + encodeURIComponent(element.value) + "&";
				}
			}
		}
	}
	
	if (request) {
		request.onreadystatechange = function () {
			if(request.readyState == 4)
			{
				if (document.getElementById('disable-button')) {
					document.getElementById('disable-button').disabled = false;
				}
				if (request.status == 200) {
					
					if(bLoading){
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}
					
					element = document.getElementById(id);
					//Si pusieramos cuidado en no borrar divs no tendria que hacer esto.
					if (element) element.innerHTML = request.responseText;
					/* ejecuta los scripts dentro del html */
					var startPos=0;
					var endPos=0;
					var script;
					var uchtml = request.responseText;
					startPos = 0;	
					do {
						startPos = uchtml.indexOf("<script",startPos);
						if (startPos<0) break;
						startPos = 1 + uchtml.indexOf(">",startPos);
						endPos = uchtml.indexOf("</script>",startPos);
						script =request.responseText.substr(startPos,endPos-startPos);
						if (window.execScript){
							window.execScript(script);
						}else{
							eval(script);
						}
						startPos = endPos+1;
					} while(true);	
				} else {
					if(bLoading){
						DestroyWindow("backgroundloader");
						DestroyWindow("ajaxloader");
					}
					document.getElementById('error_box').innerHTML = request.responseText;
					/* ejecuta los scripts dentro del html */
					var startPos=0;
					var endPos=0;
					var script;
					var uchtml = request.responseText.toUpperCase();
					startPos = 0;	
					do {
						startPos = uchtml.indexOf("<SCRIPT",startPos);
						if (startPos<0) break;
						startPos = 1 + uchtml.indexOf(">",startPos);
						endPos = uchtml.indexOf("</SCRIPT>",startPos);
						script =request.responseText.substr(startPos,endPos-startPos);
						if (window.execScript){
							window.execScript(script);
						}else{
							eval(script);
						}
						startPos = endPos+1;
					} while(true);						
				}
			}
		}

		if(bLoading){
			var wwidth = getWindowWidth();
			var wheight = getWindowHeight();
			CreateWindow("backgroundloader","0px","0px",wwidth + "px",wheight + "px","<br><br><br>",null,"30","loading-window2");
			CreateWindow("ajaxloader","0px","0px",wwidth + "px","32px",'Loading	',null,'80',"loading-window");		
		}

		if (document.getElementById('disable-button')) {
			document.getElementById('disable-button').disabled = true;
		}
		request.open("POST",url,true)
		request.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
		request.send(formdata);
	}
}


$(document).ready(function(){
  var display = false;
  $("#registerTopButton").click(function(){
    $("#homepageForm").toggle(display);
    $(".registerText").toggle(display);
    $("#altadatosbasicosForm").toggle(!display);
    $("#enterText").toggle(!display);
    display = !display;
  });
});

 if (!signupForm) {
    var signupForm = 'altadatosbasicos';

 }
  $('#getProvinces').click(function(e) {
    ajax_submit_form2('provincia_div', signupForm,'/php/signup_form.php?cmd=leerprovincias',null);
    e.preventDefault();
  });
  $("#provincia_div").change(function() {
    var $province = $("#provincia_div option:selected").val();
    if ($province) {
        ajax_eval_form(signupForm,'/php/signup_form.php?cmd=leerlocalidad',null);
    } else {
      $("#localidad_div").html('');
      $("#provinceId").val('');
      $("#cityId").val('');
      $("#city").val('');
    }
 });
  $("#localidad_div").change(function() {
    var $city = $("#localidad_div option:selected").val();
    if ($city) {
        var $city_text = $("#localidad_div option:selected").text();
        var $province = $("#provincia_div option:selected").val();
        var $province_text = $("#provincia_div option:selected").text();
        $("#cityId").val($city);
        $("#provinceId").val($province);
        // add the text of the city+province and validate the field
        $("#city").val($city_text + " (" + $province_text + ")").trigger("blur");
    } else {
        $("#city").val('');
    }
  });
  $("#cityId").change(function() {
    $("#provincia_div").html('');
    $("#localidad_div").html('');
  });

var propiedad_auxiliar = "Es para los ajustes css y js";


var validator2 = $("#altadatos2").validate({
  errorElement: "div",
  errorClass: "validation-failed",
  validClass: "validation-passed",
  ignore: "",
  rules: {
    "to[]": {
      required: true
    },
    seek: {
      required: true
    }
  },
  messages: {
    confirmation: {
      required: requiredCertifico
    },
    seek: {
      required: requiredText
    },
    "to[]": {
      required: requiredPara
    },
    city: {
      required: requiredText
    },
    cityId: {
      required: requiredCity
    }
  },
  submitHandler: function (e) {
    var data = $("#altadatos2").serializeArray();
    $.ajax({
      url: '/php/signup_form_part2.php',
      type: "POST",
      data: data,
      success: function (data) {
        var info = JSON.parse(data);
        console.log(info);
        if (info.status.errorCode === 0) {
          // Preservar UTM params de la URL actual para GA4
          var currentParams = new URLSearchParams(window.location.search);
          var redirectUrl = '/web/signup/photo/';
          var utmParams = new URLSearchParams();
          if (currentParams.get('utm_source')) utmParams.append('utm_source', currentParams.get('utm_source'));
          if (currentParams.get('utm_medium')) utmParams.append('utm_medium', currentParams.get('utm_medium'));
          if (currentParams.get('utm_campaign')) utmParams.append('utm_campaign', currentParams.get('utm_campaign'));
          if (utmParams.toString()) {
            redirectUrl += '?' + utmParams.toString();
          }
          window.location = redirectUrl;
          return;
        }
      }
    });
  }
});
var END_OF_INPUT = -1;
var base64Str;
var base64Count;
var base64Chars = new Array(
    'A','B','C','D','E','F','G','H',
    'I','J','K','L','M','N','O','P',
    'Q','R','S','T','U','V','W','X',
    'Y','Z','a','b','c','d','e','f',
    'g','h','i','j','k','l','m','n',
    'o','p','q','r','s','t','u','v',
    'w','x','y','z','0','1','2','3',
    '4','5','6','7','8','9','+','/'
);
 
var reverseBase64Chars = new Array();
for (var i=0; i < base64Chars.length; i++){
    reverseBase64Chars[base64Chars[i]] = i;
}
function setBase64Str(str){base64Str = str;base64Count = 0;}
function readBase64(){    
    if (!base64Str) return END_OF_INPUT;
    if (base64Count >= base64Str.length) return END_OF_INPUT;
    var c = base64Str.charCodeAt(base64Count) & 0xff;
    base64Count++;
    return c;
}
function encodeBase64(str){
    setBase64Str(str);
    var result = '';
    var inBuffer = new Array(3);
    var lineCount = 0;
    var done = false;
    while (!done && (inBuffer[0] = readBase64()) != END_OF_INPUT){
        inBuffer[1] = readBase64();
        inBuffer[2] = readBase64();
        result += (base64Chars[ inBuffer[0] >> 2 ]);
        if (inBuffer[1] != END_OF_INPUT){
            result += (base64Chars [(( inBuffer[0] << 4 ) & 0x30) | (inBuffer[1] >> 4) ]);
            if (inBuffer[2] != END_OF_INPUT){
                result += (base64Chars [((inBuffer[1] << 2) & 0x3c) | (inBuffer[2] >> 6) ]);
                result += (base64Chars [inBuffer[2] & 0x3F]);
            } else {
                result += (base64Chars [((inBuffer[1] << 2) & 0x3c)]);
                result += ('=');
                done = true;
            }
        } else {
            result += (base64Chars [(( inBuffer[0] << 4 ) & 0x30)]);
            result += ('=');
            result += ('=');
            done = true;
        }
        lineCount += 4;
        if (lineCount >= 76){
            result += ('\n');
            lineCount = 0;
        }
    }
    return result;
}

// Base64 encoder/decoder with UTF-8 support
//
// Copyright (c) 2011 Vitaly Puzrin
// Copyright (c) 2011 Aleksey V Zapparov
//
// Author: Aleksey V Zapparov AKA ixti (http://www.ixti.net/)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.


// Based on original artworks of base64 encoder/decoder by [Mozilla][1]
// [1]: http://lxr.mozilla.org/mozilla/source/extensions/xml-rpc/src/nsXmlRpcClient.js


(function (global) {
  'use strict';

  var log = function () {},
    padding = '=',
    chrTable = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz' +
      '0123456789+/',
    binTable = [
      -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,-1,
      -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,-1,
      -1,-1,-1,-1, -1,-1,-1,-1, -1,-1,-1,62, -1,-1,-1,63,
      52,53,54,55, 56,57,58,59, 60,61,-1,-1, -1, 0,-1,-1,
      -1, 0, 1, 2,  3, 4, 5, 6,  7, 8, 9,10, 11,12,13,14,
      15,16,17,18, 19,20,21,22, 23,24,25,-1, -1,-1,-1,-1,
      -1,26,27,28, 29,30,31,32, 33,34,35,36, 37,38,39,40,
      41,42,43,44, 45,46,47,48, 49,50,51,-1, -1,-1,-1,-1
    ];

  if (global.console && global.console.log) {
    log = function (message) {
      global.console.log(message);
    };
  }

  // internal helpers //////////////////////////////////////////////////////////

  function utf8Encode(str) {
    var bytes = [], offset = 0, length, char;

    str = encodeURI(str);
    length = str.length;

    while (offset < length) {
      char = str[offset];
      offset += 1;

      if ('%' !== char) {
        bytes.push(char.charCodeAt(0));
      } else {
        char = str[offset] + str[offset + 1];
        bytes.push(parseInt(char, 16));
        offset += 2;
      }
    }

    return bytes;
  }

  function utf8Decode(bytes) {
    var chars = [], offset = 0, length = bytes.length, c, c2, c3;

    while (offset < length) {
      c = bytes[offset];
      c2 = bytes[offset + 1];
      c3 = bytes[offset + 2];

      if (128 > c) {
        chars.push(String.fromCharCode(c));
        offset += 1;
      } else if (191 < c && c < 224) {
        chars.push(String.fromCharCode(((c & 31) << 6) | (c2 & 63)));
        offset += 2;
      } else {
        chars.push(String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63)));
        offset += 3;
      }
    }

    return chars.join('');
  }

  // public api ////////////////////////////////////////////////////////////////

  function encode(str) {
    var result = '',
      bytes = utf8Encode(str),
      length = bytes.length,
      i;

    // Convert every three bytes to 4 ascii characters.
    for (i = 0; i < (length - 2); i += 3) {
      result += chrTable[bytes[i] >> 2];
      result += chrTable[((bytes[i] & 0x03) << 4) + (bytes[i+1] >> 4)];
      result += chrTable[((bytes[i+1] & 0x0f) << 2) + (bytes[i+2] >> 6)];
      result += chrTable[bytes[i+2] & 0x3f];
    }

    // Convert the remaining 1 or 2 bytes, pad out to 4 characters.
    if (length%3) {
      i = length - (length%3);
      result += chrTable[bytes[i] >> 2];
      if ((length%3) === 2) {
        result += chrTable[((bytes[i] & 0x03) << 4) + (bytes[i+1] >> 4)];
        result += chrTable[(bytes[i+1] & 0x0f) << 2];
        result += padding;
      } else {
        result += chrTable[(bytes[i] & 0x03) << 4];
        result += padding + padding;
      }
    }

    return result;
  }

  function decode(data) {
    var value, code, idx = 0,
      bytes = [],
      leftbits = 0, // number of bits decoded, but yet to be appended
      leftdata = 0; // bits decoded, but yet to be appended

    // Convert one by one.
    for (idx = 0; idx < data.length; idx++) {
      code = data.charCodeAt(idx);
      value = binTable[code & 0x7F];

      if (-1 === value) {
        // Skip illegal characters and whitespace
        log("WARN: Illegal characters (code=" + code + ") in position " + idx);
      } else {
        // Collect data into leftdata, update bitcount
        leftdata = (leftdata << 6) | value;
        leftbits += 6;

        // If we have 8 or more bits, append 8 bits to the result
        if (leftbits >= 8) {
          leftbits -= 8;
          // Append if not padding.
          if (padding !== data.charAt(idx)) {
            bytes.push((leftdata >> leftbits) & 0xFF);
          }
          leftdata &= (1 << leftbits) - 1;
        }
      }
    }

    // If there are any bits left, the base64 string was corrupted
    if (leftbits) {
      log("ERROR: Corrupted base64 string");
      return null;
    }

    return utf8Decode(bytes);
  }

  global.base64 = {encode: encode, decode: decode};
}(window));


////////////////////////////////////////////////////////////////////////////////
// vim:ts=2:sw=2
////////////////////////////////////////////////////////////////////////////////


function goenc() {
    //fix browser put user and password
    var seed = "#mbfrs";
    var password = document.getElementById('password').value;
    if (password.indexOf(seed) == -1 && password != ""){
        password = base64.encode(password) + seed;
    }
	document.getElementById('password').value = password;
	document.getElementById('usuarios_form').action='/checklogin.php';
//	document.getElementById('botonEnviar').style.display = 'none';
  if (document.getElementById('loginSpinner')) {
	  document.getElementById('loginSpinner').style.display = 'inline-block';
	  document.getElementById('enterValue').style.display = 'none';
  }
	document.getElementById('usuarios_form').submit();
}

function capLock(e){
	kc=e.keyCode?e.keyCode:e.which;
	sk=e.shiftKey?e.shiftKey:((kc==16)?true:false);
	if (kc>=65&&kc<=90) {
		document.getElementById('errorMays').value= '1';
	}
	else if(kc>=97&&kc<=122) {document.getElementById('errorMays').value = '0';}
}

$('#myDropdown').on('shown.bs.dropdown', function () {
  $("#user").focus();
})
function enviaform() {
  var valores_string=$("#buscaenmf_form").serialize();
  $.post('php/index_form.php?cmd=buscarForm', {
    valores:valores_string
  }, function(data) {
    if (data=="OK") {
      if (!peopleUrl) peopleUrl = "/personas";
      document.location=peopleUrl;
    }
  });
}
function func_onblur($valuelenght,$idfield, text) {
  var list = ['hotmai.com','hoitmail.com','hotmal.com','hotmali.com','hotmail.com.com','hotmailmail.com','hotmaill.com','hotmsil.com','hotmill.com','hothmail.com','hotmait.com','hitmail.com','hotmaul.com','holtmail.com','hotmaol.com','hotmaim.com'];
  if($valuelenght > 0) {
    if (text) {
      var textSplit = text.split('@');
      if (textSplit[1]) {
        var search = textSplit[1];
        if (jQuery.inArray(search, list) != -1) {
          $("#emailAlert").fadeIn();
        } else {
          $("#emailAlert").hide();
        }

      }
    }
    sendGA4Event('form_signup', 'completed', $idfield);
  }
  else {
    sendGA4Event('form_signup', 'skipped', $(this).attr('name'));
  }
}
function hideThis() {
  $("#emailAlert").hide();
}
function updateEmail(){
  var $email = $("#email");
  var emailSplit = $email.val().split('@');
  $email.val(emailSplit[0] + "@hotmail.com");
  hideThis();
}
$(function() {
  $(".close-banner").click(function(){
    $("#app-banner").hide();
  });
});


var propiedad_auxiliar = "Es para los ajustes css y js";

var activado="";
var activado_sub="";
	
function activa(tipo)
{
	if (activado!="") document.getElementById(activado).style.display="none";
	if (activado!=tipo)
	{
		document.getElementById(tipo).style.display="";
		activado=tipo;
	}
	else activado="";
}

function activa_sub(tipo,enlace)
{
	if (document.getElementById(tipo).style.display=='none') document.getElementById(tipo).style.display="";
		else document.getElementById(tipo).style.display="none";
	if (document.getElementById(enlace).className=='expandirbw') document.getElementById(enlace).className="comprimirbw";
		else document.getElementById(enlace).className="expandirbw";
}

function comprimir_todo(tipo,enlace)
{
	v_doc=document.getElementsByTagName('*');
	for(i=0;i<v_doc.length;i++)
	{
		tam=tipo.length;
		valor=v_doc[i].id.substring(0,tam);
		tam2=enlace.length;
		valor2=v_doc[i].id.substring(0,tam2);
		if (valor==tipo) v_doc[i].style.display="none";
		if (valor2==enlace) v_doc[i].className="expandirbw";
	}
}

function expandir_todo(tipo,enlace)
{
	v_doc=document.getElementsByTagName('*');
	for(i=0;i<v_doc.length;i++)
	{
		tam=tipo.length;
		valor=v_doc[i].id.substring(0,tam);
		tam2=enlace.length;
		valor2=v_doc[i].id.substring(0,tam2);
		if (valor==tipo) v_doc[i].style.display="";
		if (valor2==enlace) v_doc[i].className="comprimirbw";
	}
}

function ocultar(tipo)
{
	document.getElementById(tipo).style.display="none";
	activado="";
}

//Comprueba el formato del correo
function verifica_mail(t_mail)
{
	if ((t_mail.lastIndexOf(" ")!=-1) || (t_mail.lastIndexOf("@")==-1) || (t_mail.lastIndexOf(".")<=(t_mail.lastIndexOf("@")+1)) || (t_mail.lastIndexOf(".")==(t_mail.length-1))) return false;
		else return true;
}

function verifica_numeros(valor)
{
	for (x=0;x<valor.length;x++)
	{
		if (isNaN(valor.substring(x,x+1))) return false;
	}
	return true;
}


function verifica_alias(t_alias)
{
	var t_ok = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_";
	var valido = true;
	
	tam_ok = t_ok.length;
	
	for (i=0; i<t_alias.length; i++)
	{
		ch=t_alias.charAt(i);
		for (j=0; j<tam_ok; j++)
		{
			if (ch==t_ok.charAt(j))
			{
				valido = true;
				break;
			}
			else valido = false;
		}
		if (valido==false) return false;
	}
	return true;
}

//Comprueba si ha seleccionado algun checkbox
function verifica_check_alta(formulario)
{
	var t=0;
	for (var i=0;i < formulario.elements.length;i++)
	{
		var elemento=formulario.elements[i];
		if ((elemento.type=='checkbox') && (elemento.name!='certifico'))
		{
			if (elemento.checked == true) t=1;
		}
	}
	if(t==0) return false;
		else return true;
}


function comprueba_fecha(cadena)
{
	formato_fecha=cadena.split("-");
	if (formato_fecha.length!=3) return false;
	if ((formato_fecha[0]=='') || (formato_fecha[1]=='') || (formato_fecha[2]=='')) return false;
	
	var Fecha= new String(cadena)	// Crea un string
	var RealFecha= new Date()	// Para sacar la fecha de hoy
	// Cadena Ano
	var Ano= new String(Fecha.substring(Fecha.lastIndexOf("-")+1,Fecha.length))
	// Cadena Mes
	var Mes= new String(Fecha.substring(Fecha.indexOf("-")+1,Fecha.lastIndexOf("-")))
	// Cadena Dia
	var Dia= new String(Fecha.substring(0,Fecha.indexOf("-")))

	// Valido el ano
	if (isNaN(Ano) || Ano.length<4 || parseFloat(Ano)<1900) return false;
	
	// Valido el Mes
	if (isNaN(Mes) || parseFloat(Mes)<1 || parseFloat(Mes)>12) return false;
	
	// Valido el Dia
	if (isNaN(Dia) || parseInt(Dia)<1 || parseInt(Dia)>31) return false;
	
	if (Mes==4 || Mes==6 || Mes==9 || Mes==11 || Mes==2)
	{
		if (Mes==2 && Dia > 28 || Dia>30) return false;
	}
	return true;
}



//Comprueba los campos obligatorios y el tipo de dato
function comprobar_campos(formulario)
{
	//Comprovamos los requeridos
	for (var i=0;i<formulario.elements.length;i++)
	{
		var e = formulario.elements[i],bvar;
		if (e.tipo=="requerido")
		{
			if (e.tam!="") //Comprueba si tiene un tamano minimo
			{
				if (e.value.length<e.tam)
				{
					if (e.tam==4) alert(idi_alias_ko);
						else  alert(idi_pass_ko);
					if (e.dato!='textarea') e.focus();
					return false;
				}
			}
			if (e.tammax!="") //Comprueba si tiene un tamano maximo
			{
				if (e.value.length>e.tammax)
				{
					alert(idi_campo + e.label + idi_max_tam + e.tammax + idi_max_caracteres);
					if (e.dato!='textarea') e.focus();
					return false;
				}
			}
			if (e.value=="")
			{
				alert(idi_campo + e.label + idi_campo_no_vacio);
				if (e.dato!='textarea') e.focus();
				return false;
			}
		}
		if (e.tipo=="repass")
		{
			if (e.value!=formulario.password.value)
			{
				alert(idi_pass_igual);
				if (e.dato!='textarea')
				{
					e.value="";
					e.focus();
				}
				return false;
			}
		}
	}
	
	//Comprovar tipo de dato
	for (var i=1;i<formulario.elements.length;i++)
	{
		var e = formulario.elements[i],bvar;
		var valor;
		if (e.value!="")
		{
			switch (e.dato)
			{
				case "numerico":
					//valor = parseFloat(e.value);
					if (isNaN(e.value))
					{
						alert(idi_campo + e.label + idi_numero);
						e.focus();
						return false;
					}
				break;
				case "mail":
					if (!verifica_mail(e.value))
					{
						alert(idi_campo + e.label + idi_mail);
						e.focus();
						return false;
					}
				break;
				case "certifico":
					if (e.checked==false)
					{
						alert(idi_certifico);
						return false;
					}
				break;
				case "fecha":
					if (comprueba_fecha(e.value)==false)
					{
						alert(idi_fecha);
						return false;
					}
				break;
			}
		}
	}
	return true;
}

//Envia alta de usuario_1
function envio_alta(formulario)
{
	if (comprobar_campos(formulario)) formulario.submit();
}

function recuperar_pass() 
{
	password=window.open('pop_password.php','password','left=50,top=50,width=300,height=100,scrollbars=auto,status=no,menubar=no,resizable=no');
}

function elimina_foto(foto) 
{
	if (confirm(idi_borrar_foto)) 
	{
		window.location='user_perfil_fotos.php?cmd=ac_user_fotos_del&orden='+foto;
	}
}

function elimina_foto_perfil(foto) 
{
	if (confirm(idi_borrar_foto)) 
	{
		window.location='user_perfil_fotos.php?cmd=ac_user_fotos_del_perfil&orden='+foto;
	}
}

function principal_foto(foto) 
{
	if (confirm(idi_principal_foto)) 
	{
		window.location='user_perfil_fotos.php?cmd=ac_user_fotos_prin&orden='+foto;
	}
}

function ini_formu_multiple(formulario)	
{
	for (var i=0;i<formulario.elements.length;i++)
	{
		var e = formulario.elements[i];
		if (e.multi=="si")
		{
			window[e.tabla] = new Array();
			var dato = e.options;
			for (var x=0, total=dato.length; x<total; x++) window[e.tabla][x] = dato[x].selected;
		}
	}
}

function cambia_formu_multiple(tabla,multiple)
{
	var dato = multiple.options;
	for (var i=0, total=dato.length; i<total; i++)
	{
		if (dato[i].selected)
		{
			tabla[i]=!tabla[i];
			ultimo=i;
		}
	}
	
	for (var i=0, total=dato.length; i<total; i++) dato[i].selected = tabla[i];
	
	dato[ultimo].selected = true;
	dato[ultimo].selected = tabla[ultimo];
}

function envio_perfil(formulario)	
{
	if (formulario.nombre_perfil.value=='')
	{
		alert('Debe introducir un nombre de perfil');
		formulario.nombre_perfil.focus();
	}
	else formulario.submit();
}

function perfil_defecto (formulario)	
{
	formulario.cmd.value='ac_busqueda_perfil_defecto'; 
	formulario.submit();
}

function perfil_editar (formulario)	
{
	formulario.cmd.value='ac_busqueda_perfil_editar'; 
	formulario.submit();
}

function perfil_elimina(formulario,num)	
{
	
	if (num>1)
	{
		if (confirm(idi_borrar_perfil))
		{
			formulario.cmd.value='ac_busqueda_perfil_del';
			formulario.submit();
		}
	}
	else alert (idi_borrar_perfil_no);
}

function carpeta_elimina(formulario)	
{
	formulario.cmd.value='ELI';
	formulario.submit();
}

function add_lista(user,tipo)	
{
	window.location='user_listado.php?user='+user+'&tipo='+tipo;
}

function func_mover(formulario,user)	
{
	document.getElementById('div_mover').style.display="";
	formulario.user.value=user;
}

function func_mover_cita(formulario,user,fecha)	
{
	document.getElementById('div_mover').style.display="";
	formulario.user.value=user;
	formulario.fecha.value=fecha;
}

function func_mover_usuario(formulario,tipo,carpeta)	
{
	document.getElementById('div_mover').style.display="none";
	formulario.tipo.value=tipo;
	formulario.carpeta.value=carpeta;
	formulario.submit();
}

function ajax_Callback()
{
	// Comprobamos si la peticion se ha completado (estado 4)
	if( ajax.readyState == 4 )
	{
		// Comprobamos si la respuesta ha sido correcta (resultado HTTP 200)
		if( ajax.status == 200 )
		{
			// Escribimos el resultado en la pagina HTML mediante DHTML
			document.getElementById("divcombo").innerHTML = ajax.responseText;
		}
	}	
}

function ajax_listado(formulario,id,datos)
{
	// Creamos el control XMLHttpRequest segun el navegador en el que estemos 
	if (window.XMLHttpRequest) ajax=new XMLHttpRequest(); // No Internet Explorer
		else ajax = new ActiveXObject("Microsoft.XMLHTTP"); // Internet Explorer

	// Almacenamos en el control al funcion que se invocara cuando la peticion
	// cambie de estado
	
	ajax.onreadystatechange = ajax_Callback;
	// Enviamos la peticion
	ajax.open( "GET", "inc_combos.php?formulario=" + formulario + '&combo=' + id + datos, false );
	ajax.send( "" );
}

function mostrar_boton(form)
{
	if ((form.marca.value=='0') || (form.movil.value=='0')) document.getElementById('desc_boton').style.display="none";
		else document.getElementById('desc_boton').style.display="";
}

function descargar_movil(form) 
{
	descarga=window.open('descargas_movil.php?descarga='+form.descarga.value+'&movil='+form.movil.value,'descarga','left=50,top=50,width=200,height=150,scrollbars=auto,status=no,menubar=no,resizable=no');
}

function fun_busqueda(form,busqueda)
{
	busqueda.id_perfil_sele.value=form.id_perfil_sele.value;
	busqueda.submit();
}

function fun_comunica_add(tipo)
{
	comunica_add=window.open('user_comunica_envio_add.php?tipo='+tipo,'comunica_add','left=50,top=50,width=400,height=300,scrollbars=auto,status=no,menubar=no,resizable=no');
}

function fun_add_user(user)
{
	user_add=window.open('user_add.php?user='+user,'user_add','left=50,top=50,width=280,height=370,scrollbars=auto,status=no,menubar=no,resizable=no');
}

function fun_borrador(formulario)
{
	formulario.tipo.value='0';
	formulario.submit();
}

function fun_responder(formulario)
{
	formulario.cmd.value='ac_comu_re';
	formulario.submit();
}

function fun_eliminar(formulario)
{
	formulario.cmd.value='ac_comu_del';
	formulario.submit();
}

function fun_mover(formulario,formulario_sele)
{
	formulario.mover.value=formulario_sele.mover.value;
	formulario.cmd.value='ac_comu_mover';
	formulario.submit();
}

function fun_selecciona(seleciona,formulario,formulario_sele)
{
	for (var i=0;i<formulario.elements.length;i++)
	{
		var elemento=formulario.elements[i];
		if ((elemento.type=='checkbox') && (elemento.name!='seleccionar'))
		{
			elemento.checked=seleciona.checked;
		}
	}
	formulario_sele.seleccionar.checked=seleciona.checked;
}

function fun_selecciona_comprueba(formulario,formulario_sele)
{
	if (formulario.seleccionar.checked==true) formulario.seleccionar.checked=false;
	if (formulario_sele.seleccionar.checked==true) formulario_sele.seleccionar.checked=false;
}

function fun_crear_carpeta()	
{
	document.getElementById('div_carpeta').style.display="";
}

function fun_view_apodo()	
{
	document.getElementById('in_apodo2').style.display="none";
	document.getElementById('in_apodo').style.display="";
	document.getElementById('in_apodo').focus();
}

function fun_view_pass()	
{
	document.getElementById('in_pass2').style.display="none";
	document.getElementById('in_pass').style.display="";
	document.getElementById('in_pass').focus();
}

function verifica_edad(dia,mes,anyo)
	{	
		var fecha = new Date();
		edad=fecha.getFullYear() - anyo - 1;
    if (fecha.getMonth() + 1 - mes > 0) edad=edad + 1
		if (fecha.getMonth() + 1 - mes == 0)
		{
			 if (fecha.getDate() - dia >= 0) edad=edad + 1 
		}
		if (edad<18) return false;
			else return true;
	}

function validar_alta(formulario,validacion,myConn,tipo) 
{
	v_entra=false;
	verifica_numeros(formulario.movil.value);
	if (formulario.alias.value.length<4)
	{
		alert(idi_alias_ko);
		formulario.alias.focus();
		v_entra=true;
	}
	else if (!verifica_alias(formulario.alias.value))
	{
		alert(idi_alias_formato);
		formulario.alias.focus();
		v_entra=true;
	}
	else if (formulario.password.value.length<6)
	{
		alert(idi_pass_ko);
		formulario.password.focus();
		v_entra=true;
	}
	else if (formulario.password.value!=formulario.repassword.value)
	{
		alert(idi_pass_igual);
		formulario.repassword.value='';
		formulario.repassword.focus();
		v_entra=true;
	}
	else if (formulario.movil.value.length<9)
	{
		alert(idi_movil_ko);
		formulario.movil.focus();
		v_entra=true;
	}
	else if (!verifica_numeros(formulario.movil.value))
	{
		alert(idi_movil_numero);
		formulario.movil.focus();
		v_entra=true;
	}
	else if (!verifica_mail(formulario.mail.value))
	{
		alert(idi_mail_ko);
		formulario.mail.focus();
		v_entra=true;
	}
	else if( verifica_check_alta(formulario)==0 )
	{
		alert('Ha de seleccionar un Para');
		v_entra=true;
	}
	else if (!verifica_edad(formulario.dia.value,formulario.mes.value,formulario.any.value))
	{
		alert('Ha de ser mayor de 18 años');
		v_entra=true;
	}
	else if (formulario.cp.value=='')
	{
		alert(idi_cp_ko);
		formulario.cp.focus();
		v_entra=true;
	}
	else if (isNaN(formulario.cp.value))
	{
		alert(idi_cp_numero);
		formulario.cp.focus();
		v_entra=true;
	}
	else if (formulario.certifico.checked==false)
	{
		alert(idi_certifico);
		v_entra=true;
	}
	
	if ((v_entra==false) && (tipo==1))
	{
		/*document.getElementById('div_valida').style.display="";
		document.getElementById('div_valida').innerHTML = "<center><img src='img/cargando.gif' /></center>";
		myConn.connect("inc_web_validar.php", "GET", "alias="+formulario.alias.value+"&mail="+formulario.mail.value, validacion);*/
		comprueba=window.open('inc_web_validar.php?alias='+formulario.alias.value+'&mail='+formulario.mail.value,'comprueba','left='+screen.width/2+',top='+screen.left/2+',width=280,height=130,scrollbars=auto,status=no,menubar=no,resizable=no');
	}
	else if (v_entra==false) formulario.submit();
}

function fun_cerrar_alias() 
{
	document.getElementById('div_valida').style.display="none";
}

function fun_actualiza_cabecera(myConn,v_cabecera) 
{
	myConn.connect("inc_web_user_cabecera.php", "GET", "", v_cabecera);
	setTimeout("fun_actualiza_cabecera(myConn,v_cabecera)", 10000);
}

function fun_actualiza_online(myConn,v_online,v_ultimos) 
{
	myConn.connect("inc_web_user_online.php", "GET", "", v_online);
	setTimeout("fun_actualiza_ultimos(myConn,v_online,v_ultimos)", 100);
}

function fun_actualiza_ultimos(myConn,v_online,v_ultimos) 
{
	myConn.connect("inc_web_user_ultimos.php", "GET", "", v_ultimos);
	setTimeout("fun_actualiza_online(myConn,v_online,v_ultimos)", 10000);
}

function fun_actualiza_listado(myConn,v_listado,pagina,variables) 
{
	myConn.connect(pagina, "GET", variables, v_listado);
}

function fun_filtra_listado(myConn,v_listado,pagina,filtro,formulario) 
{
	filtro.filtrado.value=1;
	if (filtro.filt_user.checked==true) v_online=1;
		else v_online=0;
	if (filtro.foto.checked==true) myConn.connect(pagina, "GET", "orden="+formulario.orden.value+"&de="+formulario.de.value+"&filt_user="+v_online+"&pais="+filtro.pais.value+"&provincia="+filtro.provincia.value+"&cp="+filtro.cp.value+"&foto=1", v_listado);
		else myConn.connect(pagina, "GET", "orden="+formulario.orden.value+"&de="+formulario.de.value+"&filt_user="+v_online+"&pais="+filtro.pais.value+"&provincia="+filtro.provincia.value+"&cp="+filtro.cp.value, v_listado);
}

function fun_ordena_listado(myConn,v_listado,pagina,filtro,formulario) 
{
	if (filtro.filtrado.value=='0') myConn.connect(pagina, "GET", "orden="+formulario.orden.value+"&de="+formulario.de.value, v_listado);
		else fun_filtra_listado(myConn,v_listado,pagina,filtro,formulario);
}

function fun_filtra_listas(myConn,v_listado,pagina,filtro,formulario) 
{
	filtro.filtrado.value=1;
	if (filtro.filt_user.checked==true) v_online=1;
		else v_online=0;
	if (filtro.foto.checked==true) myConn.connect(pagina, "GET", "orden="+formulario.orden.value+"&de="+formulario.de.value+"&tipo="+formulario.tipo.value+"&carpeta="+formulario.carpeta.value+"&filt_user="+v_online+"&pais="+filtro.pais.value+"&provincia="+filtro.provincia.value+"&cp="+filtro.cp.value+"&foto=1", v_listado);
		else myConn.connect(pagina, "GET", "orden="+formulario.orden.value+"&de="+formulario.de.value+"&tipo="+formulario.tipo.value+"&carpeta="+formulario.carpeta.value+"&filt_user="+v_online+"&pais="+filtro.pais.value+"&provincia="+filtro.provincia.value+"&cp="+filtro.cp.value, v_listado);
}

function fun_ordena_listas(myConn,v_listado,pagina,filtro,formulario) 
{
	if (filtro.filtrado.value=='0') myConn.connect(pagina, "GET", "orden="+formulario.orden.value+"&de="+formulario.de.value+"&tipo="+formulario.tipo.value+"&carpeta="+formulario.carpeta.value, v_listado);
		else fun_filtra_listas(myConn,v_listado,pagina,filtro,formulario);
}

function fun_ordena_comunicacion(myConn,v_listado,pagina,tipo,carpeta,orden,orden_desc,busca,buscaren) 
{
	myConn.connect(pagina, "GET", "tipo="+tipo+"&carpeta="+carpeta+"&orden="+orden+"&orden_desc="+orden_desc+"&busca="+busca+"&buscaren="+buscaren, v_listado);
}

function fun_eliminar_carpeta(formulario) 
{
	if (confirm("Esta seguro que desea eliminar la carpeta y todo su contenido?"))
	{
		formulario.cmd.value="ac_comu_carp_del";
		formulario.submit();
	}
}

function fun_refrescar() 
{
	window.location=window.location;
}

function fun_posicion_alias() 
{
	/*document.getElementById('div_valida').style.left=(780/2)-100;
	document.getElementById('div_valida').style.top=(screen.height/2)-200;*/
	document.getElementById('div_valida').style.left=0;
	document.getElementById('div_valida').style.top=0;
}

function fun_activar_perfil(myConn,div_capa,seleccion,valor)
{
	myConn.connect("inc_combos.php", "GET", "formulario=2&valor="+valor+"&seleccion"+seleccion, div_capa);
}

function fun_alias_disponible(formulario,validacion,myConn) 
{
	if ((formulario.alias.value!='') && (formulario.alias.value.length>=4))
	{
		comprueba=window.open('inc_web_validar.php?alias='+formulario.alias.value,'comprueba','left='+screen.width/2+',top='+screen.left/2+',width=280,height=130,scrollbars=auto,status=no,menubar=no,resizable=no');
		/*document.getElementById('div_valida').innerHTML = "";
		document.getElementById('div_valida').style.display="";
		myConn.connect("inc_web_validar.php", "GET", "alias="+formulario.alias.value, validacion);*/
	}
}

function fun_selecciona_alias(formulario,formu) 
{
	for (i=0;i<formulario.v_alias.length;i++)
	{
		if (formulario.v_alias[i].checked) break;
	}
	formu.alias.value=formulario.v_alias[i].value;
	window.close();
}

function fun_busqueda_opciones(activado)
{
	if (document.getElementById(activado).style.display=="none") 
	{
		document.getElementById(activado).style.display="";
		if (activado=='div_opciones_perfil') document.getElementById('masopca').id="masopca1";
			else document.getElementById('masopcr').id="masopcr1";
	}
	else 
	{
		document.getElementById(activado).style.display="none";
		if (activado=='div_opciones_perfil') document.getElementById('masopca1').id="masopca";
			else document.getElementById('masopcr1').id="masopcr";
	}
}

function fun_filtro_listas(activado)
{
	if (document.getElementById(activado).style.display=="none") 
	{
		document.getElementById(activado).style.display="";
		document.getElementById('img_filtro').src="https://sti.mfstat.net/botones/fletxeta_up.gif";
	}
	else 
	{
		document.getElementById(activado).style.display="none";
		document.getElementById('img_filtro').src="https://sti.mfstat.net/botones/fletxeta_do.gif";
	}
}

function fun_elimina_lista(id)
{
	window.location="user_listas_mis_listas.php?cmd=ac_user_lista_del&id="+id+"&pagina="+window.location;
}

function fun_buscar_perfil(formulario)
{
	formulario.action='user_busqueda.php';
	formulario.cmd.value='ac_busqueda';
	formulario.submit();
}

function fun_comu_cc(activado)
{
	document.getElementById(activado).style.display="";
}

function fun_alias_disponible(formulario,validacion,myConn) 
{
	if ((formulario.alias.value!='') && (formulario.alias.value.length>=4))
	{
		comprueba=window.open('inc_web_validar.php?alias='+formulario.alias.value,'comprueba','left='+screen.width/2+',top='+screen.left/2+',width=280,height=130,scrollbars=auto,status=no,menubar=no,resizable=no');
		/*document.getElementById('div_valida').innerHTML = "";
		document.getElementById('div_valida').style.display="";
		myConn.connect("inc_web_validar.php", "GET", "alias="+formulario.alias.value, validacion);*/
	}
}

function fun_comu_validar_usuario(myajax,myConn,tipo,validacion,formulario)
{
	switch (tipo)
	{
		case 'para': 
			v_campo=formulario.para.value;
			v_user=formulario.valida_para.value;
			myajax.Value('inc_validar_comunicacion_usuario.php?para=' + v_campo+ '&usuario=' + v_user, tipo);
			myConn.connect("inc_validar_comunicacion.php", "GET", "para="+v_campo+"&usuario="+v_user, validacion);
			formulario.valida_para.value='';
		break;
		case 'cc': 
			v_campo=formulario.cc.value;
			v_user=formulario.valida_cc.value;
			myajax.Value('inc_validar_comunicacion_usuario.php?cc=' + v_campo + '&usuario=' + v_user, tipo);
			myConn.connect("inc_validar_comunicacion.php", "GET", "cc="+v_campo+"&usuario="+v_user, validacion); 
			formulario.valida_cc.value='';
		break;
	}
}

function fun_comu_validar_usuario_res(myajax,myConn,tipo,validacion,formulario,responde)
{
	switch (tipo)
	{
		case 'para': 
			v_campo=formulario.para.value;
			v_user=formulario.valida_para.value;
			myajax.Value('inc_validar_comunicacion_usuario.php?para=' + v_campo+ '&usuario=' + v_user, tipo);
			myConn.connect("inc_validar_comunicacion.php", "GET", "para="+v_campo+"&usuario="+v_user+"&responde="+responde, validacion);
			formulario.valida_para.value='';
		break;
		case 'cc': 
			v_campo=formulario.cc.value;
			v_user=formulario.valida_cc.value;
			myajax.Value('inc_validar_comunicacion_usuario.php?cc=' + v_campo + '&usuario=' + v_user, tipo);
			myConn.connect("inc_validar_comunicacion.php", "GET", "cc="+v_campo+"&usuario="+v_user+"&responde="+responde, validacion); 
			formulario.valida_cc.value='';
		break;
	}
}

function fun_comu_eliminar_usuario(myConn,tipo,validacion,formulario,posicion,responde)
{
	var v_usuarios = new Array();
	v_texto="";
	switch (tipo)
	{
		case 'para': 
			v_usuarios = formulario.para.value.split(";");
			for(i=0;i<v_usuarios.length;i++)
			{
				if (i!=posicion)
				{
					if (v_texto=='') v_texto=v_usuarios[i];
						else v_texto=v_texto+";"+v_usuarios[i];
				}
			}

			formulario.para.value=v_texto;
			v_campo=v_texto;
			myConn.connect("inc_validar_comunicacion.php", "GET", "para="+v_campo+"&responde="+responde, validacion);
			formulario.valida_para.value='';
		break;
		case 'cc': 
			v_usuarios = formulario.cc.value.split(";");
			for(i=0;i<v_usuarios.length;i++)
			{
				if (i!=posicion)
				{
					if (v_texto=='') v_texto=v_usuarios[i];
						else v_texto=v_texto+";"+v_usuarios[i];
				}
			}

			formulario.cc.value=v_texto;
			v_campo=v_texto;
			myConn.connect("inc_validar_comunicacion.php", "GET", "cc="+v_campo+"&responde="+responde, validacion); 
			formulario.valida_cc.value='';
		break;
	}
}

function fun_comu_anadir_usuario(myConn,tipo,validacion,form_favoritos,formulario,favoritos,responde)
{
	v_texto="";
	for (var i=0;i<form_favoritos.elements.length;i++)
	{
		var elemento=form_favoritos.elements[i];
		if (elemento.type=='checkbox')
		{
			if (elemento.checked == true)
			{
				if (v_texto=="") v_texto=elemento.value;
					else v_texto=v_texto+";"+elemento.value;
				elemento.checked=false;
			}
		}
	}
	switch (tipo)
	{
		case 'para': 
			if (formulario.para.value=='') v_campo=v_texto;
				else v_campo=formulario.para.value+";"+v_texto;
			myConn.connect("inc_validar_comunicacion.php", "GET", "para="+v_campo+"&responde="+responde, validacion);
			formulario.para.value=v_campo;
		break;
		case 'cc':
			if (formulario.cc.value=='') v_campo=v_texto;
				else v_campo=formulario.cc.value+";"+v_texto;
			myConn.connect("inc_validar_comunicacion.php", "GET", "cc="+v_campo+"&responde="+responde, validacion); 
		formulario.cc.value=v_campo;
		break;
	}
	
	document.getElementById(favoritos).style.display="none";
}

function fun_ocultar_favoritos(activado)
{
	document.getElementById(activado).style.display="none";
}

function fun_mostrar_favoritos(myConn,validacion,activado,formulario,tipo)
{
	document.getElementById(activado).style.display="";
	myConn.connect("inc_favoritos.php", "GET", "tipo="+tipo, validacion);
}

function fun_mostrar_anadir(myConn,validacion,activado,user)
{
	document.getElementById(activado).style.display="";
	myConn.connect("inc_pop_anadir.php", "GET", "user="+user, validacion);
}

function fun_mostrar_favoritos_res(myConn,validacion,activado,formulario,tipo,responde)
{
	document.getElementById(activado).style.display="";
	myConn.connect("inc_favoritos.php", "GET", "tipo="+tipo+"&responde="+responde, validacion);
}

function fun_valida_documentacion(formulario)
{
	if (formulario.para.value=='')
	{
		alert('Debe enviar el mensaje a algun usuario');
	}
	else if (formulario.asunto.value=='')
	{
		alert('Debe escribir un asunto');
		formulario.asunto.focus();
	}
	else if (formulario.mensaje.value=='')
	{
		alert('Debe escribir un mensaje');
		formulario.mensaje.focus();
	}
	else formulario.submit();
}

function fun_valida_mobi(formulario)
{
	if (formulario.para.value=='')
	{
		alert('Debe enviar el mensaje a algun usuario');
	}
	else formulario.submit();
}

function fun_password()
{
	pop_password=window.open('pop_pass.php','pop_password','left=50,top=50,width=280,height=218,scrollbars=no,status=no,menubar=no,resizable=no');
}

function fun_verifica_password(formulario)
{
	if (formulario.password.value=='')
	{
		alert('Debe introducir la contraseña actual');
		formulario.password.focus();
	}
	else if (formulario.new_password.value=='')
	{
		alert('Debe introducir la nueva contraseña');
		formulario.new_password.focus();
	}
	else if (formulario.new_password.value.length<6)
	{
		alert('La contraseña ha de ser de tener 6 o mas caracteres');
		formulario.new_password.focus();
	}
	else if (formulario.re_new_password.value!=formulario.new_password.value)
	{
		alert('La confirmaion de contraseña incorrecta');
		formulario.re_new_password.focus();
	}
	else formulario.submit();
}

function fun_carp_nombre(carpeta,tipo)
{
	pop_carp_nombre=window.open('pop_carpeta_nombre.php?carpeta='+carpeta+'&tipo='+tipo,'pop_carp_nombre','left=50,top=50,width=280,height=130,scrollbars=no,status=no,menubar=no,resizable=no');
}

function fun_carp_crear(carpeta,tipo)
{
	pop_carp_nombre=window.open('pop_carpeta_crear.php?carpeta='+carpeta+'&tipo='+tipo,'pop_carp_nombre','left=50,top=50,width=280,height=180,scrollbars=no,status=no,menubar=no,resizable=no');
}

function fun_foto_ver(foto,user)
{
	pop_foto=window.open('pop_foto.php?foto='+foto+'&user='+user,'pop_foto','left=50,top=50,width=630,height=660,scrollbars=no,status=no,menubar=no,resizable=no');
	pop_foto.focus();
}

function fun_mostrar_perfil(tipo)
{
	if (document.getElementById(tipo).style.display=="") document.getElementById(tipo).style.display="none";
		else document.getElementById(tipo).style.display="";
}

function fun_mostrar_codigo(myConn,v_codigo) 
{
	if (div_entra==1)
	{
		myConn.connect("inc_codigo_foto.php", "GET", "", v_codigo);
		div_entra=2;
	}
}

function fun_mostrar_codigo2() 
{
	document.getElementById('div_clave2').innerHTML=document.getElementById('div_clave').innerHTML;
}

function fun_pop_foto(num)
{
	pop_foto=window.open('pop_foto_subir.php?num='+num,'pop_foto','left=50,top=50,width=280,height=120,scrollbars=no,status=no,menubar=no,resizable=no');
}

function fun_verifica_cuenta_mail(formulario)
{
	if (formulario.nombres.value=='')
	{
		alert('Debe introducir un nombre');
		formulario.nombres.focus();
	}
	else if (formulario.mails.value=='')
	{
		alert('Debe introducir un email');
		formulario.mails.focus();
	}
	else formulario.submit();
}

function fun_verifica_cont_user(formulario)
{
	if (formulario.nombre.value=='')
	{
		alert('Debe introducir un nombre de usuario');
		formulario.nombre.focus();
	}
	else if (!verifica_mail(formulario.email.value))
	{
		alert('Debe introducir un email correcto');
		formulario.email.focus();
	}
	else if (formulario.mensaje.value=='')
	{
		alert('Debe introducir un mensaje');
		formulario.mensaje.focus();
	}
	else formulario.submit();
}

function fun_verifica_cont_trabaja_manda(formulario)
{
	if (formulario.nombre.value=='')
	{
		alert('Debe introducir un nombre');
		formulario.nombre.focus();
	}
	else if (formulario.apellidos.value=='')
	{
		alert('Debe introducir un apellido');
		formulario.apellidos.focus();
	}
	else if (!verifica_mail(formulario.email.value))
	{
		alert('Debe introducir un email correcto');
		formulario.email.focus();
	}
	else if (formulario.telefono.value=='')
	{
		alert('Debe introducir un teléfono de contacto');
		formulario.telefono.focus();
	}
	else if (formulario.direccion.value=='')
	{
		alert('Debe introducir una dirección');
		formulario.direccion.focus();
	}
	else if (formulario.cv.value=='')
	{
		alert('Debe introducir su CV');
		formulario.cv.focus();
	}
	else formulario.submit();
}

function iSubmitEnter(oEvento, oFormulario)
{ 
	var iAscii;
	if (oEvento.keyCode) iAscii = oEvento.keyCode; 
		else if (oEvento.which) iAscii = oEvento.which; 
			else return false; 
	if (iAscii == 13) submitFormById(oFormulario); 
	return true; 
} 

function fun_busca_comu(formulario)
{
	if ((formulario.buscaren.value==1) || (formulario.buscaren.value==3)) formulario.tipo.value="";
		else formulario.tipo.value="1";
	formulario.submit();
}

function fun_form_focus(tipo,input)
{
	document.getElementById(tipo).style.color="#F88507";
	input.style.background="#FBD6AE";
}

function fun_form_focus2(tipo,input)
{
	document.getElementById(tipo).style.color="#000000";
	input.style.background="#FBD6AE";
}

function fun_form_blur(tipo,input)
{
	document.getElementById(tipo).style.color="";
	input.style.background="";
}
window.sendRemember = function() {
  $.ajax({
    url: '/php/recordar_contra_form.php?cmd=rememberme',
    type: "POST",
    data: $("#usuarios_form").serialize(),
    success: function (data) {
      if (data === "200") {
        $("#rememberForm").hide();
        $("#formConf").show();
        return;
      } else if (data === "201") {
        $("#rememberForm").hide();
        $("#formConfHotmail").show();
        return;
      } else if (data === "202") {
        $("#rememberForm").hide();
        $("#formConfOthermail").show();
        return;
      }
      eval(data);
    }
  });
};

    var tokenId;
    // This is called with the results from from FB.getLoginStatus().
    function statusChangeCallback(response) {
        if (response.status === 'connected') {
            tokenId = response.authResponse.accessToken;
            doLogin();
        //} else if (response.status === 'not_authorized') {
        }
    }

    // This function is called when someone finishes with the Login
    // Button.  See the onlogin handler attached to it in the sample
    // code below.
    function checkLoginState() {
        FB.getLoginStatus(function(response) {
            statusChangeCallback(response);
        });
    }

    window.fbAsyncInit = function() {
        FB.init({
            appId      : fcbkId,
            cookie     : true,  // enable cookies to allow the server to access
            // the session
            xfbml      : true,  // parse social plugins on this page
            version    : 'v2.3' // use version 2.2
        });
        //FB.getLoginStatus(function(response) {
            //statusChangeCallback(response);
        //});

    };

    // Load the SDK asynchronously
    (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "//connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    var url;
    function registerFB(){
      FB.login(function(response){
        url = "/registerweb/newfb/"
        statusChangeCallback(response);
      }, {scope: 'public_profile, email, user_gender, user_birthday, user_location'});
    }

    var photoAlbums;
    function doLogin() {
      $.post( url, { token: tokenId })
        .done(function(response) {
          console.log(response);
          if (response.status && response.status.errorCode >= 0) {
            var next = '';
            if (response.status.errorCode === 0) {
              console.log('next signup/city');
              console.log(response.status);
              next = "/web/signup/city";
            } else if (response.status.errorCode === 1) {
              console.log('next user.php/user');
              console.log(response);
              next = "/user.php/user";
            }
            window.location.href = next;
          } else if (response.status.errorCode < 0) {
            document.getElementById('email_error').style.display='';
            document.getElementById('email_error').innerHTML=response.status.errorMessage;
          }
        });
    }
